//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import dayjs, { PluginFunc } from "dayjs";
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export class BookingClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getBookingsByCustomerId(
    customerAccountId: number,
    from: dayjs.Dayjs,
    to: dayjs.Dayjs,
    cancelToken?: CancelToken
  ): Promise<BookingHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{CustomerAccountId}/from/{From}/to/{To}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    if (from === undefined || from === null) throw new globalThis.Error("The parameter 'from' must be defined.");
    url_ = url_.replace("{From}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
    if (to === undefined || to === null) throw new globalThis.Error("The parameter 'to' must be defined.");
    url_ = url_.replace("{To}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBookingsByCustomerId(_response);
      });
  }

  protected processGetBookingsByCustomerId(response: AxiosResponse): Promise<BookingHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingHttpResponse[]>(null as any);
  }

  getBookingsByBookingIds(
    customerAccountId: number,
    bookingIds: string[] | undefined,
    cancelToken?: CancelToken
  ): Promise<BookingHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{CustomerAccountId}?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingIds === null) throw new globalThis.Error("The parameter 'bookingIds' cannot be null.");
    else if (bookingIds !== undefined)
      bookingIds &&
        bookingIds.forEach((item) => {
          url_ += "BookingIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBookingsByBookingIds(_response);
      });
  }

  protected processGetBookingsByBookingIds(response: AxiosResponse): Promise<BookingHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingHttpResponse[]>(null as any);
  }

  createCasualBookings(
    customerAccountId: number,
    httpRequest: CreateCasualBookingsHttpRequest,
    cancelToken?: CancelToken
  ): Promise<string | null> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/casual";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCasualBookings(_response);
      });
  }

  protected processCreateCasualBookings(response: AxiosResponse): Promise<string | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string | null>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string | null>(null as any);
  }

  getCreateCasualBookingsPreview(
    customerAccountId: number,
    httpRequest: GetCreateCasualBookingsPreviewHttpRequest,
    cancelToken?: CancelToken
  ): Promise<GetCreateCasualBookingsPreviewHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/casual/preview";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCreateCasualBookingsPreview(_response);
      });
  }

  protected processGetCreateCasualBookingsPreview(
    response: AxiosResponse
  ): Promise<GetCreateCasualBookingsPreviewHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetCreateCasualBookingsPreviewHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetCreateCasualBookingsPreviewHttpResponse>(result200);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCreateCasualBookingsPreviewHttpResponse>(null as any);
  }

  createRecurringBookings(
    customerAccountId: number,
    httpRequest: CreateRecurringBookingsHttpRequest,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/recurring";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRecurringBookings(_response);
      });
  }

  protected processCreateRecurringBookings(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = null as any;
      }
      return Promise.resolve<string[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
  }

  createRecurringBookingsForAllAvailableDates(
    customerAccountId: number,
    httpRequest: CreateRecurringBookingsForAllAvailableDatesHttpRequest,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/recurring/all-dates";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRecurringBookingsForAllAvailableDates(_response);
      });
  }

  protected processCreateRecurringBookingsForAllAvailableDates(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = null as any;
      }
      return Promise.resolve<string[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
  }

  createRecurringBookingsForAllAvailableDatesIgnoreClosedToPublic(
    customerAccountId: number,
    httpRequest: CreateRecurringBookingsForAllAvailableDatesHttpRequest,
    cancelToken?: CancelToken
  ): Promise<string[]> {
    let url_ =
      this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/recurring/all-dates/ignore-closed-to-public";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRecurringBookingsForAllAvailableDatesIgnoreClosedToPublic(_response);
      });
  }

  protected processCreateRecurringBookingsForAllAvailableDatesIgnoreClosedToPublic(
    response: AxiosResponse
  ): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = null as any;
      }
      return Promise.resolve<string[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
  }

  getCreateRecurringBookingsPreview(
    customerAccountId: number,
    httpRequest: CreateRecurringBookingsHttpRequest,
    cancelToken?: CancelToken
  ): Promise<GetCreateRecurringBookingsPreviewHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/recurring/preview";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCreateRecurringBookingsPreview(_response);
      });
  }

  protected processGetCreateRecurringBookingsPreview(
    response: AxiosResponse
  ): Promise<GetCreateRecurringBookingsPreviewHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetCreateRecurringBookingsPreviewHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetCreateRecurringBookingsPreviewHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCreateRecurringBookingsPreviewHttpResponse>(null as any);
  }

  changeRecurringBooking(
    customerAccountId: number,
    scheduleId: string,
    httpRequest: ChangeRecurringBookingHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeRecurringBooking(_response);
      });
  }

  protected processChangeRecurringBooking(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getChangeRecurringBookingPreview(
    customerAccountId: number,
    scheduleId: string,
    httpRequest: GetChangeRecurringBookingPreviewHttpRequest,
    cancelToken?: CancelToken
  ): Promise<GetChangeRecurringBookingPreviewHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}/edit/preview";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetChangeRecurringBookingPreview(_response);
      });
  }

  protected processGetChangeRecurringBookingPreview(
    response: AxiosResponse
  ): Promise<GetChangeRecurringBookingPreviewHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetChangeRecurringBookingPreviewHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetChangeRecurringBookingPreviewHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetChangeRecurringBookingPreviewHttpResponse>(null as any);
  }

  /**
   * @deprecated
   */
  cancelSingleBooking(customerAccountId: number, bookingId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/booking/{bookingId}/cancel";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelSingleBooking(_response);
      });
  }

  protected processCancelSingleBooking(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @deprecated
   */
  cancelSingleBooking2(customerAccountId: number, bookingId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/{bookingId}/cancel";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelSingleBooking2(_response);
      });
  }

  protected processCancelSingleBooking2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  cancelSingleBookingWithReason(
    customerAccountId: number,
    bookingId: string,
    request: CancelBookingReasonHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/booking/{bookingId}/cancel-with-reason";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelSingleBookingWithReason(_response);
      });
  }

  protected processCancelSingleBookingWithReason(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  cancelSingleBookingWithReason2(
    customerAccountId: number,
    bookingId: string,
    request: CancelBookingReasonHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/{bookingId}/cancel-with-reason";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelSingleBookingWithReason2(_response);
      });
  }

  protected processCancelSingleBookingWithReason2(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @deprecated
   */
  cancelSchedule(customerAccountId: number, scheduleId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}/cancel";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelSchedule(_response);
      });
  }

  protected processCancelSchedule(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  cancelScheduleWithReason(
    customerAccountId: number,
    scheduleId: string,
    request: CancelBookingReasonHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}/cancel-with-reason";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancelScheduleWithReason(_response);
      });
  }

  protected processCancelScheduleWithReason(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @deprecated
   */
  getScheduleCancellableBookings(
    customerAccountId: number,
    scheduleId: string,
    cancelToken?: CancelToken
  ): Promise<BookingToCancel[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}/cancellable-bookings";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetScheduleCancellableBookings(_response);
      });
  }

  protected processGetScheduleCancellableBookings(response: AxiosResponse): Promise<BookingToCancel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingToCancel.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingToCancel[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingToCancel[]>(null as any);
  }

  getScheduleCancellableBookingsByReason(
    customerAccountId: number,
    scheduleId: string,
    reasonId: number,
    cancelToken?: CancelToken
  ): Promise<BookingToCancel[]> {
    let url_ =
      this.baseUrl +
      "/api/v3/Booking/customer/{customerAccountId}/schedule/{scheduleId}/reason/{reasonId}/cancellable-bookings";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    if (reasonId === undefined || reasonId === null)
      throw new globalThis.Error("The parameter 'reasonId' must be defined.");
    url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetScheduleCancellableBookingsByReason(_response);
      });
  }

  protected processGetScheduleCancellableBookingsByReason(response: AxiosResponse): Promise<BookingToCancel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingToCancel.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingToCancel[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingToCancel[]>(null as any);
  }

  /**
   * @deprecated
   */
  isChargeableCancellation(customerAccountId: number, bookingId: string, cancelToken?: CancelToken): Promise<boolean> {
    let url_ =
      this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/booking/{bookingId}/is-chargeable-cancellation";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processIsChargeableCancellation(_response);
      });
  }

  protected processIsChargeableCancellation(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<boolean>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @deprecated
   */
  isChargeableCancellation2(customerAccountId: number, bookingId: string, cancelToken?: CancelToken): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/{bookingId}/is-chargeable-cancellation";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processIsChargeableCancellation2(_response);
      });
  }

  protected processIsChargeableCancellation2(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<boolean>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @deprecated
   */
  getCancellableBooking(
    customerAccountId: number,
    bookingId: string,
    cancelToken?: CancelToken
  ): Promise<BookingToCancel> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/booking/{bookingId}/cancellable-booking";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCancellableBooking(_response);
      });
  }

  protected processGetCancellableBooking(response: AxiosResponse): Promise<BookingToCancel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BookingToCancel.fromJS(resultData200);
      return Promise.resolve<BookingToCancel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingToCancel>(null as any);
  }

  /**
   * @deprecated
   */
  getCancellableBooking2(
    customerAccountId: number,
    bookingId: string,
    cancelToken?: CancelToken
  ): Promise<BookingToCancel> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/{bookingId}/cancellable-booking";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCancellableBooking2(_response);
      });
  }

  protected processGetCancellableBooking2(response: AxiosResponse): Promise<BookingToCancel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BookingToCancel.fromJS(resultData200);
      return Promise.resolve<BookingToCancel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingToCancel>(null as any);
  }

  getCancellableBookingByReason(
    customerAccountId: number,
    bookingId: string,
    reasonId: number,
    cancelToken?: CancelToken
  ): Promise<BookingToCancel> {
    let url_ =
      this.baseUrl + "/api/v3/Booking/customer/{customerAccountId}/{bookingId}/reason/{reasonId}/cancellable-booking";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (bookingId === undefined || bookingId === null)
      throw new globalThis.Error("The parameter 'bookingId' must be defined.");
    url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
    if (reasonId === undefined || reasonId === null)
      throw new globalThis.Error("The parameter 'reasonId' must be defined.");
    url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCancellableBookingByReason(_response);
      });
  }

  protected processGetCancellableBookingByReason(response: AxiosResponse): Promise<BookingToCancel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BookingToCancel.fromJS(resultData200);
      return Promise.resolve<BookingToCancel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingToCancel>(null as any);
  }

  getCancellationReasons(cancelToken?: CancelToken): Promise<BookingCancellationReason[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/cancellation-reasons";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCancellationReasons(_response);
      });
  }

  protected processGetCancellationReasons(response: AxiosResponse): Promise<BookingCancellationReason[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingCancellationReason.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingCancellationReason[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingCancellationReason[]>(null as any);
  }

  getUpcomingBookingsByCustomerId(
    customerAccountId: number,
    skip: number,
    take: number,
    cancelToken?: CancelToken
  ): Promise<PageableObjectOfBookingHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{CustomerAccountId}/skip/{Skip}/take/{Take}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    if (skip === undefined || skip === null) throw new globalThis.Error("The parameter 'skip' must be defined.");
    url_ = url_.replace("{Skip}", encodeURIComponent("" + skip));
    if (take === undefined || take === null) throw new globalThis.Error("The parameter 'take' must be defined.");
    url_ = url_.replace("{Take}", encodeURIComponent("" + take));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingBookingsByCustomerId(_response);
      });
  }

  protected processGetUpcomingBookingsByCustomerId(
    response: AxiosResponse
  ): Promise<PageableObjectOfBookingHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageableObjectOfBookingHttpResponse.fromJS(resultData200);
      return Promise.resolve<PageableObjectOfBookingHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PageableObjectOfBookingHttpResponse>(null as any);
  }

  getRecurringBookings(customerAccountId: number, cancelToken?: CancelToken): Promise<BookingHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{CustomerAccountId}/active-recurring";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRecurringBookings(_response);
      });
  }

  protected processGetRecurringBookings(response: AxiosResponse): Promise<BookingHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingHttpResponse[]>(null as any);
  }

  getActiveBookingsSchedules(customerAccountId: number, cancelToken?: CancelToken): Promise<BookingScheduleSummary[]> {
    let url_ = this.baseUrl + "/api/v3/Booking/customer/{CustomerAccountId}/active-schedules";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetActiveBookingsSchedules(_response);
      });
  }

  protected processGetActiveBookingsSchedules(response: AxiosResponse): Promise<BookingScheduleSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BookingScheduleSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BookingScheduleSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BookingScheduleSummary[]>(null as any);
  }
}

export class BootstrapClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  bootstrap(cancelToken?: CancelToken): Promise<BootstrapHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Bootstrap";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processBootstrap(_response);
      });
  }

  protected processBootstrap(response: AxiosResponse): Promise<BootstrapHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BootstrapHttpResponse.fromJS(resultData200);
      return Promise.resolve<BootstrapHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BootstrapHttpResponse>(null as any);
  }
}

export class ChatbotClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getDirectLineToken(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Chatbot/directline-token";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDirectLineToken(_response);
      });
  }

  protected processGetDirectLineToken(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 503) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ChildClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  createChild(
    customerAccountId: number,
    httpRequest: CreateChildHttpRequest,
    cancelToken?: CancelToken
  ): Promise<ChildHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Child/customer/{customerAccountId}/create";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateChild(_response);
      });
  }

  protected processCreateChild(response: AxiosResponse): Promise<ChildHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChildHttpResponse.fromJS(resultData200);
      return Promise.resolve<ChildHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChildHttpResponse>(null as any);
  }

  updateChild(
    customerAccountId: number,
    childId: number,
    httpRequest: UpdateChildHttpRequest,
    cancelToken?: CancelToken
  ): Promise<ChildHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Child/customer/{customerAccountId}/child/{childId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (childId === undefined || childId === null)
      throw new globalThis.Error("The parameter 'childId' must be defined.");
    url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateChild(_response);
      });
  }

  protected processUpdateChild(response: AxiosResponse): Promise<ChildHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChildHttpResponse.fromJS(resultData200);
      return Promise.resolve<ChildHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChildHttpResponse>(null as any);
  }

  getChildrenByCustomerAccountId(customerAccountId: number, cancelToken?: CancelToken): Promise<ChildHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Child/customer/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetChildrenByCustomerAccountId(_response);
      });
  }

  protected processGetChildrenByCustomerAccountId(response: AxiosResponse): Promise<ChildHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ChildHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ChildHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChildHttpResponse[]>(null as any);
  }
}

export class CommonClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCommonData(cancelToken?: CancelToken): Promise<GetCommonDataHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Common/data";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCommonData(_response);
      });
  }

  protected processGetCommonData(response: AxiosResponse): Promise<GetCommonDataHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetCommonDataHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetCommonDataHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCommonDataHttpResponse>(null as any);
  }

  searchAddress(
    pattern: string | undefined,
    maxResults: number | undefined,
    cancelToken?: CancelToken
  ): Promise<AddressSearchResultHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Common/search-address?";
    if (pattern === null) throw new globalThis.Error("The parameter 'pattern' cannot be null.");
    else if (pattern !== undefined) url_ += "Pattern=" + encodeURIComponent("" + pattern) + "&";
    if (maxResults === null) throw new globalThis.Error("The parameter 'maxResults' cannot be null.");
    else if (maxResults !== undefined) url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchAddress(_response);
      });
  }

  protected processSearchAddress(response: AxiosResponse): Promise<AddressSearchResultHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AddressSearchResultHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<AddressSearchResultHttpResponse[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AddressSearchResultHttpResponse[]>(null as any);
  }

  getAppConfigs(cancelToken?: CancelToken): Promise<AppConfig[]> {
    let url_ = this.baseUrl + "/api/v3/Common/app-configs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAppConfigs(_response);
      });
  }

  protected processGetAppConfigs(response: AxiosResponse): Promise<AppConfig[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AppConfig.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<AppConfig[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AppConfig[]>(null as any);
  }

  getPasswordRules(cancelToken?: CancelToken): Promise<PasswordSettings> {
    let url_ = this.baseUrl + "/api/v3/Common/password-rules";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPasswordRules(_response);
      });
  }

  protected processGetPasswordRules(response: AxiosResponse): Promise<PasswordSettings> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PasswordSettings.fromJS(resultData200);
      return Promise.resolve<PasswordSettings>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PasswordSettings>(null as any);
  }

  getCommonDates(
    customerAccountId: number,
    year: number,
    cancelToken?: CancelToken
  ): Promise<GetCommonDatesHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Common/customer/{customerAccountId}/common-dates/{year}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCommonDates(_response);
      });
  }

  protected processGetCommonDates(response: AxiosResponse): Promise<GetCommonDatesHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetCommonDatesHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetCommonDatesHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCommonDatesHttpResponse>(null as any);
  }
}

export class CryptoTokenClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getTokens(cancelToken?: CancelToken): Promise<TokenHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/CryptoToken";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTokens(_response);
      });
  }

  protected processGetTokens(response: AxiosResponse): Promise<TokenHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(TokenHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TokenHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TokenHttpResponse[]>(null as any);
  }
}

export class CustomerClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  submitFeedback(
    customerAccountId: number,
    httpRequest: SubmitFeedbackHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/feedback";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSubmitFeedback(_response);
      });
  }

  protected processSubmitFeedback(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getFeedbackTypes(cancelToken?: CancelToken): Promise<FeedbackTypeHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Customer/feedback-types";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFeedbackTypes(_response);
      });
  }

  protected processGetFeedbackTypes(response: AxiosResponse): Promise<FeedbackTypeHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(FeedbackTypeHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<FeedbackTypeHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FeedbackTypeHttpResponse[]>(null as any);
  }

  register(httpRequest: RegisterHttpRequest, cancelToken?: CancelToken): Promise<RegisterHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Customer/register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegister(_response);
      });
  }

  protected processRegister(response: AxiosResponse): Promise<RegisterHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RegisterHttpResponse.fromJS(resultData200);
      return Promise.resolve<RegisterHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RegisterHttpResponse>(null as any);
  }

  verifyEmail(httpRequest: VerifyEmailHttpRequest, cancelToken?: CancelToken): Promise<VerifyEmailHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Customer/verify-email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processVerifyEmail(_response);
      });
  }

  protected processVerifyEmail(response: AxiosResponse): Promise<VerifyEmailHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = VerifyEmailHttpResponse.fromJS(resultData200);
      return Promise.resolve<VerifyEmailHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<VerifyEmailHttpResponse>(null as any);
  }

  sendOtpEmail(httpRequest: ResendCodeHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/resend-otp-email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendOtpEmail(_response);
      });
  }

  protected processSendOtpEmail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  forgotPassword(httpRequest: ForgotPasswordHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/forgot-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processForgotPassword(_response);
      });
  }

  protected processForgotPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  expiredPasswordChange(httpRequest: ExpiredPasswordChangeHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/expired-password-change";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExpiredPasswordChange(_response);
      });
  }

  protected processExpiredPasswordChange(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  passwordChange(
    customerAccountId: number,
    customerContactId: number,
    httpRequest: PasswordChangeHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/contact/{customerContactId}/password-change";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (customerContactId === undefined || customerContactId === null)
      throw new globalThis.Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace("{customerContactId}", encodeURIComponent("" + customerContactId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPasswordChange(_response);
      });
  }

  protected processPasswordChange(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  acknowledgeAdditionalNeeds(
    customerAccountId: number,
    httpRequest: AcknowledgeSpecialNeedsHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/contact/acknowledge-additional-needs";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAcknowledgeAdditionalNeeds(_response);
      });
  }

  protected processAcknowledgeAdditionalNeeds(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  loginEmailChange(
    customerAccountId: number,
    customerContactId: number,
    newLoginEmail: string,
    isNewWebApp: boolean | null | undefined,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ =
      this.baseUrl + "/api/v3/Customer/{customerAccountId}/contact/{customerContactId}/login/{newLoginEmail}/change?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (customerContactId === undefined || customerContactId === null)
      throw new globalThis.Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace("{customerContactId}", encodeURIComponent("" + customerContactId));
    if (newLoginEmail === undefined || newLoginEmail === null)
      throw new globalThis.Error("The parameter 'newLoginEmail' must be defined.");
    url_ = url_.replace("{newLoginEmail}", encodeURIComponent("" + newLoginEmail));
    if (isNewWebApp !== undefined && isNewWebApp !== null)
      url_ += "isNewWebApp=" + encodeURIComponent("" + isNewWebApp) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLoginEmailChange(_response);
      });
  }

  protected processLoginEmailChange(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  login(httpRequest: LoginHttpRequest, cancelToken?: CancelToken): Promise<LoginResponse> {
    let url_ = this.baseUrl + "/api/v3/Customer/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogin(_response);
      });
  }

  protected processLogin(response: AxiosResponse): Promise<LoginResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LoginResponse.fromJS(resultData200);
      return Promise.resolve<LoginResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LoginResponse>(null as any);
  }

  getCustomerAccount(customerAccountId: number, cancelToken?: CancelToken): Promise<CustomerAccountHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCustomerAccount(_response);
      });
  }

  protected processGetCustomerAccount(response: AxiosResponse): Promise<CustomerAccountHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CustomerAccountHttpResponse.fromJS(resultData200);
      return Promise.resolve<CustomerAccountHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerAccountHttpResponse>(null as any);
  }

  updateTutorial(customerAccountId: number, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/completetutorial";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateTutorial(_response);
      });
  }

  protected processUpdateTutorial(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  createContact(
    customerAccountId: number,
    httpRequest: CreateCustomerContactHttpRequest,
    cancelToken?: CancelToken
  ): Promise<CustomerContactHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/contact/create";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateContact(_response);
      });
  }

  protected processCreateContact(response: AxiosResponse): Promise<CustomerContactHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CustomerContactHttpResponse.fromJS(resultData200);
      return Promise.resolve<CustomerContactHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerContactHttpResponse>(null as any);
  }

  updateContact(
    customerAccountId: number,
    customerContactId: number,
    httpRequest: UpdateCustomerContactHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/contact/{customerContactId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (customerContactId === undefined || customerContactId === null)
      throw new globalThis.Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace("{customerContactId}", encodeURIComponent("" + customerContactId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateContact(_response);
      });
  }

  protected processUpdateContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  requestChangePasswordOtp(email: string | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/request-change-password-otp?";
    if (email === null) throw new globalThis.Error("The parameter 'email' cannot be null.");
    else if (email !== undefined) url_ += "email=" + encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRequestChangePasswordOtp(_response);
      });
  }

  protected processRequestChangePasswordOtp(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  changePasswordByOtp(req: ChangePasswordByOtpHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Customer/change-password-by-otp";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(req);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePasswordByOtp(_response);
      });
  }

  protected processChangePasswordByOtp(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  authorize(
    customerAccountId: number,
    request: ParentAuthorizationHttpRequest,
    cancelToken?: CancelToken
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v3/Customer/{customerAccountId}/authorize";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAuthorize(_response);
      });
  }

  protected processAuthorize(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }
}

export class DeviceClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  pingOrRegister(
    customerAccountId: number,
    model: RegisterDeviceHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Device/pingOrRegister/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPingOrRegister(_response);
      });
  }

  protected processPingOrRegister(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class DigitalProgramClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getActiveProgramByServices(
    customerAccountId: number,
    serviceIds: number[] | undefined,
    from: dayjs.Dayjs | undefined,
    to: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken
  ): Promise<ProgramVersionSummary[]> {
    let url_ = this.baseUrl + "/api/v3/DigitalProgram/customer/{customerAccountId}/by-services/active?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (serviceIds === null) throw new globalThis.Error("The parameter 'serviceIds' cannot be null.");
    else if (serviceIds !== undefined)
      serviceIds &&
        serviceIds.forEach((item) => {
          url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&";
        });
    if (from === null) throw new globalThis.Error("The parameter 'from' cannot be null.");
    else if (from !== undefined) url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to === null) throw new globalThis.Error("The parameter 'to' cannot be null.");
    else if (to !== undefined) url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetActiveProgramByServices(_response);
      });
  }

  protected processGetActiveProgramByServices(response: AxiosResponse): Promise<ProgramVersionSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ProgramVersionSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ProgramVersionSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProgramVersionSummary[]>(null as any);
  }

  downloadProgram(
    customerAccountId: number,
    serviceId: number,
    programVersionId: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl +
      "/api/v3/DigitalProgram/customer/{customerAccountId}/service/{serviceId}/version/{programVersionId}/download";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (programVersionId === undefined || programVersionId === null)
      throw new globalThis.Error("The parameter 'programVersionId' must be defined.");
    url_ = url_.replace("{programVersionId}", encodeURIComponent("" + programVersionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadProgram(_response);
      });
  }

  protected processDownloadProgram(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getProgramPreview(
    customerAccountId: number,
    serviceId: number,
    programVersionId: number,
    careTypeGroupId: number,
    cancelToken?: CancelToken
  ): Promise<DigitalProgramDetailsHttpResponse> {
    let url_ =
      this.baseUrl +
      "/api/v3/DigitalProgram/customer/{customerAccountId}/service/{serviceId}/program{programVersionId}/careType/{careTypeGroupId}/details";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (programVersionId === undefined || programVersionId === null)
      throw new globalThis.Error("The parameter 'programVersionId' must be defined.");
    url_ = url_.replace("{programVersionId}", encodeURIComponent("" + programVersionId));
    if (careTypeGroupId === undefined || careTypeGroupId === null)
      throw new globalThis.Error("The parameter 'careTypeGroupId' must be defined.");
    url_ = url_.replace("{careTypeGroupId}", encodeURIComponent("" + careTypeGroupId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramPreview(_response);
      });
  }

  protected processGetProgramPreview(response: AxiosResponse): Promise<DigitalProgramDetailsHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DigitalProgramDetailsHttpResponse.fromJS(resultData200);
      return Promise.resolve<DigitalProgramDetailsHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DigitalProgramDetailsHttpResponse>(null as any);
  }

  getNationalProgramDays(
    customerAccountId: number,
    serviceId: number,
    cancelToken?: CancelToken
  ): Promise<NationalProgramHttpResponse[]> {
    let url_ =
      this.baseUrl + "/api/v3/DigitalProgram/customer/{customerAccountId}/service/{serviceId}/national-program-days";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNationalProgramDays(_response);
      });
  }

  protected processGetNationalProgramDays(response: AxiosResponse): Promise<NationalProgramHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(NationalProgramHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<NationalProgramHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<NationalProgramHttpResponse[]>(null as any);
  }

  getCustomerServicesNationalProgramsSummary(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<ServiceWithUpcomingProgram[]> {
    let url_ = this.baseUrl + "/api/v3/DigitalProgram/customer/{customerAccountId}/services-national-programs-summary";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCustomerServicesNationalProgramsSummary(_response);
      });
  }

  protected processGetCustomerServicesNationalProgramsSummary(
    response: AxiosResponse
  ): Promise<ServiceWithUpcomingProgram[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceWithUpcomingProgram.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceWithUpcomingProgram[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceWithUpcomingProgram[]>(null as any);
  }

  getServicesWithUpcomingNationalPrograms(
    customerAccountId: number,
    address: string | undefined,
    take: number | undefined,
    skip: number | undefined,
    cancelToken?: CancelToken
  ): Promise<PageableObjectOfServiceWithUpcomingProgram> {
    let url_ = this.baseUrl + "/api/v3/DigitalProgram/customer/{customerAccountId}/services-with-national-programs?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (address === null) throw new globalThis.Error("The parameter 'address' cannot be null.");
    else if (address !== undefined) url_ += "address=" + encodeURIComponent("" + address) + "&";
    if (take === null) throw new globalThis.Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (skip === null) throw new globalThis.Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServicesWithUpcomingNationalPrograms(_response);
      });
  }

  protected processGetServicesWithUpcomingNationalPrograms(
    response: AxiosResponse
  ): Promise<PageableObjectOfServiceWithUpcomingProgram> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageableObjectOfServiceWithUpcomingProgram.fromJS(resultData200);
      return Promise.resolve<PageableObjectOfServiceWithUpcomingProgram>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PageableObjectOfServiceWithUpcomingProgram>(null as any);
  }

  getExperienceClassifications(cancelToken?: CancelToken): Promise<ClassificationLookup[]> {
    let url_ = this.baseUrl + "/api/v3/DigitalProgram/classifications";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetExperienceClassifications(_response);
      });
  }

  protected processGetExperienceClassifications(response: AxiosResponse): Promise<ClassificationLookup[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ClassificationLookup.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ClassificationLookup[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ClassificationLookup[]>(null as any);
  }

  downloadFileById(fileId: number, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/DigitalProgram/download-file/{fileId}";
    if (fileId === undefined || fileId === null) throw new globalThis.Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadFileById(_response);
      });
  }

  protected processDownloadFileById(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class DocumentClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  downloadContactDocumentByType(
    customerAccountId: number,
    customerContactId: number,
    documentTypeId: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl +
      "/api/v3/Document/customer/{customerAccountId}/contact/{customerContactId}/documentType/{documentTypeId}/download";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (customerContactId === undefined || customerContactId === null)
      throw new globalThis.Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace("{customerContactId}", encodeURIComponent("" + customerContactId));
    if (documentTypeId === undefined || documentTypeId === null)
      throw new globalThis.Error("The parameter 'documentTypeId' must be defined.");
    url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadContactDocumentByType(_response);
      });
  }

  protected processDownloadContactDocumentByType(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  downloadChildDocumentByType(
    customerAccountId: number,
    childId: number,
    documentTypeId: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl +
      "/api/v3/Document/customer/{customerAccountId}/child/{childId}/documentType/{documentTypeId}/download";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (childId === undefined || childId === null)
      throw new globalThis.Error("The parameter 'childId' must be defined.");
    url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
    if (documentTypeId === undefined || documentTypeId === null)
      throw new globalThis.Error("The parameter 'documentTypeId' must be defined.");
    url_ = url_.replace("{documentTypeId}", encodeURIComponent("" + documentTypeId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadChildDocumentByType(_response);
      });
  }

  protected processDownloadChildDocumentByType(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  createDocument(
    customerAccountId: number,
    childId: number | null | undefined,
    customerContactId: number | null | undefined,
    documentTypeId: number | undefined,
    isTemp: boolean | undefined,
    file: FileParameter | null | undefined,
    medicalPlanConditionId: number | null | undefined,
    medicalPlanQuestionId: number | null | undefined,
    medicalPlanAnswerIndex: number | null | undefined,
    expiresOn: dayjs.Dayjs | null | undefined,
    cancelToken?: CancelToken
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v3/Document/customer/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (childId !== null && childId !== undefined) content_.append("ChildId", childId.toString());
    if (customerContactId !== null && customerContactId !== undefined)
      content_.append("CustomerContactId", customerContactId.toString());
    if (documentTypeId === null || documentTypeId === undefined)
      throw new globalThis.Error("The parameter 'documentTypeId' cannot be null.");
    else content_.append("DocumentTypeId", documentTypeId.toString());
    if (isTemp === null || isTemp === undefined) throw new globalThis.Error("The parameter 'isTemp' cannot be null.");
    else content_.append("IsTemp", isTemp.toString());
    if (file !== null && file !== undefined) content_.append("File", file.data, file.fileName ? file.fileName : "File");
    if (medicalPlanConditionId !== null && medicalPlanConditionId !== undefined)
      content_.append("MedicalPlanConditionId", medicalPlanConditionId.toString());
    if (medicalPlanQuestionId !== null && medicalPlanQuestionId !== undefined)
      content_.append("MedicalPlanQuestionId", medicalPlanQuestionId.toString());
    if (medicalPlanAnswerIndex !== null && medicalPlanAnswerIndex !== undefined)
      content_.append("MedicalPlanAnswerIndex", medicalPlanAnswerIndex.toString());
    if (expiresOn !== null && expiresOn !== undefined) content_.append("ExpiresOn", expiresOn.toJSON());

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDocument(_response);
      });
  }

  protected processCreateDocument(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  updateDocument(
    customerAccountId: number,
    uniqueId: string,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Document/customer/{customerAccountId}/{uniqueId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined) content_.append("File", file.data, file.fileName ? file.fileName : "File");

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateDocument(_response);
      });
  }

  protected processUpdateDocument(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  downloadDocument(customerAccountId: number, uniqueId: string, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Document/customer/{customerAccountId}/document/{uniqueId}/download";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadDocument(_response);
      });
  }

  protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class GalleryClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getGalleryPhotos(
    customerAccountId: number,
    rowsToSkip: number,
    numOfRowsToReturn: number,
    childId: number | null,
    cancelToken?: CancelToken
  ): Promise<GalleryPhoto[]> {
    let url_ =
      this.baseUrl +
      "/api/v3/Gallery/customer/{customerAccountId}/skip/{rowsToSkip}/take/{numOfRowsToReturn}/child/{childId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (rowsToSkip === undefined || rowsToSkip === null)
      throw new globalThis.Error("The parameter 'rowsToSkip' must be defined.");
    url_ = url_.replace("{rowsToSkip}", encodeURIComponent("" + rowsToSkip));
    if (numOfRowsToReturn === undefined || numOfRowsToReturn === null)
      throw new globalThis.Error("The parameter 'numOfRowsToReturn' must be defined.");
    url_ = url_.replace("{numOfRowsToReturn}", encodeURIComponent("" + numOfRowsToReturn));
    if (childId === undefined || childId === null)
      throw new globalThis.Error("The parameter 'childId' must be defined.");
    url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetGalleryPhotos(_response);
      });
  }

  protected processGetGalleryPhotos(response: AxiosResponse): Promise<GalleryPhoto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(GalleryPhoto.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<GalleryPhoto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GalleryPhoto[]>(null as any);
  }

  getGalleryPage(
    customerAccountId: number,
    rowsToSkip: number,
    numOfRowsToReturn: number,
    cancelToken?: CancelToken
  ): Promise<GalleryPhoto[]> {
    let url_ = this.baseUrl + "/api/v3/Gallery/customer/{customerAccountId}/skip/{rowsToSkip}/take/{numOfRowsToReturn}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (rowsToSkip === undefined || rowsToSkip === null)
      throw new globalThis.Error("The parameter 'rowsToSkip' must be defined.");
    url_ = url_.replace("{rowsToSkip}", encodeURIComponent("" + rowsToSkip));
    if (numOfRowsToReturn === undefined || numOfRowsToReturn === null)
      throw new globalThis.Error("The parameter 'numOfRowsToReturn' must be defined.");
    url_ = url_.replace("{numOfRowsToReturn}", encodeURIComponent("" + numOfRowsToReturn));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetGalleryPage(_response);
      });
  }

  protected processGetGalleryPage(response: AxiosResponse): Promise<GalleryPhoto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(GalleryPhoto.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<GalleryPhoto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GalleryPhoto[]>(null as any);
  }

  downloadBlob(customerAccountId: number, uniqueId: string, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Gallery/customer/{customerAccountId}/photo/{uniqueId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadBlob(_response);
      });
  }

  protected processDownloadBlob(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  downloadBlobOptimized(
    customerAccountId: number,
    photoId: string,
    maxSize: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Gallery/customer/{CustomerAccountId}/photo/{PhotoId}/max-size/{MaxSize}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{CustomerAccountId}", encodeURIComponent("" + customerAccountId));
    if (photoId === undefined || photoId === null)
      throw new globalThis.Error("The parameter 'photoId' must be defined.");
    url_ = url_.replace("{PhotoId}", encodeURIComponent("" + photoId));
    if (maxSize === undefined || maxSize === null)
      throw new globalThis.Error("The parameter 'maxSize' must be defined.");
    url_ = url_.replace("{MaxSize}", encodeURIComponent("" + maxSize));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadBlobOptimized(_response);
      });
  }

  protected processDownloadBlobOptimized(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class ImportClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  registerEmail(email: string | undefined, cancelToken?: CancelToken): Promise<ImportResultHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Import/registeremail?";
    if (email === null) throw new globalThis.Error("The parameter 'email' cannot be null.");
    else if (email !== undefined) url_ += "email=" + encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterEmail(_response);
      });
  }

  protected processRegisterEmail(response: AxiosResponse): Promise<ImportResultHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ImportResultHttpResponse.fromJS(resultData200);
      return Promise.resolve<ImportResultHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ImportResultHttpResponse>(null as any);
  }

  registerResult(email: string | undefined, cancelToken?: CancelToken): Promise<ImportResultHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Import/registerresult?";
    if (email === null) throw new globalThis.Error("The parameter 'email' cannot be null.");
    else if (email !== undefined) url_ += "email=" + encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterResult(_response);
      });
  }

  protected processRegisterResult(response: AxiosResponse): Promise<ImportResultHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ImportResultHttpResponse.fromJS(resultData200);
      return Promise.resolve<ImportResultHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ImportResultHttpResponse>(null as any);
  }

  registerBatch(
    size: number | undefined,
    serviceId: number | null | undefined,
    cancelToken?: CancelToken
  ): Promise<ImportBatchHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Import/registerbatch?";
    if (size === null) throw new globalThis.Error("The parameter 'size' cannot be null.");
    else if (size !== undefined) url_ += "size=" + encodeURIComponent("" + size) + "&";
    if (serviceId !== undefined && serviceId !== null) url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterBatch(_response);
      });
  }

  protected processRegisterBatch(response: AxiosResponse): Promise<ImportBatchHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ImportBatchHttpResponse.fromJS(resultData200);
      return Promise.resolve<ImportBatchHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ImportBatchHttpResponse>(null as any);
  }

  getStats(cancelToken?: CancelToken): Promise<ImportStatsHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Import/stats";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetStats(_response);
      });
  }

  protected processGetStats(response: AxiosResponse): Promise<ImportStatsHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ImportStatsHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ImportStatsHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ImportStatsHttpResponse[]>(null as any);
  }
}

export class MessageClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCurrent(cancelToken?: CancelToken): Promise<AppMessageHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Message";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrent(_response);
      });
  }

  protected processGetCurrent(response: AxiosResponse): Promise<AppMessageHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AppMessageHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<AppMessageHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AppMessageHttpResponse[]>(null as any);
  }
}

export class NotificationClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getNotificationSettings(customerAccountId: number, cancelToken?: CancelToken): Promise<NotificationSettings> {
    let url_ = this.baseUrl + "/api/v3/Notification/customer/{customerAccountId}/notification-setting";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNotificationSettings(_response);
      });
  }

  protected processGetNotificationSettings(response: AxiosResponse): Promise<NotificationSettings> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = NotificationSettings.fromJS(resultData200);
      return Promise.resolve<NotificationSettings>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<NotificationSettings>(null as any);
  }

  toggleNotificationSetting(
    customerAccountId: number,
    request: ToggleNotificationSettingHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Notification/customer/{customerAccountId}/toggle-notification";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processToggleNotificationSetting(_response);
      });
  }

  protected processToggleNotificationSetting(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class NswVoucherClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  redeem(
    customerAccountId: number,
    redeemHttpRequest: RedeemHttpRequest,
    cancelToken?: CancelToken
  ): Promise<RedeemHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/NswVoucher/customer/{customerAccountId}/redeem";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(redeemHttpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRedeem(_response);
      });
  }

  protected processRedeem(response: AxiosResponse): Promise<RedeemHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RedeemHttpResponse.fromJS(resultData200);
      return Promise.resolve<RedeemHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RedeemHttpResponse>(null as any);
  }
}

export class OnlineSessionClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getUpcoming(cancelToken?: CancelToken): Promise<OnlineSession[]> {
    let url_ = this.baseUrl + "/api/v3/OnlineSession";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcoming(_response);
      });
  }

  protected processGetUpcoming(response: AxiosResponse): Promise<OnlineSession[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(OnlineSession.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<OnlineSession[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OnlineSession[]>(null as any);
  }

  getUpcomingBookings(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<OnlineSessionBookingsHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/OnlineSession/customer/{customerAccountId}/upcoming";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingBookings(_response);
      });
  }

  protected processGetUpcomingBookings(response: AxiosResponse): Promise<OnlineSessionBookingsHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(OnlineSessionBookingsHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<OnlineSessionBookingsHttpResponse[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OnlineSessionBookingsHttpResponse[]>(null as any);
  }

  saveBookings(
    customerAccountId: number,
    httpRequest: UpdateOnlineSessionBookingsHttpRequest,
    cancelToken?: CancelToken
  ): Promise<OnlineSessionBookingsHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/OnlineSession/customer/{customerAccountId}/save-bookings";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveBookings(_response);
      });
  }

  protected processSaveBookings(response: AxiosResponse): Promise<OnlineSessionBookingsHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(OnlineSessionBookingsHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<OnlineSessionBookingsHttpResponse[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ErrorResponse.fromJS(resultData409);
      return throwException("A server side error occurred.", status, _responseText, _headers, result409);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<OnlineSessionBookingsHttpResponse[]>(null as any);
  }
}

export class PaymentsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCustomerCurrentPaymentMethod(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<PaymentMethodHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/current-payment-method";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCustomerCurrentPaymentMethod(_response);
      });
  }

  protected processGetCustomerCurrentPaymentMethod(response: AxiosResponse): Promise<PaymentMethodHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaymentMethodHttpResponse.fromJS(resultData200);
      return Promise.resolve<PaymentMethodHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PaymentMethodHttpResponse>(null as any);
  }

  getBillingCycles(
    customerAccountId: number,
    page: number | undefined,
    pageSize: number | undefined,
    isDue: boolean | undefined,
    cancelToken?: CancelToken
  ): Promise<PageableObjectOfBillingCycleSummaryModel> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/billing-cycles?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (isDue === null) throw new globalThis.Error("The parameter 'isDue' cannot be null.");
    else if (isDue !== undefined) url_ += "isDue=" + encodeURIComponent("" + isDue) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBillingCycles(_response);
      });
  }

  protected processGetBillingCycles(response: AxiosResponse): Promise<PageableObjectOfBillingCycleSummaryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageableObjectOfBillingCycleSummaryModel.fromJS(resultData200);
      return Promise.resolve<PageableObjectOfBillingCycleSummaryModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PageableObjectOfBillingCycleSummaryModel>(null as any);
  }

  getCurrentStatement(
    customerAccountId: number,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken
  ): Promise<PageableObjectOfStatementInformationSummaryModel> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/billing-cycles-current?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrentStatement(_response);
      });
  }

  protected processGetCurrentStatement(
    response: AxiosResponse
  ): Promise<PageableObjectOfStatementInformationSummaryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageableObjectOfStatementInformationSummaryModel.fromJS(resultData200);
      return Promise.resolve<PageableObjectOfStatementInformationSummaryModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PageableObjectOfStatementInformationSummaryModel>(null as any);
  }

  getHistoryBillingCycleDetails(
    customerAccountId: number,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken
  ): Promise<PageableObjectOfStatementInformationSummaryModel> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/billing-cycles-history?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetHistoryBillingCycleDetails(_response);
      });
  }

  protected processGetHistoryBillingCycleDetails(
    response: AxiosResponse
  ): Promise<PageableObjectOfStatementInformationSummaryModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageableObjectOfStatementInformationSummaryModel.fromJS(resultData200);
      return Promise.resolve<PageableObjectOfStatementInformationSummaryModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PageableObjectOfStatementInformationSummaryModel>(null as any);
  }

  getBillingCyclesSummaryWithBalance(
    customerAccountId: number,
    pageSize: number | undefined,
    cancelToken?: CancelToken
  ): Promise<BillingCycleSummaryList> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/billing-cycles-with-balance?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBillingCyclesSummaryWithBalance(_response);
      });
  }

  protected processGetBillingCyclesSummaryWithBalance(response: AxiosResponse): Promise<BillingCycleSummaryList> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BillingCycleSummaryList.fromJS(resultData200);
      return Promise.resolve<BillingCycleSummaryList>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BillingCycleSummaryList>(null as any);
  }

  makeRegularPayment(
    customerAccountId: number,
    httpRequest: MakeRegularPaymentHttpRequest,
    cancelToken?: CancelToken
  ): Promise<MakePaymentHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/regular";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMakeRegularPayment(_response);
      });
  }

  protected processMakeRegularPayment(response: AxiosResponse): Promise<MakePaymentHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MakePaymentHttpResponse.fromJS(resultData200);
      return Promise.resolve<MakePaymentHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MakePaymentHttpResponse>(null as any);
  }

  makeOneOffBankPayment(
    customerAccountId: number,
    httpRequest: MakeOneOffBankPaymentHttpRequest,
    cancelToken?: CancelToken
  ): Promise<MakePaymentHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/one-off/bank";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMakeOneOffBankPayment(_response);
      });
  }

  protected processMakeOneOffBankPayment(response: AxiosResponse): Promise<MakePaymentHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MakePaymentHttpResponse.fromJS(resultData200);
      return Promise.resolve<MakePaymentHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 429) {
      const _responseText = response.data;
      let result429: any = null;
      let resultData429 = _responseText;
      result429 = ProblemDetails.fromJS(resultData429);
      return throwException("A server side error occurred.", status, _responseText, _headers, result429);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MakePaymentHttpResponse>(null as any);
  }

  makeOneOffCardPayment(
    customerAccountId: number,
    httpRequest: EncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest,
    cancelToken?: CancelToken
  ): Promise<MakePaymentHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/one-off/card";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMakeOneOffCardPayment(_response);
      });
  }

  protected processMakeOneOffCardPayment(response: AxiosResponse): Promise<MakePaymentHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MakePaymentHttpResponse.fromJS(resultData200);
      return Promise.resolve<MakePaymentHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MakePaymentHttpResponse>(null as any);
  }

  addBankPaymentMethod(
    customerAccountId: number,
    httpRequest: AddBankPaymentMethodHttpRequest,
    cancelToken?: CancelToken
  ): Promise<CreatePaymentMethodHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/payment-method/bank";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddBankPaymentMethod(_response);
      });
  }

  protected processAddBankPaymentMethod(response: AxiosResponse): Promise<CreatePaymentMethodHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreatePaymentMethodHttpResponse.fromJS(resultData200);
      return Promise.resolve<CreatePaymentMethodHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CreatePaymentMethodHttpResponse>(null as any);
  }

  addCreditCardMethod(
    customerAccountId: number,
    httpRequest: AddCreditCardPaymentMethodHttpRequest,
    cancelToken?: CancelToken
  ): Promise<CreatePaymentMethodHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/payment-method/creditcard";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddCreditCardMethod(_response);
      });
  }

  protected processAddCreditCardMethod(response: AxiosResponse): Promise<CreatePaymentMethodHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreatePaymentMethodHttpResponse.fromJS(resultData200);
      return Promise.resolve<CreatePaymentMethodHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CreatePaymentMethodHttpResponse>(null as any);
  }

  getStatementReport(
    customerAccountId: number,
    statementRunEntryNumber: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/statement-report/{statementRunEntryNumber}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (statementRunEntryNumber === undefined || statementRunEntryNumber === null)
      throw new globalThis.Error("The parameter 'statementRunEntryNumber' must be defined.");
    url_ = url_.replace("{statementRunEntryNumber}", encodeURIComponent("" + statementRunEntryNumber));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetStatementReport(_response);
      });
  }

  protected processGetStatementReport(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getMaguireStatementReport(
    customerAccountId: number,
    statementId: number,
    billingCycleId: number,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl +
      "/api/v3/Payments/customer/{customerAccountId}/statement-report-maguire/{statementId}/{billingCycleId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (statementId === undefined || statementId === null)
      throw new globalThis.Error("The parameter 'statementId' must be defined.");
    url_ = url_.replace("{statementId}", encodeURIComponent("" + statementId));
    if (billingCycleId === undefined || billingCycleId === null)
      throw new globalThis.Error("The parameter 'billingCycleId' must be defined.");
    url_ = url_.replace("{billingCycleId}", encodeURIComponent("" + billingCycleId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMaguireStatementReport(_response);
      });
  }

  protected processGetMaguireStatementReport(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getStatementOfEntitlement(
    customerAccountId: number,
    startDate: dayjs.Dayjs | undefined,
    endDate: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/statement-of-entitlement?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (startDate === null) throw new globalThis.Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
    if (endDate === null) throw new globalThis.Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetStatementOfEntitlement(_response);
      });
  }

  protected processGetStatementOfEntitlement(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getUpcomingCharges(customerAccountId: number, cancelToken?: CancelToken): Promise<UpcomingChargeModel[]> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/upcoming-charges";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingCharges(_response);
      });
  }

  protected processGetUpcomingCharges(response: AxiosResponse): Promise<UpcomingChargeModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(UpcomingChargeModel.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<UpcomingChargeModel[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UpcomingChargeModel[]>(null as any);
  }

  getAccountBalance(customerAccountId: number, cancelToken?: CancelToken): Promise<GetAccountStatementHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/account-statement";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAccountBalance(_response);
      });
  }

  protected processGetAccountBalance(response: AxiosResponse): Promise<GetAccountStatementHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetAccountStatementHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetAccountStatementHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetAccountStatementHttpResponse>(null as any);
  }

  getCurrentAccountBalance(customerAccountId: number, cancelToken?: CancelToken): Promise<AccountBalanceResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/account-balance";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrentAccountBalance(_response);
      });
  }

  protected processGetCurrentAccountBalance(response: AxiosResponse): Promise<AccountBalanceResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AccountBalanceResponse.fromJS(resultData200);
      return Promise.resolve<AccountBalanceResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AccountBalanceResponse>(null as any);
  }

  getNextBillingCharges(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<GetNextBillingChargesHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/next-charges";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNextBillingCharges(_response);
      });
  }

  protected processGetNextBillingCharges(response: AxiosResponse): Promise<GetNextBillingChargesHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetNextBillingChargesHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetNextBillingChargesHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetNextBillingChargesHttpResponse>(null as any);
  }

  getWeeklyUpcomingCharges(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<GetWeeklyUpcomingChargesHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/weekly-upcoming-charges";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetWeeklyUpcomingCharges(_response);
      });
  }

  protected processGetWeeklyUpcomingCharges(response: AxiosResponse): Promise<GetWeeklyUpcomingChargesHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetWeeklyUpcomingChargesHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetWeeklyUpcomingChargesHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetWeeklyUpcomingChargesHttpResponse>(null as any);
  }

  getBillingDueDates(year: number, customerAccountId: number, cancelToken?: CancelToken): Promise<dayjs.Dayjs[]> {
    let url_ = this.baseUrl + "/api/v3/Payments/customer/{customerAccountId}/due-dates/{year}";
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBillingDueDates(_response);
      });
  }

  protected processGetBillingDueDates(response: AxiosResponse): Promise<dayjs.Dayjs[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(dayjs(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<dayjs.Dayjs[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<dayjs.Dayjs[]>(null as any);
  }
}

export class PrivacyClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getPrivacySettings(customerAccountId: number, cancelToken?: CancelToken): Promise<PrivacySetting> {
    let url_ = this.baseUrl + "/api/v3/Privacy/customer/{customerAccountId}/privacy-setting";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPrivacySettings(_response);
      });
  }

  protected processGetPrivacySettings(response: AxiosResponse): Promise<PrivacySetting> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PrivacySetting.fromJS(resultData200);
      return Promise.resolve<PrivacySetting>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PrivacySetting>(null as any);
  }

  togglePrivacySetting(
    customerAccountId: number,
    request: TogglePrivacySettingHttpRequest,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Privacy/customer/{customerAccountId}/toggle-privacy";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processTogglePrivacySetting(_response);
      });
  }

  protected processTogglePrivacySetting(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ProgramClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getProgramDateImage(programDateId: number, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Program/{programDateId}/image";
    if (programDateId === undefined || programDateId === null)
      throw new globalThis.Error("The parameter 'programDateId' must be defined.");
    url_ = url_.replace("{programDateId}", encodeURIComponent("" + programDateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramDateImage(_response);
      });
  }

  protected processGetProgramDateImage(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * @deprecated
   */
  getUpcomingProgramsByServiceId(serviceId: number, cancelToken?: CancelToken): Promise<ProgramHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Program/service/{serviceId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingProgramsByServiceId(_response);
      });
  }

  protected processGetUpcomingProgramsByServiceId(response: AxiosResponse): Promise<ProgramHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ProgramHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ProgramHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProgramHttpResponse[]>(null as any);
  }

  getUpcomingProgramsByCustomerAccountIdAndServiceId(
    customerAccountId: number,
    serviceId: number,
    cancelToken?: CancelToken
  ): Promise<CustomerProgramHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Program/customer/{customerAccountId}/service/{serviceId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingProgramsByCustomerAccountIdAndServiceId(_response);
      });
  }

  protected processGetUpcomingProgramsByCustomerAccountIdAndServiceId(
    response: AxiosResponse
  ): Promise<CustomerProgramHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(CustomerProgramHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<CustomerProgramHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CustomerProgramHttpResponse[]>(null as any);
  }

  /**
   * @param address (optional)
   * @param maxDistanceInKm (optional)
   * @deprecated
   */
  getProgramsByLocation(
    address: string | undefined,
    maxDistanceInKm: number | undefined,
    cancelToken?: CancelToken
  ): Promise<ServiceDistance[]> {
    let url_ = this.baseUrl + "/api/v3/Program/services-with-programs-by-location?";
    if (address === null) throw new globalThis.Error("The parameter 'address' cannot be null.");
    else if (address !== undefined) url_ += "address=" + encodeURIComponent("" + address) + "&";
    if (maxDistanceInKm === null) throw new globalThis.Error("The parameter 'maxDistanceInKm' cannot be null.");
    else if (maxDistanceInKm !== undefined) url_ += "maxDistanceInKm=" + encodeURIComponent("" + maxDistanceInKm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramsByLocation(_response);
      });
  }

  protected processGetProgramsByLocation(response: AxiosResponse): Promise<ServiceDistance[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceDistance.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceDistance[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceDistance[]>(null as any);
  }

  getProgramsByLocationAndCustomer(
    customerAccountId: number,
    address: string | undefined,
    maxDistanceInKm: number | undefined,
    cancelToken?: CancelToken
  ): Promise<ServiceDistance[]> {
    let url_ = this.baseUrl + "/api/v3/Program/customer/{customerAccountId}/services-with-programs-by-location?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (address === null) throw new globalThis.Error("The parameter 'address' cannot be null.");
    else if (address !== undefined) url_ += "address=" + encodeURIComponent("" + address) + "&";
    if (maxDistanceInKm === null) throw new globalThis.Error("The parameter 'maxDistanceInKm' cannot be null.");
    else if (maxDistanceInKm !== undefined) url_ += "maxDistanceInKm=" + encodeURIComponent("" + maxDistanceInKm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramsByLocationAndCustomer(_response);
      });
  }

  protected processGetProgramsByLocationAndCustomer(response: AxiosResponse): Promise<ServiceDistance[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceDistance.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceDistance[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceDistance[]>(null as any);
  }

  getServicesWithUpcomingPrograms(
    customerAccountId: number,
    address: string | undefined,
    take: number | undefined,
    skip: number | undefined,
    cancelToken?: CancelToken
  ): Promise<ServiceWithUpcomingProgram[]> {
    let url_ = this.baseUrl + "/api/v3/Program/customer/{customerAccountId}/services-with-programs?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (address === null) throw new globalThis.Error("The parameter 'address' cannot be null.");
    else if (address !== undefined) url_ += "address=" + encodeURIComponent("" + address) + "&";
    if (take === null) throw new globalThis.Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (skip === null) throw new globalThis.Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServicesWithUpcomingPrograms(_response);
      });
  }

  protected processGetServicesWithUpcomingPrograms(response: AxiosResponse): Promise<ServiceWithUpcomingProgram[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceWithUpcomingProgram.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceWithUpcomingProgram[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceWithUpcomingProgram[]>(null as any);
  }

  getProgramsByCoordinatesAndCustomer(
    customerAccountId: number,
    latitude: number | undefined,
    longitude: number | undefined,
    take: number | undefined,
    skip: number | undefined,
    cancelToken?: CancelToken
  ): Promise<ServiceWithUpcomingProgram[]> {
    let url_ = this.baseUrl + "/api/v3/Program/customer/{customerAccountId}/services-with-programs-by-coordinates?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (latitude === null) throw new globalThis.Error("The parameter 'latitude' cannot be null.");
    else if (latitude !== undefined) url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
    if (longitude === null) throw new globalThis.Error("The parameter 'longitude' cannot be null.");
    else if (longitude !== undefined) url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
    if (take === null) throw new globalThis.Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (skip === null) throw new globalThis.Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramsByCoordinatesAndCustomer(_response);
      });
  }

  protected processGetProgramsByCoordinatesAndCustomer(response: AxiosResponse): Promise<ServiceWithUpcomingProgram[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceWithUpcomingProgram.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceWithUpcomingProgram[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceWithUpcomingProgram[]>(null as any);
  }

  getCustomerServicesEventsSummary(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<ServiceProgramSummary[]> {
    let url_ = this.baseUrl + "/api/v3/Program/customer/{customerAccountId}/services-event-summary";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCustomerServicesEventsSummary(_response);
      });
  }

  protected processGetCustomerServicesEventsSummary(response: AxiosResponse): Promise<ServiceProgramSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceProgramSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceProgramSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceProgramSummary[]>(null as any);
  }
}

export class RegistrationClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getRegistrationByUserId(cancelToken?: CancelToken): Promise<RegistrationHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Registration";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRegistrationByUserId(_response);
      });
  }

  protected processGetRegistrationByUserId(response: AxiosResponse): Promise<RegistrationHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RegistrationHttpResponse.fromJS(resultData200);
      return Promise.resolve<RegistrationHttpResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RegistrationHttpResponse>(null as any);
  }

  completeRegistrationByUserId(httpRequest: CompleteRegistrationHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/complete";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCompleteRegistrationByUserId(_response);
      });
  }

  protected processCompleteRegistrationByUserId(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  saveChild(httpRequest: SaveRegistrationChildHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/child";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveChild(_response);
      });
  }

  protected processSaveChild(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  removeChild(uniqueId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/child/{uniqueId}";
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveChild(_response);
      });
  }

  protected processRemoveChild(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  saveContact(httpRequest: SaveRegistrationContactHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/contact";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveContact(_response);
      });
  }

  protected processSaveContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  saveContacts(httpRequest: SaveRegistrationContactsHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/contacts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveContacts(_response);
      });
  }

  protected processSaveContacts(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  removeContact(uniqueId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/contact/{uniqueId}";
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRemoveContact(_response);
      });
  }

  protected processRemoveContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  createDocument(
    registrationChildUniqueId: string | null | undefined,
    registrationContactUniqueId: string | null | undefined,
    documentTypeId: number | undefined,
    file: FileParameter | null | undefined,
    medicalPlanConditionId: number | null | undefined,
    medicalPlanQuestionId: number | null | undefined,
    medicalPlanAnswerIndex: number | null | undefined,
    expiresOn: dayjs.Dayjs | null | undefined,
    cancelToken?: CancelToken
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v3/Registration/document";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (registrationChildUniqueId !== null && registrationChildUniqueId !== undefined)
      content_.append("RegistrationChildUniqueId", registrationChildUniqueId.toString());
    if (registrationContactUniqueId !== null && registrationContactUniqueId !== undefined)
      content_.append("RegistrationContactUniqueId", registrationContactUniqueId.toString());
    if (documentTypeId === null || documentTypeId === undefined)
      throw new globalThis.Error("The parameter 'documentTypeId' cannot be null.");
    else content_.append("DocumentTypeId", documentTypeId.toString());
    if (file !== null && file !== undefined) content_.append("File", file.data, file.fileName ? file.fileName : "File");
    if (medicalPlanConditionId !== null && medicalPlanConditionId !== undefined)
      content_.append("MedicalPlanConditionId", medicalPlanConditionId.toString());
    if (medicalPlanQuestionId !== null && medicalPlanQuestionId !== undefined)
      content_.append("MedicalPlanQuestionId", medicalPlanQuestionId.toString());
    if (medicalPlanAnswerIndex !== null && medicalPlanAnswerIndex !== undefined)
      content_.append("MedicalPlanAnswerIndex", medicalPlanAnswerIndex.toString());
    if (expiresOn !== null && expiresOn !== undefined) content_.append("ExpiresOn", expiresOn.toJSON());

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDocument(_response);
      });
  }

  protected processCreateDocument(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  updateDocument(
    uniqueId: string,
    registrationChildUniqueId: string | null | undefined,
    registrationContactUniqueId: string | null | undefined,
    documentTypeId: number | undefined,
    medicalConditionId: number | null | undefined,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/document/{uniqueId}";
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (registrationChildUniqueId !== null && registrationChildUniqueId !== undefined)
      content_.append("RegistrationChildUniqueId", registrationChildUniqueId.toString());
    if (registrationContactUniqueId !== null && registrationContactUniqueId !== undefined)
      content_.append("RegistrationContactUniqueId", registrationContactUniqueId.toString());
    if (documentTypeId === null || documentTypeId === undefined)
      throw new globalThis.Error("The parameter 'documentTypeId' cannot be null.");
    else content_.append("DocumentTypeId", documentTypeId.toString());
    if (medicalConditionId !== null && medicalConditionId !== undefined)
      content_.append("MedicalConditionId", medicalConditionId.toString());
    if (file !== null && file !== undefined) content_.append("File", file.data, file.fileName ? file.fileName : "File");

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateDocument(_response);
      });
  }

  protected processUpdateDocument(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  deleteDocument(uniqueId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/document/{uniqueId}";
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteDocument(_response);
      });
  }

  protected processDeleteDocument(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  downloadDocument(uniqueId: string, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/Registration/document/{uniqueId}/download";
    if (uniqueId === undefined || uniqueId === null)
      throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
    url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadDocument(_response);
      });
  }

  protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getPossibleDuplicatedAccount(cancelToken?: CancelToken): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v3/Registration/possible-duplicated-account";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPossibleDuplicatedAccount(_response);
      });
  }

  protected processGetPossibleDuplicatedAccount(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<boolean>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
  }

  getRequirePaymentConfiguration(cancelToken?: CancelToken): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v3/Registration/require-payment-configuration";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRequirePaymentConfiguration(_response);
      });
  }

  protected processGetRequirePaymentConfiguration(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<boolean>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @deprecated
   */
  logEvent(request: LogRegistrationEventHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/Registration/event";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLogEvent(_response);
      });
  }

  protected processLogEvent(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class RollOverClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getRollOverSchedules(
    customerAccountId: number | undefined,
    cancelToken?: CancelToken
  ): Promise<RollOverScheduleHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/RollOver/schedules?";
    if (customerAccountId === null) throw new globalThis.Error("The parameter 'customerAccountId' cannot be null.");
    else if (customerAccountId !== undefined)
      url_ += "customerAccountId=" + encodeURIComponent("" + customerAccountId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRollOverSchedules(_response);
      });
  }

  protected processGetRollOverSchedules(response: AxiosResponse): Promise<RollOverScheduleHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RollOverScheduleHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<RollOverScheduleHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RollOverScheduleHttpResponse[]>(null as any);
  }

  rollOverScheduleOpt(
    customerAccountId: number,
    request: RollOverScheduleOptHttpRequest,
    cancelToken?: CancelToken
  ): Promise<RollOverScheduleHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/RollOver/schedules/{customerAccountId}/opt";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRollOverScheduleOpt(_response);
      });
  }

  protected processRollOverScheduleOpt(response: AxiosResponse): Promise<RollOverScheduleHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RollOverScheduleHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<RollOverScheduleHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RollOverScheduleHttpResponse[]>(null as any);
  }

  rollOverSchedulesUpdate(
    customerAccountId: number,
    request: RollOverScheduleUpdatesHttpRequest,
    cancelToken?: CancelToken
  ): Promise<RollOverScheduleHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/RollOver/schedules/{customerAccountId}/update";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRollOverSchedulesUpdate(_response);
      });
  }

  protected processRollOverSchedulesUpdate(response: AxiosResponse): Promise<RollOverScheduleHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RollOverScheduleHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<RollOverScheduleHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RollOverScheduleHttpResponse[]>(null as any);
  }

  getRollsForChild(childId: number, cancelToken?: CancelToken): Promise<RollHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/RollOver/roll/child/{childId}";
    if (childId === undefined || childId === null)
      throw new globalThis.Error("The parameter 'childId' must be defined.");
    url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRollsForChild(_response);
      });
  }

  protected processGetRollsForChild(response: AxiosResponse): Promise<RollHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RollHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<RollHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RollHttpResponse[]>(null as any);
  }
}

export class SchoolClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getSchoolsByStateName(stateShortName: string, cancelToken?: CancelToken): Promise<SchoolHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/School/state/name/{stateShortName}";
    if (stateShortName === undefined || stateShortName === null)
      throw new globalThis.Error("The parameter 'stateShortName' must be defined.");
    url_ = url_.replace("{stateShortName}", encodeURIComponent("" + stateShortName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSchoolsByStateName(_response);
      });
  }

  protected processGetSchoolsByStateName(response: AxiosResponse): Promise<SchoolHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SchoolHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SchoolHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SchoolHttpResponse[]>(null as any);
  }

  search(
    pattern: string | undefined,
    maxResults: number | undefined,
    cancelToken?: CancelToken
  ): Promise<SchoolHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/School/search?";
    if (pattern === null) throw new globalThis.Error("The parameter 'pattern' cannot be null.");
    else if (pattern !== undefined) url_ += "Pattern=" + encodeURIComponent("" + pattern) + "&";
    if (maxResults === null) throw new globalThis.Error("The parameter 'maxResults' cannot be null.");
    else if (maxResults !== undefined) url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(response: AxiosResponse): Promise<SchoolHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SchoolHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SchoolHttpResponse[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SchoolHttpResponse[]>(null as any);
  }
}

export class ServiceClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getServicesByCustomer(customerAccountId: number, cancelToken?: CancelToken): Promise<ServiceHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Service/customer/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServicesByCustomer(_response);
      });
  }

  protected processGetServicesByCustomer(response: AxiosResponse): Promise<ServiceHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceHttpResponse[]>(null as any);
  }

  getServicesByCustomerBookings(
    customerAccountId: number,
    cancelToken?: CancelToken
  ): Promise<GetServicesByCustomerBookingsHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Service/customer/{customerAccountId}/with-sessions";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServicesByCustomerBookings(_response);
      });
  }

  protected processGetServicesByCustomerBookings(
    response: AxiosResponse
  ): Promise<GetServicesByCustomerBookingsHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(GetServicesByCustomerBookingsHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<GetServicesByCustomerBookingsHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetServicesByCustomerBookingsHttpResponse[]>(null as any);
  }

  getServicesByStateName(stateShortName: string, cancelToken?: CancelToken): Promise<ServiceHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Service/state/name/{stateShortName}";
    if (stateShortName === undefined || stateShortName === null)
      throw new globalThis.Error("The parameter 'stateShortName' must be defined.");
    url_ = url_.replace("{stateShortName}", encodeURIComponent("" + stateShortName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServicesByStateName(_response);
      });
  }

  protected processGetServicesByStateName(response: AxiosResponse): Promise<ServiceHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceHttpResponse[]>(null as any);
  }

  getTermsByServiceId(serviceId: number, cancelToken?: CancelToken): Promise<TermHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Service/{serviceId}/terms";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTermsByServiceId(_response);
      });
  }

  protected processGetTermsByServiceId(response: AxiosResponse): Promise<TermHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(TermHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TermHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TermHttpResponse[]>(null as any);
  }

  getBreaksByServiceId(serviceId: number, cancelToken?: CancelToken): Promise<BreakHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Service/{serviceId}/breaks";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBreaksByServiceId(_response);
      });
  }

  protected processGetBreaksByServiceId(response: AxiosResponse): Promise<BreakHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(BreakHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BreakHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<BreakHttpResponse[]>(null as any);
  }
}

export class SessionClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getSessionsUnavailability(
    customerAccountId: number,
    from: dayjs.Dayjs | undefined,
    to: dayjs.Dayjs | undefined,
    rollIds: number[] | undefined,
    childrenIds: number[] | undefined,
    cancelToken?: CancelToken
  ): Promise<SessionAvailabilityInfo[]> {
    let url_ = this.baseUrl + "/api/v3/Session/customer/{customerAccountId}/unavailability?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (from === null) throw new globalThis.Error("The parameter 'from' cannot be null.");
    else if (from !== undefined) url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to === null) throw new globalThis.Error("The parameter 'to' cannot be null.");
    else if (to !== undefined) url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    if (rollIds === null) throw new globalThis.Error("The parameter 'rollIds' cannot be null.");
    else if (rollIds !== undefined)
      rollIds &&
        rollIds.forEach((item) => {
          url_ += "RollIds=" + encodeURIComponent("" + item) + "&";
        });
    if (childrenIds === null) throw new globalThis.Error("The parameter 'childrenIds' cannot be null.");
    else if (childrenIds !== undefined)
      childrenIds &&
        childrenIds.forEach((item) => {
          url_ += "ChildrenIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSessionsUnavailability(_response);
      });
  }

  protected processGetSessionsUnavailability(response: AxiosResponse): Promise<SessionAvailabilityInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SessionAvailabilityInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SessionAvailabilityInfo[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SessionAvailabilityInfo[]>(null as any);
  }

  getSessionsUnavailabilityForScheduleEdit(
    customerAccountId: number,
    scheduleId: string,
    from: dayjs.Dayjs | undefined,
    to: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken
  ): Promise<SessionAvailabilityInfo[]> {
    let url_ = this.baseUrl + "/api/v3/Session/customer/{customerAccountId}/schedule/{scheduleId}/unavailability?";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    if (scheduleId === undefined || scheduleId === null)
      throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
    url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
    if (from === null) throw new globalThis.Error("The parameter 'from' cannot be null.");
    else if (from !== undefined) url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to === null) throw new globalThis.Error("The parameter 'to' cannot be null.");
    else if (to !== undefined) url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSessionsUnavailabilityForScheduleEdit(_response);
      });
  }

  protected processGetSessionsUnavailabilityForScheduleEdit(
    response: AxiosResponse
  ): Promise<SessionAvailabilityInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SessionAvailabilityInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SessionAvailabilityInfo[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SessionAvailabilityInfo[]>(null as any);
  }

  getRollsForService(serviceId: number, cancelToken?: CancelToken): Promise<RollHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Session/roll/service/{serviceId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRollsForService(_response);
      });
  }

  protected processGetRollsForService(response: AxiosResponse): Promise<RollHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RollHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<RollHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RollHttpResponse[]>(null as any);
  }

  getPupilFreeDays(
    serviceId: number,
    from: dayjs.Dayjs | undefined,
    to: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken
  ): Promise<GetPupilFreeDaysHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v3/Session/service/{serviceId}/pupil-free-days?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (from === null) throw new globalThis.Error("The parameter 'from' cannot be null.");
    else if (from !== undefined) url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
    if (to === null) throw new globalThis.Error("The parameter 'to' cannot be null.");
    else if (to !== undefined) url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPupilFreeDays(_response);
      });
  }

  protected processGetPupilFreeDays(response: AxiosResponse): Promise<GetPupilFreeDaysHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(GetPupilFreeDaysHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<GetPupilFreeDaysHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetPupilFreeDaysHttpResponse[]>(null as any);
  }

  getNextAvailableSession(rollId: number, year: number, cancelToken?: CancelToken): Promise<dayjs.Dayjs | null> {
    let url_ = this.baseUrl + "/api/v3/Session/roll/{rollId}/{year}/next-available-session";
    if (rollId === undefined || rollId === null) throw new globalThis.Error("The parameter 'rollId' must be defined.");
    url_ = url_.replace("{rollId}", encodeURIComponent("" + rollId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNextAvailableSession(_response);
      });
  }

  protected processGetNextAvailableSession(response: AxiosResponse): Promise<dayjs.Dayjs | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 ? dayjs(resultData200.toString()) : (null as any);

      return Promise.resolve<dayjs.Dayjs | null>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<dayjs.Dayjs | null>(null as any);
  }
}

export class StatusClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCurrent(cancelToken?: CancelToken): Promise<AppStatusHttpResponse> {
    let url_ = this.baseUrl + "/api/v3/Status";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrent(_response);
      });
  }

  protected processGetCurrent(response: AxiosResponse): Promise<AppStatusHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AppStatusHttpResponse.fromJS(resultData200);
      return Promise.resolve<AppStatusHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<AppStatusHttpResponse>(null as any);
  }
}

export class TermsAndConditionsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCustomerTermsAndConditions(customerAccountId: number, cancelToken?: CancelToken): Promise<string> {
    let url_ = this.baseUrl + "/api/v3/TermsAndConditions/customer/{customerAccountId}";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCustomerTermsAndConditions(_response);
      });
  }

  protected processGetCustomerTermsAndConditions(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }

  acceptTermsAndConditions(customerAccountId: number, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/TermsAndConditions/customer/{customerAccountId}/accept";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAcceptTermsAndConditions(_response);
      });
  }

  protected processAcceptTermsAndConditions(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class TokenExchangeClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  chatBot(cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v3/TokenExchange/chat-bot";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChatBot(_response);
      });
  }

  protected processChatBot(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"] }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class TransactionQueryClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  submitBillingQuery(
    customerAccountId: number,
    files: FileParameter[] | null | undefined,
    details: string | null | undefined,
    queryTypeId: number | undefined,
    transactions: string | null | undefined,
    isUpcoming: boolean | undefined,
    cancelToken?: CancelToken
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v3/TransactionQuery/customer/{customerAccountId}/query";
    if (customerAccountId === undefined || customerAccountId === null)
      throw new globalThis.Error("The parameter 'customerAccountId' must be defined.");
    url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files !== null && files !== undefined)
      files.forEach((item_) => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
    if (details !== null && details !== undefined) content_.append("Details", details.toString());
    if (queryTypeId === null || queryTypeId === undefined)
      throw new globalThis.Error("The parameter 'queryTypeId' cannot be null.");
    else content_.append("QueryTypeId", queryTypeId.toString());
    if (transactions !== null && transactions !== undefined) content_.append("Transactions", transactions.toString());
    if (isUpcoming === null || isUpcoming === undefined)
      throw new globalThis.Error("The parameter 'isUpcoming' cannot be null.");
    else content_.append("IsUpcoming", isUpcoming.toString());

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSubmitBillingQuery(_response);
      });
  }

  protected processSubmitBillingQuery(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class BookingHttpResponse implements IBookingHttpResponse {
  uniqueId!: string;
  childId!: number;
  rollId!: number;
  scheduleId?: string | undefined;
  feeAmount!: number;
  discountAmount!: number;
  cancellationStatusId!: number;
  cancelledAt?: dayjs.Dayjs | undefined;
  cancelledBy?: string | undefined;
  attendedTimeIn?: dayjs.Dayjs | undefined;
  attendedTimeOut?: dayjs.Dayjs | undefined;
  feeId!: number;
  feeName!: string;
  hasAttended?: boolean | undefined;
  isAttendanceMarked?: boolean | undefined;
  isBookingCreated?: boolean | undefined;
  nonAttendanceReason?: string | undefined;
  date!: dayjs.Dayjs;
  isCancelled!: boolean;
  netAmount!: number;
  createdAt!: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | undefined;
  roll?: RollInfo | undefined;
  schedule?: ScheduleInfo | undefined;
  program?: HolidayClubProgramInfo | undefined;
  nationalProgram?: NationalProgramDayCompactInfo | undefined;

  constructor(data?: IBookingHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.scheduleId = _data["scheduleId"];
      this.feeAmount = _data["feeAmount"];
      this.discountAmount = _data["discountAmount"];
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.cancelledAt = _data["cancelledAt"] ? dayjs(_data["cancelledAt"].toString()) : (undefined as any);
      this.cancelledBy = _data["cancelledBy"];
      this.attendedTimeIn = _data["attendedTimeIn"] ? dayjs(_data["attendedTimeIn"].toString()) : (undefined as any);
      this.attendedTimeOut = _data["attendedTimeOut"] ? dayjs(_data["attendedTimeOut"].toString()) : (undefined as any);
      this.feeId = _data["feeId"];
      this.feeName = _data["feeName"];
      this.hasAttended = _data["hasAttended"];
      this.isAttendanceMarked = _data["isAttendanceMarked"];
      this.isBookingCreated = _data["isBookingCreated"];
      this.nonAttendanceReason = _data["nonAttendanceReason"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.isCancelled = _data["isCancelled"];
      this.netAmount = _data["netAmount"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.updatedAt = _data["updatedAt"] ? dayjs(_data["updatedAt"].toString()) : (undefined as any);
      this.roll = _data["roll"] ? RollInfo.fromJS(_data["roll"]) : (undefined as any);
      this.schedule = _data["schedule"] ? ScheduleInfo.fromJS(_data["schedule"]) : (undefined as any);
      this.program = _data["program"] ? HolidayClubProgramInfo.fromJS(_data["program"]) : (undefined as any);
      this.nationalProgram = _data["nationalProgram"]
        ? NationalProgramDayCompactInfo.fromJS(_data["nationalProgram"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): BookingHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new BookingHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["scheduleId"] = this.scheduleId;
    data["feeAmount"] = this.feeAmount;
    data["discountAmount"] = this.discountAmount;
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : (undefined as any);
    data["cancelledBy"] = this.cancelledBy;
    data["attendedTimeIn"] = this.attendedTimeIn ? this.attendedTimeIn.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["attendedTimeOut"] = this.attendedTimeOut ? this.attendedTimeOut.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["feeId"] = this.feeId;
    data["feeName"] = this.feeName;
    data["hasAttended"] = this.hasAttended;
    data["isAttendanceMarked"] = this.isAttendanceMarked;
    data["isBookingCreated"] = this.isBookingCreated;
    data["nonAttendanceReason"] = this.nonAttendanceReason;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["isCancelled"] = this.isCancelled;
    data["netAmount"] = this.netAmount;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : (undefined as any);
    data["roll"] = this.roll ? this.roll.toJSON() : (undefined as any);
    data["schedule"] = this.schedule ? this.schedule.toJSON() : (undefined as any);
    data["program"] = this.program ? this.program.toJSON() : (undefined as any);
    data["nationalProgram"] = this.nationalProgram ? this.nationalProgram.toJSON() : (undefined as any);
    return data;
  }
}

export interface IBookingHttpResponse {
  uniqueId: string;
  childId: number;
  rollId: number;
  scheduleId?: string | undefined;
  feeAmount: number;
  discountAmount: number;
  cancellationStatusId: number;
  cancelledAt?: dayjs.Dayjs | undefined;
  cancelledBy?: string | undefined;
  attendedTimeIn?: dayjs.Dayjs | undefined;
  attendedTimeOut?: dayjs.Dayjs | undefined;
  feeId: number;
  feeName: string;
  hasAttended?: boolean | undefined;
  isAttendanceMarked?: boolean | undefined;
  isBookingCreated?: boolean | undefined;
  nonAttendanceReason?: string | undefined;
  date: dayjs.Dayjs;
  isCancelled: boolean;
  netAmount: number;
  createdAt: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | undefined;
  roll?: RollInfo | undefined;
  schedule?: ScheduleInfo | undefined;
  program?: HolidayClubProgramInfo | undefined;
  nationalProgram?: NationalProgramDayCompactInfo | undefined;
}

export class RollInfo implements IRollInfo {
  rollId!: number;
  serviceId!: number;
  rollName?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeId?: number | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  casualFeeId?: number | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  rollClassificationId?: number | undefined;
  minAgeMths!: number;
  maxAgeMths!: number;
  ageCalculationMethod!: string;
  ageCalculation!: AgeCalculationMethod;
  ageCalculationMethodId!: number;
  defaultMinAgeMths!: number;
  defaultMaxAgeMths!: number;
  service?: ServiceInfo | undefined;

  constructor(data?: IRollInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.serviceId = _data["serviceId"];
      this.rollName = _data["rollName"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.primaryFeeId = _data["primaryFeeId"];
      this.primaryFeeAmount = _data["primaryFeeAmount"];
      this.primaryFeeName = _data["primaryFeeName"];
      this.casualFeeId = _data["casualFeeId"];
      this.casualFeeName = _data["casualFeeName"];
      this.casualFeeAmount = _data["casualFeeAmount"];
      this.sessionType = _data["sessionType"];
      this.sessionSubType = _data["sessionSubType"];
      this.rollClassificationId = _data["rollClassificationId"];
      this.minAgeMths = _data["minAgeMths"];
      this.maxAgeMths = _data["maxAgeMths"];
      this.ageCalculationMethod = _data["ageCalculationMethod"];
      this.ageCalculation = _data["ageCalculation"];
      this.ageCalculationMethodId = _data["ageCalculationMethodId"];
      this.defaultMinAgeMths = _data["defaultMinAgeMths"];
      this.defaultMaxAgeMths = _data["defaultMaxAgeMths"];
      this.service = _data["service"] ? ServiceInfo.fromJS(_data["service"]) : (undefined as any);
    }
  }

  static fromJS(data: any): RollInfo {
    data = typeof data === "object" ? data : {};
    let result = new RollInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["serviceId"] = this.serviceId;
    data["rollName"] = this.rollName;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["primaryFeeId"] = this.primaryFeeId;
    data["primaryFeeAmount"] = this.primaryFeeAmount;
    data["primaryFeeName"] = this.primaryFeeName;
    data["casualFeeId"] = this.casualFeeId;
    data["casualFeeName"] = this.casualFeeName;
    data["casualFeeAmount"] = this.casualFeeAmount;
    data["sessionType"] = this.sessionType;
    data["sessionSubType"] = this.sessionSubType;
    data["rollClassificationId"] = this.rollClassificationId;
    data["minAgeMths"] = this.minAgeMths;
    data["maxAgeMths"] = this.maxAgeMths;
    data["ageCalculationMethod"] = this.ageCalculationMethod;
    data["ageCalculation"] = this.ageCalculation;
    data["ageCalculationMethodId"] = this.ageCalculationMethodId;
    data["defaultMinAgeMths"] = this.defaultMinAgeMths;
    data["defaultMaxAgeMths"] = this.defaultMaxAgeMths;
    data["service"] = this.service ? this.service.toJSON() : (undefined as any);
    return data;
  }
}

export interface IRollInfo {
  rollId: number;
  serviceId: number;
  rollName?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeId?: number | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  casualFeeId?: number | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  rollClassificationId?: number | undefined;
  minAgeMths: number;
  maxAgeMths: number;
  ageCalculationMethod: string;
  ageCalculation: AgeCalculationMethod;
  ageCalculationMethodId: number;
  defaultMinAgeMths: number;
  defaultMaxAgeMths: number;
  service?: ServiceInfo | undefined;
}

export enum AgeCalculationMethod {
  Normal = "normal",
  TillStartOfYear = "tillStartOfYear",
}

export class ServiceInfo implements IServiceInfo {
  serviceId!: number;
  serviceName?: string | undefined;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking!: number;

  constructor(data?: IServiceInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.minimumDaysToAvoidCancellationFeeRecurringBooking =
        _data["minimumDaysToAvoidCancellationFeeRecurringBooking"];
      this.minimumDaysToAvoidCancellationFeeCasualBooking = _data["minimumDaysToAvoidCancellationFeeCasualBooking"];
      this.minimumDaysToAvoidCancellationFeeVacBooking = _data["minimumDaysToAvoidCancellationFeeVacBooking"];
    }
  }

  static fromJS(data: any): ServiceInfo {
    data = typeof data === "object" ? data : {};
    let result = new ServiceInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["minimumDaysToAvoidCancellationFeeRecurringBooking"] = this.minimumDaysToAvoidCancellationFeeRecurringBooking;
    data["minimumDaysToAvoidCancellationFeeCasualBooking"] = this.minimumDaysToAvoidCancellationFeeCasualBooking;
    data["minimumDaysToAvoidCancellationFeeVacBooking"] = this.minimumDaysToAvoidCancellationFeeVacBooking;
    return data;
  }
}

export interface IServiceInfo {
  serviceId: number;
  serviceName?: string | undefined;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking: number;
}

export class ScheduleInfo implements IScheduleInfo {
  uniqueId!: string;
  createdAt!: dayjs.Dayjs;
  customerAccountId!: number;
  rollId!: number;
  childId!: number;
  scheduleType!: BookingScheduleType;
  effectiveFromDate!: dayjs.Dayjs;
  effectiveToDate?: dayjs.Dayjs | undefined;
  firstMonday!: boolean;
  firstTuesday!: boolean;
  firstWednesday!: boolean;
  firstThursday!: boolean;
  firstFriday!: boolean;
  secondMonday!: boolean;
  secondTuesday!: boolean;
  secondWednesday!: boolean;
  secondThursday!: boolean;
  secondFriday!: boolean;
  numberOfUpcomingBookings!: number;
  minBookingsRequired!: number;

  constructor(data?: IScheduleInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.customerAccountId = _data["customerAccountId"];
      this.rollId = _data["rollId"];
      this.childId = _data["childId"];
      this.scheduleType = _data["scheduleType"];
      this.effectiveFromDate = _data["effectiveFromDate"]
        ? dayjs(_data["effectiveFromDate"].toString())
        : (undefined as any);
      this.effectiveToDate = _data["effectiveToDate"] ? dayjs(_data["effectiveToDate"].toString()) : (undefined as any);
      this.firstMonday = _data["firstMonday"];
      this.firstTuesday = _data["firstTuesday"];
      this.firstWednesday = _data["firstWednesday"];
      this.firstThursday = _data["firstThursday"];
      this.firstFriday = _data["firstFriday"];
      this.secondMonday = _data["secondMonday"];
      this.secondTuesday = _data["secondTuesday"];
      this.secondWednesday = _data["secondWednesday"];
      this.secondThursday = _data["secondThursday"];
      this.secondFriday = _data["secondFriday"];
      this.numberOfUpcomingBookings = _data["numberOfUpcomingBookings"];
      this.minBookingsRequired = _data["minBookingsRequired"];
    }
  }

  static fromJS(data: any): ScheduleInfo {
    data = typeof data === "object" ? data : {};
    let result = new ScheduleInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["customerAccountId"] = this.customerAccountId;
    data["rollId"] = this.rollId;
    data["childId"] = this.childId;
    data["scheduleType"] = this.scheduleType;
    data["effectiveFromDate"] = this.effectiveFromDate
      ? this.effectiveFromDate.format("YYYY-MM-DD")
      : (undefined as any);
    data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.format("YYYY-MM-DD") : (undefined as any);
    data["firstMonday"] = this.firstMonday;
    data["firstTuesday"] = this.firstTuesday;
    data["firstWednesday"] = this.firstWednesday;
    data["firstThursday"] = this.firstThursday;
    data["firstFriday"] = this.firstFriday;
    data["secondMonday"] = this.secondMonday;
    data["secondTuesday"] = this.secondTuesday;
    data["secondWednesday"] = this.secondWednesday;
    data["secondThursday"] = this.secondThursday;
    data["secondFriday"] = this.secondFriday;
    data["numberOfUpcomingBookings"] = this.numberOfUpcomingBookings;
    data["minBookingsRequired"] = this.minBookingsRequired;
    return data;
  }
}

export interface IScheduleInfo {
  uniqueId: string;
  createdAt: dayjs.Dayjs;
  customerAccountId: number;
  rollId: number;
  childId: number;
  scheduleType: BookingScheduleType;
  effectiveFromDate: dayjs.Dayjs;
  effectiveToDate?: dayjs.Dayjs | undefined;
  firstMonday: boolean;
  firstTuesday: boolean;
  firstWednesday: boolean;
  firstThursday: boolean;
  firstFriday: boolean;
  secondMonday: boolean;
  secondTuesday: boolean;
  secondWednesday: boolean;
  secondThursday: boolean;
  secondFriday: boolean;
  numberOfUpcomingBookings: number;
  minBookingsRequired: number;
}

export enum BookingScheduleType {
  Weekly = "weekly",
  Fortnightly = "fortnightly",
}

export class HolidayClubProgramInfo implements IHolidayClubProgramInfo {
  programDateId!: number;
  sessionId!: number;
  season!: string;
  year!: number;
  supplierId?: number | undefined;
  provider?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  activityCode?: string | undefined;
  programDescription!: string;
  programName!: string;
  imageUrl?: string | undefined;
  date!: dayjs.Dayjs;

  constructor(data?: IHolidayClubProgramInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programDateId = _data["programDateId"];
      this.sessionId = _data["sessionId"];
      this.season = _data["season"];
      this.year = _data["year"];
      this.supplierId = _data["supplierId"];
      this.provider = _data["provider"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.activityCode = _data["activityCode"];
      this.programDescription = _data["programDescription"];
      this.programName = _data["programName"];
      this.imageUrl = _data["imageUrl"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): HolidayClubProgramInfo {
    data = typeof data === "object" ? data : {};
    let result = new HolidayClubProgramInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programDateId"] = this.programDateId;
    data["sessionId"] = this.sessionId;
    data["season"] = this.season;
    data["year"] = this.year;
    data["supplierId"] = this.supplierId;
    data["provider"] = this.provider;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["activityCode"] = this.activityCode;
    data["programDescription"] = this.programDescription;
    data["programName"] = this.programName;
    data["imageUrl"] = this.imageUrl;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    return data;
  }
}

export interface IHolidayClubProgramInfo {
  programDateId: number;
  sessionId: number;
  season: string;
  year: number;
  supplierId?: number | undefined;
  provider?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  activityCode?: string | undefined;
  programDescription: string;
  programName: string;
  imageUrl?: string | undefined;
  date: dayjs.Dayjs;
}

export class NationalProgramDayCompactInfo implements INationalProgramDayCompactInfo {
  programId!: number;
  programVersionId!: number;
  sessionId!: number;
  theme!: string;
  shortBlurb?: string | undefined;
  experienceName?: string | undefined;
  previewFileId?: number | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  providerCode?: string | undefined;
  classificationId!: number;
  classification!: string;
  seasonName!: string;
  seasonStartDate!: dayjs.Dayjs;
  seasonEndDate?: dayjs.Dayjs | undefined;

  constructor(data?: INationalProgramDayCompactInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.programVersionId = _data["programVersionId"];
      this.sessionId = _data["sessionId"];
      this.theme = _data["theme"];
      this.shortBlurb = _data["shortBlurb"];
      this.experienceName = _data["experienceName"];
      this.previewFileId = _data["previewFileId"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.excursionLeaveTime = _data["excursionLeaveTime"]
        ? dayjs(_data["excursionLeaveTime"].toString())
        : (undefined as any);
      this.excursionReturnTime = _data["excursionReturnTime"]
        ? dayjs(_data["excursionReturnTime"].toString())
        : (undefined as any);
      this.providerCode = _data["providerCode"];
      this.classificationId = _data["classificationId"];
      this.classification = _data["classification"];
      this.seasonName = _data["seasonName"];
      this.seasonStartDate = _data["seasonStartDate"] ? dayjs(_data["seasonStartDate"].toString()) : (undefined as any);
      this.seasonEndDate = _data["seasonEndDate"] ? dayjs(_data["seasonEndDate"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): NationalProgramDayCompactInfo {
    data = typeof data === "object" ? data : {};
    let result = new NationalProgramDayCompactInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programId"] = this.programId;
    data["programVersionId"] = this.programVersionId;
    data["sessionId"] = this.sessionId;
    data["theme"] = this.theme;
    data["shortBlurb"] = this.shortBlurb;
    data["experienceName"] = this.experienceName;
    data["previewFileId"] = this.previewFileId;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["excursionLeaveTime"] = this.excursionLeaveTime
      ? this.excursionLeaveTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["excursionReturnTime"] = this.excursionReturnTime
      ? this.excursionReturnTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["providerCode"] = this.providerCode;
    data["classificationId"] = this.classificationId;
    data["classification"] = this.classification;
    data["seasonName"] = this.seasonName;
    data["seasonStartDate"] = this.seasonStartDate ? this.seasonStartDate.toISOString() : (undefined as any);
    data["seasonEndDate"] = this.seasonEndDate ? this.seasonEndDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface INationalProgramDayCompactInfo {
  programId: number;
  programVersionId: number;
  sessionId: number;
  theme: string;
  shortBlurb?: string | undefined;
  experienceName?: string | undefined;
  previewFileId?: number | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  providerCode?: string | undefined;
  classificationId: number;
  classification: string;
  seasonName: string;
  seasonStartDate: dayjs.Dayjs;
  seasonEndDate?: dayjs.Dayjs | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
  errors!: { [key: string]: string[] };

  [key: string]: any;

  constructor(data?: IHttpValidationProblemDetails) {
    super(data);
    if (!data) {
      this.errors = {};
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): HttpValidationProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new HttpValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key)) (data["errors"] as any)[key] = (this.errors as any)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
  errors!: { [key: string]: string[] };

  [key: string]: any;

  constructor(data?: IValidationProblemDetails) {
    super(data);
    if (!data) {
      this.errors = {};
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): ValidationProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key)) (data["errors"] as any)[key] = (this.errors as any)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export class ErrorResponse implements IErrorResponse {
  errorCode?: number | undefined;
  message!: string;
  correlationId!: string;
  info?: any | undefined;

  constructor(data?: IErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.errorCode = _data["errorCode"];
      this.message = _data["message"];
      this.correlationId = _data["correlationId"];
      this.info = _data["info"];
    }
  }

  static fromJS(data: any): ErrorResponse {
    data = typeof data === "object" ? data : {};
    let result = new ErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["errorCode"] = this.errorCode;
    data["message"] = this.message;
    data["correlationId"] = this.correlationId;
    data["info"] = this.info;
    return data;
  }
}

export interface IErrorResponse {
  errorCode?: number | undefined;
  message: string;
  correlationId: string;
  info?: any | undefined;
}

export class CreateCasualBookingsHttpRequest implements ICreateCasualBookingsHttpRequest {
  childrenIds!: number[];
  dates!: BookingDate[];
  excludedDates?: BookingDate[] | undefined;
  ageViolationReasons?: AgeViolationReason[] | undefined;

  constructor(data?: ICreateCasualBookingsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenIds = [];
      this.dates = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["childrenIds"])) {
        this.childrenIds = [] as any;
        for (let item of _data["childrenIds"]) this.childrenIds!.push(item);
      }
      if (Array.isArray(_data["dates"])) {
        this.dates = [] as any;
        for (let item of _data["dates"]) this.dates!.push(BookingDate.fromJS(item));
      }
      if (Array.isArray(_data["excludedDates"])) {
        this.excludedDates = [] as any;
        for (let item of _data["excludedDates"]) this.excludedDates!.push(BookingDate.fromJS(item));
      }
      if (Array.isArray(_data["ageViolationReasons"])) {
        this.ageViolationReasons = [] as any;
        for (let item of _data["ageViolationReasons"]) this.ageViolationReasons!.push(AgeViolationReason.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateCasualBookingsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateCasualBookingsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.childrenIds)) {
      data["childrenIds"] = [];
      for (let item of this.childrenIds) data["childrenIds"].push(item);
    }
    if (Array.isArray(this.dates)) {
      data["dates"] = [];
      for (let item of this.dates) data["dates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.excludedDates)) {
      data["excludedDates"] = [];
      for (let item of this.excludedDates) data["excludedDates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.ageViolationReasons)) {
      data["ageViolationReasons"] = [];
      for (let item of this.ageViolationReasons)
        data["ageViolationReasons"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateCasualBookingsHttpRequest {
  childrenIds: number[];
  dates: BookingDate[];
  excludedDates?: BookingDate[] | undefined;
  ageViolationReasons?: AgeViolationReason[] | undefined;
}

export class BookingDate implements IBookingDate {
  rollId!: number;
  date!: dayjs.Dayjs;

  constructor(data?: IBookingDate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): BookingDate {
    data = typeof data === "object" ? data : {};
    let result = new BookingDate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    return data;
  }
}

export interface IBookingDate {
  rollId: number;
  date: dayjs.Dayjs;
}

export class AgeViolationReason implements IAgeViolationReason {
  childId!: number;
  rollId!: number;
  reason!: string;

  constructor(data?: IAgeViolationReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): AgeViolationReason {
    data = typeof data === "object" ? data : {};
    let result = new AgeViolationReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["reason"] = this.reason;
    return data;
  }
}

export interface IAgeViolationReason {
  childId: number;
  rollId: number;
  reason: string;
}

export class GetCreateCasualBookingsPreviewHttpResponse implements IGetCreateCasualBookingsPreviewHttpResponse {
  bookings!: BookingInfo[];

  constructor(data?: IGetCreateCasualBookingsPreviewHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bookings = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["bookings"])) {
        this.bookings = [] as any;
        for (let item of _data["bookings"]) this.bookings!.push(BookingInfo.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetCreateCasualBookingsPreviewHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetCreateCasualBookingsPreviewHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.bookings)) {
      data["bookings"] = [];
      for (let item of this.bookings) data["bookings"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetCreateCasualBookingsPreviewHttpResponse {
  bookings: BookingInfo[];
}

export class BookingInfo implements IBookingInfo {
  rollId!: number;
  childId!: number;
  date!: dayjs.Dayjs;
  status!: BookingStatus;
  fee!: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount!: number;

  constructor(data?: IBookingInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.childId = _data["childId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.status = _data["status"];
      this.fee = _data["fee"];
      this.feeType = _data["feeType"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): BookingInfo {
    data = typeof data === "object" ? data : {};
    let result = new BookingInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["childId"] = this.childId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["status"] = this.status;
    data["fee"] = this.fee;
    data["feeType"] = this.feeType;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IBookingInfo {
  rollId: number;
  childId: number;
  date: dayjs.Dayjs;
  status: BookingStatus;
  fee: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount: number;
}

export enum BookingStatus {
  New = "new",
  Existing = "existing",
}

export enum FeeType {
  Casual = "casual",
  Recurring = "recurring",
}

export class GetCreateCasualBookingsPreviewHttpRequest implements IGetCreateCasualBookingsPreviewHttpRequest {
  childrenIds!: number[];
  dates!: BookingDate2[];

  constructor(data?: IGetCreateCasualBookingsPreviewHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenIds = [];
      this.dates = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["childrenIds"])) {
        this.childrenIds = [] as any;
        for (let item of _data["childrenIds"]) this.childrenIds!.push(item);
      }
      if (Array.isArray(_data["dates"])) {
        this.dates = [] as any;
        for (let item of _data["dates"]) this.dates!.push(BookingDate2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetCreateCasualBookingsPreviewHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetCreateCasualBookingsPreviewHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.childrenIds)) {
      data["childrenIds"] = [];
      for (let item of this.childrenIds) data["childrenIds"].push(item);
    }
    if (Array.isArray(this.dates)) {
      data["dates"] = [];
      for (let item of this.dates) data["dates"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetCreateCasualBookingsPreviewHttpRequest {
  childrenIds: number[];
  dates: BookingDate2[];
}

export class BookingDate2 implements IBookingDate2 {
  rollId!: number;
  date!: dayjs.Dayjs;

  constructor(data?: IBookingDate2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): BookingDate2 {
    data = typeof data === "object" ? data : {};
    let result = new BookingDate2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    return data;
  }
}

export interface IBookingDate2 {
  rollId: number;
  date: dayjs.Dayjs;
}

export class CreateRecurringBookingsHttpRequest implements ICreateRecurringBookingsHttpRequest {
  childrenIds!: number[];
  from!: dayjs.Dayjs;
  to!: dayjs.Dayjs;
  scheduleType!: BookingScheduleType;
  days!: BookingDays[];
  excludedDates?: BookingDate3[] | undefined;
  ageViolationReasons?: AgeViolationReason2[] | undefined;

  constructor(data?: ICreateRecurringBookingsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenIds = [];
      this.days = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["childrenIds"])) {
        this.childrenIds = [] as any;
        for (let item of _data["childrenIds"]) this.childrenIds!.push(item);
      }
      this.from = _data["from"] ? dayjs(_data["from"].toString()) : (undefined as any);
      this.to = _data["to"] ? dayjs(_data["to"].toString()) : (undefined as any);
      this.scheduleType = _data["scheduleType"];
      if (Array.isArray(_data["days"])) {
        this.days = [] as any;
        for (let item of _data["days"]) this.days!.push(BookingDays.fromJS(item));
      }
      if (Array.isArray(_data["excludedDates"])) {
        this.excludedDates = [] as any;
        for (let item of _data["excludedDates"]) this.excludedDates!.push(BookingDate3.fromJS(item));
      }
      if (Array.isArray(_data["ageViolationReasons"])) {
        this.ageViolationReasons = [] as any;
        for (let item of _data["ageViolationReasons"]) this.ageViolationReasons!.push(AgeViolationReason2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateRecurringBookingsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateRecurringBookingsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.childrenIds)) {
      data["childrenIds"] = [];
      for (let item of this.childrenIds) data["childrenIds"].push(item);
    }
    data["from"] = this.from ? this.from.toISOString() : (undefined as any);
    data["to"] = this.to ? this.to.toISOString() : (undefined as any);
    data["scheduleType"] = this.scheduleType;
    if (Array.isArray(this.days)) {
      data["days"] = [];
      for (let item of this.days) data["days"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.excludedDates)) {
      data["excludedDates"] = [];
      for (let item of this.excludedDates) data["excludedDates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.ageViolationReasons)) {
      data["ageViolationReasons"] = [];
      for (let item of this.ageViolationReasons)
        data["ageViolationReasons"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateRecurringBookingsHttpRequest {
  childrenIds: number[];
  from: dayjs.Dayjs;
  to: dayjs.Dayjs;
  scheduleType: BookingScheduleType;
  days: BookingDays[];
  excludedDates?: BookingDate3[] | undefined;
  ageViolationReasons?: AgeViolationReason2[] | undefined;
}

export class BookingDays implements IBookingDays {
  rollId!: number;
  week1!: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;

  constructor(data?: IBookingDays) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.week1 = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      if (Array.isArray(_data["week1"])) {
        this.week1 = [] as any;
        for (let item of _data["week1"]) this.week1!.push(item);
      }
      if (Array.isArray(_data["week2"])) {
        this.week2 = [] as any;
        for (let item of _data["week2"]) this.week2!.push(item);
      }
    }
  }

  static fromJS(data: any): BookingDays {
    data = typeof data === "object" ? data : {};
    let result = new BookingDays();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    if (Array.isArray(this.week1)) {
      data["week1"] = [];
      for (let item of this.week1) data["week1"].push(item);
    }
    if (Array.isArray(this.week2)) {
      data["week2"] = [];
      for (let item of this.week2) data["week2"].push(item);
    }
    return data;
  }
}

export interface IBookingDays {
  rollId: number;
  week1: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;
}

export enum DayOfWeek {
  Sunday = "sunday",
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
}

export class BookingDate3 implements IBookingDate3 {
  rollId!: number;
  date!: dayjs.Dayjs;

  constructor(data?: IBookingDate3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): BookingDate3 {
    data = typeof data === "object" ? data : {};
    let result = new BookingDate3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    return data;
  }
}

export interface IBookingDate3 {
  rollId: number;
  date: dayjs.Dayjs;
}

export class AgeViolationReason2 implements IAgeViolationReason2 {
  childId!: number;
  rollId!: number;
  reason!: string;

  constructor(data?: IAgeViolationReason2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): AgeViolationReason2 {
    data = typeof data === "object" ? data : {};
    let result = new AgeViolationReason2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["reason"] = this.reason;
    return data;
  }
}

export interface IAgeViolationReason2 {
  childId: number;
  rollId: number;
  reason: string;
}

export class CreateRecurringBookingsForAllAvailableDatesHttpRequest
  implements ICreateRecurringBookingsForAllAvailableDatesHttpRequest
{
  childrenIds!: number[];
  from!: dayjs.Dayjs;
  to!: dayjs.Dayjs;
  scheduleType!: BookingScheduleType;
  days!: BookingDays2[];
  ageViolationReasons?: AgeViolationReason3[] | undefined;

  constructor(data?: ICreateRecurringBookingsForAllAvailableDatesHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenIds = [];
      this.days = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["childrenIds"])) {
        this.childrenIds = [] as any;
        for (let item of _data["childrenIds"]) this.childrenIds!.push(item);
      }
      this.from = _data["from"] ? dayjs(_data["from"].toString()) : (undefined as any);
      this.to = _data["to"] ? dayjs(_data["to"].toString()) : (undefined as any);
      this.scheduleType = _data["scheduleType"];
      if (Array.isArray(_data["days"])) {
        this.days = [] as any;
        for (let item of _data["days"]) this.days!.push(BookingDays2.fromJS(item));
      }
      if (Array.isArray(_data["ageViolationReasons"])) {
        this.ageViolationReasons = [] as any;
        for (let item of _data["ageViolationReasons"]) this.ageViolationReasons!.push(AgeViolationReason3.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreateRecurringBookingsForAllAvailableDatesHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateRecurringBookingsForAllAvailableDatesHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.childrenIds)) {
      data["childrenIds"] = [];
      for (let item of this.childrenIds) data["childrenIds"].push(item);
    }
    data["from"] = this.from ? this.from.toISOString() : (undefined as any);
    data["to"] = this.to ? this.to.toISOString() : (undefined as any);
    data["scheduleType"] = this.scheduleType;
    if (Array.isArray(this.days)) {
      data["days"] = [];
      for (let item of this.days) data["days"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.ageViolationReasons)) {
      data["ageViolationReasons"] = [];
      for (let item of this.ageViolationReasons)
        data["ageViolationReasons"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreateRecurringBookingsForAllAvailableDatesHttpRequest {
  childrenIds: number[];
  from: dayjs.Dayjs;
  to: dayjs.Dayjs;
  scheduleType: BookingScheduleType;
  days: BookingDays2[];
  ageViolationReasons?: AgeViolationReason3[] | undefined;
}

export class BookingDays2 implements IBookingDays2 {
  rollId!: number;
  week1!: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;

  constructor(data?: IBookingDays2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.week1 = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      if (Array.isArray(_data["week1"])) {
        this.week1 = [] as any;
        for (let item of _data["week1"]) this.week1!.push(item);
      }
      if (Array.isArray(_data["week2"])) {
        this.week2 = [] as any;
        for (let item of _data["week2"]) this.week2!.push(item);
      }
    }
  }

  static fromJS(data: any): BookingDays2 {
    data = typeof data === "object" ? data : {};
    let result = new BookingDays2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    if (Array.isArray(this.week1)) {
      data["week1"] = [];
      for (let item of this.week1) data["week1"].push(item);
    }
    if (Array.isArray(this.week2)) {
      data["week2"] = [];
      for (let item of this.week2) data["week2"].push(item);
    }
    return data;
  }
}

export interface IBookingDays2 {
  rollId: number;
  week1: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;
}

export class AgeViolationReason3 implements IAgeViolationReason3 {
  childId!: number;
  rollId!: number;
  reason!: string;

  constructor(data?: IAgeViolationReason3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): AgeViolationReason3 {
    data = typeof data === "object" ? data : {};
    let result = new AgeViolationReason3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["reason"] = this.reason;
    return data;
  }
}

export interface IAgeViolationReason3 {
  childId: number;
  rollId: number;
  reason: string;
}

export class GetCreateRecurringBookingsPreviewHttpResponse implements IGetCreateRecurringBookingsPreviewHttpResponse {
  bookings!: BookingInfo2[];

  constructor(data?: IGetCreateRecurringBookingsPreviewHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bookings = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["bookings"])) {
        this.bookings = [] as any;
        for (let item of _data["bookings"]) this.bookings!.push(BookingInfo2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetCreateRecurringBookingsPreviewHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetCreateRecurringBookingsPreviewHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.bookings)) {
      data["bookings"] = [];
      for (let item of this.bookings) data["bookings"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetCreateRecurringBookingsPreviewHttpResponse {
  bookings: BookingInfo2[];
}

export class BookingInfo2 implements IBookingInfo2 {
  rollId!: number;
  childId!: number;
  date!: dayjs.Dayjs;
  status!: BookingStatus2;
  fee!: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount!: number;

  constructor(data?: IBookingInfo2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.childId = _data["childId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.status = _data["status"];
      this.fee = _data["fee"];
      this.feeType = _data["feeType"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): BookingInfo2 {
    data = typeof data === "object" ? data : {};
    let result = new BookingInfo2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["childId"] = this.childId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["status"] = this.status;
    data["fee"] = this.fee;
    data["feeType"] = this.feeType;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IBookingInfo2 {
  rollId: number;
  childId: number;
  date: dayjs.Dayjs;
  status: BookingStatus2;
  fee: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount: number;
}

export enum BookingStatus2 {
  New = "new",
  Existing = "existing",
}

export class ChangeRecurringBookingHttpRequest implements IChangeRecurringBookingHttpRequest {
  from!: dayjs.Dayjs;
  to!: dayjs.Dayjs;
  days!: BookingDays3;
  excludedDates?: dayjs.Dayjs[] | undefined;
  ageViolationReason?: string | undefined;

  constructor(data?: IChangeRecurringBookingHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.days = new BookingDays3();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data["from"] ? dayjs(_data["from"].toString()) : (undefined as any);
      this.to = _data["to"] ? dayjs(_data["to"].toString()) : (undefined as any);
      this.days = _data["days"] ? BookingDays3.fromJS(_data["days"]) : new BookingDays3();
      if (Array.isArray(_data["excludedDates"])) {
        this.excludedDates = [] as any;
        for (let item of _data["excludedDates"]) this.excludedDates!.push(dayjs(item));
      }
      this.ageViolationReason = _data["ageViolationReason"];
    }
  }

  static fromJS(data: any): ChangeRecurringBookingHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangeRecurringBookingHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["from"] = this.from ? this.from.toISOString() : (undefined as any);
    data["to"] = this.to ? this.to.toISOString() : (undefined as any);
    data["days"] = this.days ? this.days.toJSON() : (undefined as any);
    if (Array.isArray(this.excludedDates)) {
      data["excludedDates"] = [];
      for (let item of this.excludedDates) data["excludedDates"].push(item.toISOString());
    }
    data["ageViolationReason"] = this.ageViolationReason;
    return data;
  }
}

export interface IChangeRecurringBookingHttpRequest {
  from: dayjs.Dayjs;
  to: dayjs.Dayjs;
  days: BookingDays3;
  excludedDates?: dayjs.Dayjs[] | undefined;
  ageViolationReason?: string | undefined;
}

export class BookingDays3 implements IBookingDays3 {
  week1!: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;

  constructor(data?: IBookingDays3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.week1 = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["week1"])) {
        this.week1 = [] as any;
        for (let item of _data["week1"]) this.week1!.push(item);
      }
      if (Array.isArray(_data["week2"])) {
        this.week2 = [] as any;
        for (let item of _data["week2"]) this.week2!.push(item);
      }
    }
  }

  static fromJS(data: any): BookingDays3 {
    data = typeof data === "object" ? data : {};
    let result = new BookingDays3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.week1)) {
      data["week1"] = [];
      for (let item of this.week1) data["week1"].push(item);
    }
    if (Array.isArray(this.week2)) {
      data["week2"] = [];
      for (let item of this.week2) data["week2"].push(item);
    }
    return data;
  }
}

export interface IBookingDays3 {
  week1: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;
}

export class GetChangeRecurringBookingPreviewHttpResponse implements IGetChangeRecurringBookingPreviewHttpResponse {
  minBookingsRequired!: number;
  chargedBookingsCount!: number;
  bookings!: BookingInfo3[];

  constructor(data?: IGetChangeRecurringBookingPreviewHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bookings = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minBookingsRequired = _data["minBookingsRequired"];
      this.chargedBookingsCount = _data["chargedBookingsCount"];
      if (Array.isArray(_data["bookings"])) {
        this.bookings = [] as any;
        for (let item of _data["bookings"]) this.bookings!.push(BookingInfo3.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetChangeRecurringBookingPreviewHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetChangeRecurringBookingPreviewHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["minBookingsRequired"] = this.minBookingsRequired;
    data["chargedBookingsCount"] = this.chargedBookingsCount;
    if (Array.isArray(this.bookings)) {
      data["bookings"] = [];
      for (let item of this.bookings) data["bookings"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetChangeRecurringBookingPreviewHttpResponse {
  minBookingsRequired: number;
  chargedBookingsCount: number;
  bookings: BookingInfo3[];
}

export class BookingInfo3 implements IBookingInfo3 {
  rollId!: number;
  date!: dayjs.Dayjs;
  status!: BookingStatus3;
  fee!: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount!: number;

  constructor(data?: IBookingInfo3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.status = _data["status"];
      this.fee = _data["fee"];
      this.feeType = _data["feeType"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): BookingInfo3 {
    data = typeof data === "object" ? data : {};
    let result = new BookingInfo3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["status"] = this.status;
    data["fee"] = this.fee;
    data["feeType"] = this.feeType;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IBookingInfo3 {
  rollId: number;
  date: dayjs.Dayjs;
  status: BookingStatus3;
  fee: number;
  feeType?: FeeType | undefined;
  multiChildrenDiscount: number;
}

export enum BookingStatus3 {
  New = "new",
  Existing = "existing",
  CancelledInTime = "cancelledInTime",
  CancelledInTimeAsHot = "cancelledInTimeAsHot",
  CancelledInNoticePeriod = "cancelledInNoticePeriod",
}

export class GetChangeRecurringBookingPreviewHttpRequest implements IGetChangeRecurringBookingPreviewHttpRequest {
  from!: dayjs.Dayjs;
  to!: dayjs.Dayjs;
  days!: BookingDays4;
  excludedDates?: dayjs.Dayjs[] | undefined;

  constructor(data?: IGetChangeRecurringBookingPreviewHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.days = new BookingDays4();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data["from"] ? dayjs(_data["from"].toString()) : (undefined as any);
      this.to = _data["to"] ? dayjs(_data["to"].toString()) : (undefined as any);
      this.days = _data["days"] ? BookingDays4.fromJS(_data["days"]) : new BookingDays4();
      if (Array.isArray(_data["excludedDates"])) {
        this.excludedDates = [] as any;
        for (let item of _data["excludedDates"]) this.excludedDates!.push(dayjs(item));
      }
    }
  }

  static fromJS(data: any): GetChangeRecurringBookingPreviewHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetChangeRecurringBookingPreviewHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["from"] = this.from ? this.from.toISOString() : (undefined as any);
    data["to"] = this.to ? this.to.toISOString() : (undefined as any);
    data["days"] = this.days ? this.days.toJSON() : (undefined as any);
    if (Array.isArray(this.excludedDates)) {
      data["excludedDates"] = [];
      for (let item of this.excludedDates) data["excludedDates"].push(item.toISOString());
    }
    return data;
  }
}

export interface IGetChangeRecurringBookingPreviewHttpRequest {
  from: dayjs.Dayjs;
  to: dayjs.Dayjs;
  days: BookingDays4;
  excludedDates?: dayjs.Dayjs[] | undefined;
}

export class BookingDays4 implements IBookingDays4 {
  week1!: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;

  constructor(data?: IBookingDays4) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.week1 = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["week1"])) {
        this.week1 = [] as any;
        for (let item of _data["week1"]) this.week1!.push(item);
      }
      if (Array.isArray(_data["week2"])) {
        this.week2 = [] as any;
        for (let item of _data["week2"]) this.week2!.push(item);
      }
    }
  }

  static fromJS(data: any): BookingDays4 {
    data = typeof data === "object" ? data : {};
    let result = new BookingDays4();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.week1)) {
      data["week1"] = [];
      for (let item of this.week1) data["week1"].push(item);
    }
    if (Array.isArray(this.week2)) {
      data["week2"] = [];
      for (let item of this.week2) data["week2"].push(item);
    }
    return data;
  }
}

export interface IBookingDays4 {
  week1: DayOfWeek[];
  week2?: DayOfWeek[] | undefined;
}

export class CancelBookingReasonHttpRequest implements ICancelBookingReasonHttpRequest {
  reasonId!: number;
  otherReasonText?: string | undefined;

  constructor(data?: ICancelBookingReasonHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reasonId = _data["reasonId"];
      this.otherReasonText = _data["otherReasonText"];
    }
  }

  static fromJS(data: any): CancelBookingReasonHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CancelBookingReasonHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reasonId"] = this.reasonId;
    data["otherReasonText"] = this.otherReasonText;
    return data;
  }
}

export interface ICancelBookingReasonHttpRequest {
  reasonId: number;
  otherReasonText?: string | undefined;
}

export class BookingToCancel implements IBookingToCancel {
  uniqueId!: string;
  childId!: number;
  rollId!: number;
  date!: dayjs.Dayjs;
  sessionStartTime!: dayjs.Dayjs;
  cancellationStatusId!: number;
  originalCancellationStatusId!: number;
  cancelledInTimeCutoffServerTime!: dayjs.Dayjs;
  feeAmount!: number;
  createdAt!: dayjs.Dayjs;
  isHotCancellation!: boolean;
  feeType!: FeeType;

  constructor(data?: IBookingToCancel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.sessionStartTime = _data["sessionStartTime"]
        ? dayjs(_data["sessionStartTime"].toString())
        : (undefined as any);
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.originalCancellationStatusId = _data["originalCancellationStatusId"];
      this.cancelledInTimeCutoffServerTime = _data["cancelledInTimeCutoffServerTime"]
        ? dayjs(_data["cancelledInTimeCutoffServerTime"].toString())
        : (undefined as any);
      this.feeAmount = _data["feeAmount"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.isHotCancellation = _data["isHotCancellation"];
      this.feeType = _data["feeType"];
    }
  }

  static fromJS(data: any): BookingToCancel {
    data = typeof data === "object" ? data : {};
    let result = new BookingToCancel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["sessionStartTime"] = this.sessionStartTime
      ? this.sessionStartTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["originalCancellationStatusId"] = this.originalCancellationStatusId;
    data["cancelledInTimeCutoffServerTime"] = this.cancelledInTimeCutoffServerTime
      ? this.cancelledInTimeCutoffServerTime.toISOString()
      : (undefined as any);
    data["feeAmount"] = this.feeAmount;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["isHotCancellation"] = this.isHotCancellation;
    data["feeType"] = this.feeType;
    return data;
  }
}

export interface IBookingToCancel {
  uniqueId: string;
  childId: number;
  rollId: number;
  date: dayjs.Dayjs;
  sessionStartTime: dayjs.Dayjs;
  cancellationStatusId: number;
  originalCancellationStatusId: number;
  cancelledInTimeCutoffServerTime: dayjs.Dayjs;
  feeAmount: number;
  createdAt: dayjs.Dayjs;
  isHotCancellation: boolean;
  feeType: FeeType;
}

export class BookingCancellationReason implements IBookingCancellationReason {
  bookingCancellationReasonId!: number;
  name!: string;

  constructor(data?: IBookingCancellationReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingCancellationReasonId = _data["bookingCancellationReasonId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): BookingCancellationReason {
    data = typeof data === "object" ? data : {};
    let result = new BookingCancellationReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingCancellationReasonId"] = this.bookingCancellationReasonId;
    data["name"] = this.name;
    return data;
  }
}

export interface IBookingCancellationReason {
  bookingCancellationReasonId: number;
  name: string;
}

export class PageableObjectOfBookingHttpResponse implements IPageableObjectOfBookingHttpResponse {
  records!: BookingHttpResponse[];
  total!: number;

  constructor(data?: IPageableObjectOfBookingHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.records = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["records"])) {
        this.records = [] as any;
        for (let item of _data["records"]) this.records!.push(BookingHttpResponse.fromJS(item));
      }
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): PageableObjectOfBookingHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new PageableObjectOfBookingHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.records)) {
      data["records"] = [];
      for (let item of this.records) data["records"].push(item ? item.toJSON() : (undefined as any));
    }
    data["total"] = this.total;
    return data;
  }
}

export interface IPageableObjectOfBookingHttpResponse {
  records: BookingHttpResponse[];
  total: number;
}

export class BookingScheduleSummary implements IBookingScheduleSummary {
  uniqueId!: string;
  createdAt!: dayjs.Dayjs;
  bookingScheduleId!: number;
  effectiveFromDate!: dayjs.Dayjs;
  effectiveToDate?: dayjs.Dayjs | undefined;
  secondMonday!: boolean;
  secondTuesday!: boolean;
  secondWednesday!: boolean;
  secondThursday!: boolean;
  secondFriday!: boolean;
  customerAccountId!: number;
  rollId!: number;
  childId!: number;
  firstMonday!: boolean;
  firstTuesday!: boolean;
  firstWednesday!: boolean;
  firstThursday!: boolean;
  firstFriday!: boolean;
  scheduleTypeId!: number;
  childFirstName!: string;
  childLastName!: string;
  rollName?: string | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  serviceId?: number | undefined;
  serviceName?: string | undefined;
  minBookingsRequired!: number;
  totalBookings!: number;

  constructor(data?: IBookingScheduleSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.bookingScheduleId = _data["bookingScheduleId"];
      this.effectiveFromDate = _data["effectiveFromDate"]
        ? dayjs(_data["effectiveFromDate"].toString())
        : (undefined as any);
      this.effectiveToDate = _data["effectiveToDate"] ? dayjs(_data["effectiveToDate"].toString()) : (undefined as any);
      this.secondMonday = _data["secondMonday"];
      this.secondTuesday = _data["secondTuesday"];
      this.secondWednesday = _data["secondWednesday"];
      this.secondThursday = _data["secondThursday"];
      this.secondFriday = _data["secondFriday"];
      this.customerAccountId = _data["customerAccountId"];
      this.rollId = _data["rollId"];
      this.childId = _data["childId"];
      this.firstMonday = _data["firstMonday"];
      this.firstTuesday = _data["firstTuesday"];
      this.firstWednesday = _data["firstWednesday"];
      this.firstThursday = _data["firstThursday"];
      this.firstFriday = _data["firstFriday"];
      this.scheduleTypeId = _data["scheduleTypeId"];
      this.childFirstName = _data["childFirstName"];
      this.childLastName = _data["childLastName"];
      this.rollName = _data["rollName"];
      this.sessionType = _data["sessionType"];
      this.sessionSubType = _data["sessionSubType"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.minBookingsRequired = _data["minBookingsRequired"];
      this.totalBookings = _data["totalBookings"];
    }
  }

  static fromJS(data: any): BookingScheduleSummary {
    data = typeof data === "object" ? data : {};
    let result = new BookingScheduleSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["bookingScheduleId"] = this.bookingScheduleId;
    data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : (undefined as any);
    data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : (undefined as any);
    data["secondMonday"] = this.secondMonday;
    data["secondTuesday"] = this.secondTuesday;
    data["secondWednesday"] = this.secondWednesday;
    data["secondThursday"] = this.secondThursday;
    data["secondFriday"] = this.secondFriday;
    data["customerAccountId"] = this.customerAccountId;
    data["rollId"] = this.rollId;
    data["childId"] = this.childId;
    data["firstMonday"] = this.firstMonday;
    data["firstTuesday"] = this.firstTuesday;
    data["firstWednesday"] = this.firstWednesday;
    data["firstThursday"] = this.firstThursday;
    data["firstFriday"] = this.firstFriday;
    data["scheduleTypeId"] = this.scheduleTypeId;
    data["childFirstName"] = this.childFirstName;
    data["childLastName"] = this.childLastName;
    data["rollName"] = this.rollName;
    data["sessionType"] = this.sessionType;
    data["sessionSubType"] = this.sessionSubType;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["minBookingsRequired"] = this.minBookingsRequired;
    data["totalBookings"] = this.totalBookings;
    return data;
  }
}

export interface IBookingScheduleSummary {
  uniqueId: string;
  createdAt: dayjs.Dayjs;
  bookingScheduleId: number;
  effectiveFromDate: dayjs.Dayjs;
  effectiveToDate?: dayjs.Dayjs | undefined;
  secondMonday: boolean;
  secondTuesday: boolean;
  secondWednesday: boolean;
  secondThursday: boolean;
  secondFriday: boolean;
  customerAccountId: number;
  rollId: number;
  childId: number;
  firstMonday: boolean;
  firstTuesday: boolean;
  firstWednesday: boolean;
  firstThursday: boolean;
  firstFriday: boolean;
  scheduleTypeId: number;
  childFirstName: string;
  childLastName: string;
  rollName?: string | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  serviceId?: number | undefined;
  serviceName?: string | undefined;
  minBookingsRequired: number;
  totalBookings: number;
}

export class BootstrapHttpResponse implements IBootstrapHttpResponse {
  accountStatus!: AccountStatus;
  accounts!: BootstrapAccountEntry[];

  constructor(data?: IBootstrapHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.accounts = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountStatus = _data["accountStatus"];
      if (Array.isArray(_data["accounts"])) {
        this.accounts = [] as any;
        for (let item of _data["accounts"]) this.accounts!.push(BootstrapAccountEntry.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BootstrapHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new BootstrapHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accountStatus"] = this.accountStatus;
    if (Array.isArray(this.accounts)) {
      data["accounts"] = [];
      for (let item of this.accounts) data["accounts"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IBootstrapHttpResponse {
  accountStatus: AccountStatus;
  accounts: BootstrapAccountEntry[];
}

export enum AccountStatus {
  Active = "active",
  Inactive = "inactive",
  Deleted = "deleted",
  NoMatchingContact = "noMatchingContact",
  Unknown = "unknown",
}

export class BootstrapAccountEntry implements IBootstrapAccountEntry {
  customerAccountId!: number;
  customerContactId?: number | undefined;
  status!: AccountStatus;

  constructor(data?: IBootstrapAccountEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerAccountId = _data["customerAccountId"];
      this.customerContactId = _data["customerContactId"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): BootstrapAccountEntry {
    data = typeof data === "object" ? data : {};
    let result = new BootstrapAccountEntry();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerAccountId"] = this.customerAccountId;
    data["customerContactId"] = this.customerContactId;
    data["status"] = this.status;
    return data;
  }
}

export interface IBootstrapAccountEntry {
  customerAccountId: number;
  customerContactId?: number | undefined;
  status: AccountStatus;
}

export class ChildHttpResponse implements IChildHttpResponse {
  childId!: number;
  customerAccountId!: number;
  crn?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  birthday!: dayjs.Dayjs;
  genderId!: number;
  otherGender?: string | undefined;
  residentialAddress?: AddressHttpResponse | undefined;
  schoolId?: number | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage!: string;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  ambulanceNumber?: string | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  otherMedicalCondition?: string | undefined;
  priorityAccessId?: number | undefined;
  schoolName?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: string[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  childSuspensionEndDate?: dayjs.Dayjs | undefined;
  childSuspensionReasonId?: number | undefined;
  isSuspended!: boolean;
  ageExemptionExpiryDate?: dayjs.Dayjs | undefined;
  serviceId?: number | undefined;
  serviceName?: string | undefined;
  acknowledgedStatus?: boolean | undefined;
  childBookingStatus?: ChildBookingStatusHttpResponse | undefined;
  answers?: AnswerHttpResponse[] | undefined;
  approvedMedicalConditions!: number[];
  childServices!: ChildServiceHttpResponse[];

  constructor(data?: IChildHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.approvedMedicalConditions = [];
      this.childServices = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.customerAccountId = _data["customerAccountId"];
      this.crn = _data["crn"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
      this.residentialAddress = _data["residentialAddress"]
        ? AddressHttpResponse.fromJS(_data["residentialAddress"])
        : (undefined as any);
      this.schoolId = _data["schoolId"];
      this.homePhone = _data["homePhone"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.indigenousStatus = _data["indigenousStatus"];
      this.dietaryRequirements = _data["dietaryRequirements"];
      this.specialNeeds = _data["specialNeeds"];
      this.educationNeeds = _data["educationNeeds"];
      this.behaviouralNeeds = _data["behaviouralNeeds"];
      this.physicalNeeds = _data["physicalNeeds"];
      this.medicalNeeds = _data["medicalNeeds"];
      this.disability = _data["disability"];
      this.allergies = _data["allergies"];
      this.anaphylaxisProblem = _data["anaphylaxisProblem"];
      this.anaphylaxisSeverity = _data["anaphylaxisSeverity"];
      this.anaphylaxisType = _data["anaphylaxisType"];
      this.anaphylaxisTreatment = _data["anaphylaxisTreatment"];
      this.medicalServiceName = _data["medicalServiceName"];
      this.doctorName = _data["doctorName"];
      this.doctorAddress = _data["doctorAddress"];
      this.doctorPhone = _data["doctorPhone"];
      this.ambulanceNumber = _data["ambulanceNumber"];
      this.avatarIndex = _data["avatarIndex"];
      this.medicareNumber = _data["medicareNumber"];
      this.otherMedicalCondition = _data["otherMedicalCondition"];
      this.priorityAccessId = _data["priorityAccessId"];
      this.schoolName = _data["schoolName"];
      this.hasBeenImmunised = _data["hasBeenImmunised"];
      this.hasMedicalConditions = _data["hasMedicalConditions"];
      this.hasPhysicalNeeds = _data["hasPhysicalNeeds"];
      this.hasBehaviouralNeeds = _data["hasBehaviouralNeeds"];
      this.hasSpecialNeeds = _data["hasSpecialNeeds"];
      this.hasDietaryRequirements = _data["hasDietaryRequirements"];
      if (Array.isArray(_data["medicalConditions"])) {
        this.medicalConditions = [] as any;
        for (let item of _data["medicalConditions"]) this.medicalConditions!.push(item);
      }
      if (Array.isArray(_data["medicalConditionDetails"])) {
        this.medicalConditionDetails = [] as any;
        for (let item of _data["medicalConditionDetails"]) this.medicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["noMedicalConditionDetails"])) {
        this.noMedicalConditionDetails = [] as any;
        for (let item of _data["noMedicalConditionDetails"]) this.noMedicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["childSituations"])) {
        this.childSituations = [] as any;
        for (let item of _data["childSituations"]) this.childSituations!.push(item);
      }
      this.allowAdministerMedicine = _data["allowAdministerMedicine"];
      this.allowAmbulanceTransportation = _data["allowAmbulanceTransportation"];
      this.allowMedicalTreatment = _data["allowMedicalTreatment"];
      this.allowTakeOutside = _data["allowTakeOutside"];
      this.childSuspensionEndDate = _data["childSuspensionEndDate"]
        ? dayjs(_data["childSuspensionEndDate"].toString())
        : (undefined as any);
      this.childSuspensionReasonId = _data["childSuspensionReasonId"];
      this.isSuspended = _data["isSuspended"];
      this.ageExemptionExpiryDate = _data["ageExemptionExpiryDate"]
        ? dayjs(_data["ageExemptionExpiryDate"].toString())
        : (undefined as any);
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.acknowledgedStatus = _data["acknowledgedStatus"];
      this.childBookingStatus = _data["childBookingStatus"];
      if (Array.isArray(_data["answers"])) {
        this.answers = [] as any;
        for (let item of _data["answers"]) this.answers!.push(AnswerHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["approvedMedicalConditions"])) {
        this.approvedMedicalConditions = [] as any;
        for (let item of _data["approvedMedicalConditions"]) this.approvedMedicalConditions!.push(item);
      }
      if (Array.isArray(_data["childServices"])) {
        this.childServices = [] as any;
        for (let item of _data["childServices"]) this.childServices!.push(ChildServiceHttpResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ChildHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ChildHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["customerAccountId"] = this.customerAccountId;
    data["crn"] = this.crn;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["birthday"] = this.birthday ? this.birthday.format("YYYY-MM-DD") : (undefined as any);
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["schoolId"] = this.schoolId;
    data["homePhone"] = this.homePhone;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["indigenousStatus"] = this.indigenousStatus;
    data["dietaryRequirements"] = this.dietaryRequirements;
    data["specialNeeds"] = this.specialNeeds;
    data["educationNeeds"] = this.educationNeeds;
    data["behaviouralNeeds"] = this.behaviouralNeeds;
    data["physicalNeeds"] = this.physicalNeeds;
    data["medicalNeeds"] = this.medicalNeeds;
    data["disability"] = this.disability;
    data["allergies"] = this.allergies;
    data["anaphylaxisProblem"] = this.anaphylaxisProblem;
    data["anaphylaxisSeverity"] = this.anaphylaxisSeverity;
    data["anaphylaxisType"] = this.anaphylaxisType;
    data["anaphylaxisTreatment"] = this.anaphylaxisTreatment;
    data["medicalServiceName"] = this.medicalServiceName;
    data["doctorName"] = this.doctorName;
    data["doctorAddress"] = this.doctorAddress;
    data["doctorPhone"] = this.doctorPhone;
    data["ambulanceNumber"] = this.ambulanceNumber;
    data["avatarIndex"] = this.avatarIndex;
    data["medicareNumber"] = this.medicareNumber;
    data["otherMedicalCondition"] = this.otherMedicalCondition;
    data["priorityAccessId"] = this.priorityAccessId;
    data["schoolName"] = this.schoolName;
    data["hasBeenImmunised"] = this.hasBeenImmunised;
    data["hasMedicalConditions"] = this.hasMedicalConditions;
    data["hasPhysicalNeeds"] = this.hasPhysicalNeeds;
    data["hasBehaviouralNeeds"] = this.hasBehaviouralNeeds;
    data["hasSpecialNeeds"] = this.hasSpecialNeeds;
    data["hasDietaryRequirements"] = this.hasDietaryRequirements;
    if (Array.isArray(this.medicalConditions)) {
      data["medicalConditions"] = [];
      for (let item of this.medicalConditions) data["medicalConditions"].push(item);
    }
    if (Array.isArray(this.medicalConditionDetails)) {
      data["medicalConditionDetails"] = [];
      for (let item of this.medicalConditionDetails) data["medicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.noMedicalConditionDetails)) {
      data["noMedicalConditionDetails"] = [];
      for (let item of this.noMedicalConditionDetails) data["noMedicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.childSituations)) {
      data["childSituations"] = [];
      for (let item of this.childSituations) data["childSituations"].push(item);
    }
    data["allowAdministerMedicine"] = this.allowAdministerMedicine;
    data["allowAmbulanceTransportation"] = this.allowAmbulanceTransportation;
    data["allowMedicalTreatment"] = this.allowMedicalTreatment;
    data["allowTakeOutside"] = this.allowTakeOutside;
    data["childSuspensionEndDate"] = this.childSuspensionEndDate
      ? this.childSuspensionEndDate.format("YYYY-MM-DD")
      : (undefined as any);
    data["childSuspensionReasonId"] = this.childSuspensionReasonId;
    data["isSuspended"] = this.isSuspended;
    data["ageExemptionExpiryDate"] = this.ageExemptionExpiryDate
      ? this.ageExemptionExpiryDate.toISOString()
      : (undefined as any);
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["acknowledgedStatus"] = this.acknowledgedStatus;
    data["childBookingStatus"] = this.childBookingStatus;
    if (Array.isArray(this.answers)) {
      data["answers"] = [];
      for (let item of this.answers) data["answers"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.approvedMedicalConditions)) {
      data["approvedMedicalConditions"] = [];
      for (let item of this.approvedMedicalConditions) data["approvedMedicalConditions"].push(item);
    }
    if (Array.isArray(this.childServices)) {
      data["childServices"] = [];
      for (let item of this.childServices) data["childServices"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IChildHttpResponse {
  childId: number;
  customerAccountId: number;
  crn?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  birthday: dayjs.Dayjs;
  genderId: number;
  otherGender?: string | undefined;
  residentialAddress?: AddressHttpResponse | undefined;
  schoolId?: number | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage: string;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  ambulanceNumber?: string | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  otherMedicalCondition?: string | undefined;
  priorityAccessId?: number | undefined;
  schoolName?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: string[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  childSuspensionEndDate?: dayjs.Dayjs | undefined;
  childSuspensionReasonId?: number | undefined;
  isSuspended: boolean;
  ageExemptionExpiryDate?: dayjs.Dayjs | undefined;
  serviceId?: number | undefined;
  serviceName?: string | undefined;
  acknowledgedStatus?: boolean | undefined;
  childBookingStatus?: ChildBookingStatusHttpResponse | undefined;
  answers?: AnswerHttpResponse[] | undefined;
  approvedMedicalConditions: number[];
  childServices: ChildServiceHttpResponse[];
}

export class AddressHttpResponse implements IAddressHttpResponse {
  uniqueId!: string;
  addressId?: number | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;

  constructor(data?: IAddressHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.addressId = _data["addressId"];
      this.streetLine1 = _data["streetLine1"];
      this.streetLine2 = _data["streetLine2"];
      this.suburb = _data["suburb"];
      this.postCode = _data["postCode"];
      this.state = _data["state"];
      this.country = _data["country"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
    }
  }

  static fromJS(data: any): AddressHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AddressHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["addressId"] = this.addressId;
    data["streetLine1"] = this.streetLine1;
    data["streetLine2"] = this.streetLine2;
    data["suburb"] = this.suburb;
    data["postCode"] = this.postCode;
    data["state"] = this.state;
    data["country"] = this.country;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    return data;
  }
}

export interface IAddressHttpResponse {
  uniqueId: string;
  addressId?: number | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
}

export enum ChildBookingStatusHttpResponse {
  ApprovedForAllServices = "approvedForAllServices",
  BlockedForAllServices = "blockedForAllServices",
  ApprovedForSpecificServices = "approvedForSpecificServices",
  MissingDocumentation = "missingDocumentation",
}

export class AnswerHttpResponse implements IAnswerHttpResponse {
  uniqueId!: string;
  childId!: number;
  questionId!: number;
  conditionId!: number;
  multipleAnswerIndex!: number;
  value?: string | undefined;
  freeText?: string | undefined;

  constructor(data?: IAnswerHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.childId = _data["childId"];
      this.questionId = _data["questionId"];
      this.conditionId = _data["conditionId"];
      this.multipleAnswerIndex = _data["multipleAnswerIndex"];
      this.value = _data["value"];
      this.freeText = _data["freeText"];
    }
  }

  static fromJS(data: any): AnswerHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AnswerHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["childId"] = this.childId;
    data["questionId"] = this.questionId;
    data["conditionId"] = this.conditionId;
    data["multipleAnswerIndex"] = this.multipleAnswerIndex;
    data["value"] = this.value;
    data["freeText"] = this.freeText;
    return data;
  }
}

export interface IAnswerHttpResponse {
  uniqueId: string;
  childId: number;
  questionId: number;
  conditionId: number;
  multipleAnswerIndex: number;
  value?: string | undefined;
  freeText?: string | undefined;
}

export class ChildServiceHttpResponse implements IChildServiceHttpResponse {
  childId!: number;
  status!: ChildServiceStatusHttpResponse;
  serviceId!: number;
  serviceName!: string;

  constructor(data?: IChildServiceHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.status = _data["status"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
    }
  }

  static fromJS(data: any): ChildServiceHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ChildServiceHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["status"] = this.status;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    return data;
  }
}

export interface IChildServiceHttpResponse {
  childId: number;
  status: ChildServiceStatusHttpResponse;
  serviceId: number;
  serviceName: string;
}

export enum ChildServiceStatusHttpResponse {
  BookingsApproved = "bookingsApproved",
  OnHoldAdditionalNeeds = "onHoldAdditionalNeeds",
  OnHoldActionPlanNeeds = "onHoldActionPlanNeeds",
  OnHoldRemoved = "onHoldRemoved",
}

export class ChildBaseHttpRequest implements IChildBaseHttpRequest {
  crn?: string | undefined;
  firstName!: string;
  lastName!: string;
  birthday!: dayjs.Dayjs;
  genderId!: number;
  otherGender?: string | undefined;
  schoolId!: number;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  sameSchoolDetailsAsFirstChild?: boolean | undefined;
  residentialAddress!: CreateAddressHttpRequest;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: string[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild?: boolean | undefined;
  sameMedicalContactAsFirstChild?: boolean | undefined;
  otherMedicalCondition?: string | undefined;
  documentIdsAdded?: string[] | undefined;
  documentIdsDeleted?: string[] | undefined;
  answers?: AnswerHttpRequest[] | undefined;
  acknowledgedStatus?: boolean | undefined;
  authorization?: ParentAuthorizationHttpRequest | undefined;

  constructor(data?: IChildBaseHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.residentialAddress = new CreateAddressHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.crn = _data["crn"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
      this.schoolId = _data["schoolId"];
      this.homePhone = _data["homePhone"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.sameAddressDetailsAsPrimary = _data["sameAddressDetailsAsPrimary"];
      this.sameCulturalDetailsAsPrimary = _data["sameCulturalDetailsAsPrimary"];
      this.sameSchoolDetailsAsFirstChild = _data["sameSchoolDetailsAsFirstChild"];
      this.residentialAddress = _data["residentialAddress"]
        ? CreateAddressHttpRequest.fromJS(_data["residentialAddress"])
        : new CreateAddressHttpRequest();
      this.indigenousStatus = _data["indigenousStatus"];
      this.dietaryRequirements = _data["dietaryRequirements"];
      this.specialNeeds = _data["specialNeeds"];
      this.educationNeeds = _data["educationNeeds"];
      this.behaviouralNeeds = _data["behaviouralNeeds"];
      this.physicalNeeds = _data["physicalNeeds"];
      this.medicalNeeds = _data["medicalNeeds"];
      this.disability = _data["disability"];
      this.allergies = _data["allergies"];
      this.anaphylaxisProblem = _data["anaphylaxisProblem"];
      this.anaphylaxisSeverity = _data["anaphylaxisSeverity"];
      this.anaphylaxisType = _data["anaphylaxisType"];
      this.anaphylaxisTreatment = _data["anaphylaxisTreatment"];
      this.medicalServiceName = _data["medicalServiceName"];
      this.doctorName = _data["doctorName"];
      this.doctorAddress = _data["doctorAddress"];
      this.doctorPhone = _data["doctorPhone"];
      this.doctorSuburb = _data["doctorSuburb"];
      this.doctorState = _data["doctorState"];
      this.doctorPostcode = _data["doctorPostcode"];
      this.ambulanceNumber = _data["ambulanceNumber"];
      this.hasBeenImmunised = _data["hasBeenImmunised"];
      this.hasMedicalConditions = _data["hasMedicalConditions"];
      this.hasPhysicalNeeds = _data["hasPhysicalNeeds"];
      this.hasBehaviouralNeeds = _data["hasBehaviouralNeeds"];
      this.hasSpecialNeeds = _data["hasSpecialNeeds"];
      this.hasDietaryRequirements = _data["hasDietaryRequirements"];
      if (Array.isArray(_data["medicalConditions"])) {
        this.medicalConditions = [] as any;
        for (let item of _data["medicalConditions"]) this.medicalConditions!.push(item);
      }
      if (Array.isArray(_data["medicalConditionDetails"])) {
        this.medicalConditionDetails = [] as any;
        for (let item of _data["medicalConditionDetails"]) this.medicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["noMedicalConditionDetails"])) {
        this.noMedicalConditionDetails = [] as any;
        for (let item of _data["noMedicalConditionDetails"]) this.noMedicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["childSituations"])) {
        this.childSituations = [] as any;
        for (let item of _data["childSituations"]) this.childSituations!.push(item);
      }
      this.allowAdministerMedicine = _data["allowAdministerMedicine"];
      this.allowAmbulanceTransportation = _data["allowAmbulanceTransportation"];
      this.allowMedicalTreatment = _data["allowMedicalTreatment"];
      this.allowTakeOutside = _data["allowTakeOutside"];
      this.priorityAccessId = _data["priorityAccessId"];
      this.avatarIndex = _data["avatarIndex"];
      this.medicareNumber = _data["medicareNumber"];
      this.sameLivingCareAsFirstChild = _data["sameLivingCareAsFirstChild"];
      this.sameMedicalContactAsFirstChild = _data["sameMedicalContactAsFirstChild"];
      this.otherMedicalCondition = _data["otherMedicalCondition"];
      if (Array.isArray(_data["documentIdsAdded"])) {
        this.documentIdsAdded = [] as any;
        for (let item of _data["documentIdsAdded"]) this.documentIdsAdded!.push(item);
      }
      if (Array.isArray(_data["documentIdsDeleted"])) {
        this.documentIdsDeleted = [] as any;
        for (let item of _data["documentIdsDeleted"]) this.documentIdsDeleted!.push(item);
      }
      if (Array.isArray(_data["answers"])) {
        this.answers = [] as any;
        for (let item of _data["answers"]) this.answers!.push(AnswerHttpRequest.fromJS(item));
      }
      this.acknowledgedStatus = _data["acknowledgedStatus"];
      this.authorization = _data["authorization"]
        ? ParentAuthorizationHttpRequest.fromJS(_data["authorization"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): ChildBaseHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChildBaseHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["crn"] = this.crn;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    data["schoolId"] = this.schoolId;
    data["homePhone"] = this.homePhone;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["sameAddressDetailsAsPrimary"] = this.sameAddressDetailsAsPrimary;
    data["sameCulturalDetailsAsPrimary"] = this.sameCulturalDetailsAsPrimary;
    data["sameSchoolDetailsAsFirstChild"] = this.sameSchoolDetailsAsFirstChild;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["indigenousStatus"] = this.indigenousStatus;
    data["dietaryRequirements"] = this.dietaryRequirements;
    data["specialNeeds"] = this.specialNeeds;
    data["educationNeeds"] = this.educationNeeds;
    data["behaviouralNeeds"] = this.behaviouralNeeds;
    data["physicalNeeds"] = this.physicalNeeds;
    data["medicalNeeds"] = this.medicalNeeds;
    data["disability"] = this.disability;
    data["allergies"] = this.allergies;
    data["anaphylaxisProblem"] = this.anaphylaxisProblem;
    data["anaphylaxisSeverity"] = this.anaphylaxisSeverity;
    data["anaphylaxisType"] = this.anaphylaxisType;
    data["anaphylaxisTreatment"] = this.anaphylaxisTreatment;
    data["medicalServiceName"] = this.medicalServiceName;
    data["doctorName"] = this.doctorName;
    data["doctorAddress"] = this.doctorAddress;
    data["doctorPhone"] = this.doctorPhone;
    data["doctorSuburb"] = this.doctorSuburb;
    data["doctorState"] = this.doctorState;
    data["doctorPostcode"] = this.doctorPostcode;
    data["ambulanceNumber"] = this.ambulanceNumber;
    data["hasBeenImmunised"] = this.hasBeenImmunised;
    data["hasMedicalConditions"] = this.hasMedicalConditions;
    data["hasPhysicalNeeds"] = this.hasPhysicalNeeds;
    data["hasBehaviouralNeeds"] = this.hasBehaviouralNeeds;
    data["hasSpecialNeeds"] = this.hasSpecialNeeds;
    data["hasDietaryRequirements"] = this.hasDietaryRequirements;
    if (Array.isArray(this.medicalConditions)) {
      data["medicalConditions"] = [];
      for (let item of this.medicalConditions) data["medicalConditions"].push(item);
    }
    if (Array.isArray(this.medicalConditionDetails)) {
      data["medicalConditionDetails"] = [];
      for (let item of this.medicalConditionDetails) data["medicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.noMedicalConditionDetails)) {
      data["noMedicalConditionDetails"] = [];
      for (let item of this.noMedicalConditionDetails) data["noMedicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.childSituations)) {
      data["childSituations"] = [];
      for (let item of this.childSituations) data["childSituations"].push(item);
    }
    data["allowAdministerMedicine"] = this.allowAdministerMedicine;
    data["allowAmbulanceTransportation"] = this.allowAmbulanceTransportation;
    data["allowMedicalTreatment"] = this.allowMedicalTreatment;
    data["allowTakeOutside"] = this.allowTakeOutside;
    data["priorityAccessId"] = this.priorityAccessId;
    data["avatarIndex"] = this.avatarIndex;
    data["medicareNumber"] = this.medicareNumber;
    data["sameLivingCareAsFirstChild"] = this.sameLivingCareAsFirstChild;
    data["sameMedicalContactAsFirstChild"] = this.sameMedicalContactAsFirstChild;
    data["otherMedicalCondition"] = this.otherMedicalCondition;
    if (Array.isArray(this.documentIdsAdded)) {
      data["documentIdsAdded"] = [];
      for (let item of this.documentIdsAdded) data["documentIdsAdded"].push(item);
    }
    if (Array.isArray(this.documentIdsDeleted)) {
      data["documentIdsDeleted"] = [];
      for (let item of this.documentIdsDeleted) data["documentIdsDeleted"].push(item);
    }
    if (Array.isArray(this.answers)) {
      data["answers"] = [];
      for (let item of this.answers) data["answers"].push(item ? item.toJSON() : (undefined as any));
    }
    data["acknowledgedStatus"] = this.acknowledgedStatus;
    data["authorization"] = this.authorization ? this.authorization.toJSON() : (undefined as any);
    return data;
  }
}

export interface IChildBaseHttpRequest {
  crn?: string | undefined;
  firstName: string;
  lastName: string;
  birthday: dayjs.Dayjs;
  genderId: number;
  otherGender?: string | undefined;
  schoolId: number;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  sameSchoolDetailsAsFirstChild?: boolean | undefined;
  residentialAddress: CreateAddressHttpRequest;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: string[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild?: boolean | undefined;
  sameMedicalContactAsFirstChild?: boolean | undefined;
  otherMedicalCondition?: string | undefined;
  documentIdsAdded?: string[] | undefined;
  documentIdsDeleted?: string[] | undefined;
  answers?: AnswerHttpRequest[] | undefined;
  acknowledgedStatus?: boolean | undefined;
  authorization?: ParentAuthorizationHttpRequest | undefined;
}

export class CreateChildHttpRequest extends ChildBaseHttpRequest implements ICreateChildHttpRequest {
  constructor(data?: ICreateChildHttpRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): CreateChildHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateChildHttpRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ICreateChildHttpRequest extends IChildBaseHttpRequest {}

export class CreateAddressHttpRequest implements ICreateAddressHttpRequest {
  uniqueId?: string | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;

  constructor(data?: ICreateAddressHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.streetLine1 = _data["streetLine1"];
      this.streetLine2 = _data["streetLine2"];
      this.suburb = _data["suburb"];
      this.postCode = _data["postCode"];
      this.state = _data["state"];
      this.country = _data["country"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
    }
  }

  static fromJS(data: any): CreateAddressHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateAddressHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["streetLine1"] = this.streetLine1;
    data["streetLine2"] = this.streetLine2;
    data["suburb"] = this.suburb;
    data["postCode"] = this.postCode;
    data["state"] = this.state;
    data["country"] = this.country;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    return data;
  }
}

export interface ICreateAddressHttpRequest {
  uniqueId?: string | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
}

export class AnswerHttpRequest implements IAnswerHttpRequest {
  uniqueId?: string | undefined;
  questionId!: number;
  conditionId!: number;
  multipleAnswerIndex?: number | undefined;
  value?: string | undefined;
  freeText?: string | undefined;

  constructor(data?: IAnswerHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.questionId = _data["questionId"];
      this.conditionId = _data["conditionId"];
      this.multipleAnswerIndex = _data["multipleAnswerIndex"];
      this.value = _data["value"];
      this.freeText = _data["freeText"];
    }
  }

  static fromJS(data: any): AnswerHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new AnswerHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["questionId"] = this.questionId;
    data["conditionId"] = this.conditionId;
    data["multipleAnswerIndex"] = this.multipleAnswerIndex;
    data["value"] = this.value;
    data["freeText"] = this.freeText;
    return data;
  }
}

export interface IAnswerHttpRequest {
  uniqueId?: string | undefined;
  questionId: number;
  conditionId: number;
  multipleAnswerIndex?: number | undefined;
  value?: string | undefined;
  freeText?: string | undefined;
}

export class ParentAuthorizationHttpRequest implements IParentAuthorizationHttpRequest {
  authorize!: boolean;
  informationIsTrue!: boolean;
  signatureData!: string;

  constructor(data?: IParentAuthorizationHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authorize = _data["authorize"];
      this.informationIsTrue = _data["informationIsTrue"];
      this.signatureData = _data["signatureData"];
    }
  }

  static fromJS(data: any): ParentAuthorizationHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ParentAuthorizationHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["authorize"] = this.authorize;
    data["informationIsTrue"] = this.informationIsTrue;
    data["signatureData"] = this.signatureData;
    return data;
  }
}

export interface IParentAuthorizationHttpRequest {
  authorize: boolean;
  informationIsTrue: boolean;
  signatureData: string;
}

export class UpdateChildHttpRequest extends ChildBaseHttpRequest implements IUpdateChildHttpRequest {
  constructor(data?: IUpdateChildHttpRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): UpdateChildHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateChildHttpRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateChildHttpRequest extends IChildBaseHttpRequest {}

export class GetCommonDataHttpResponse implements IGetCommonDataHttpResponse {
  states!: State[];
  genders!: Gender[];
  bookingCancellationStatuses!: BookingCancellationStatus[];
  careTypes!: CareType[];
  popularLanguages!: string[];
  contactTypes!: ContactType[];
  medicalConditions!: MedicalCondition[];
  priorityAccess!: PriorityAccess[];
  childSituations!: ChildSituation[];
  transQueryTypes!: TransactionQueryType[];
  medicalPlanTemplate!: TemplateHttpResponse;
  programActivityTypes!: ProgramActivityType[];
  rollOverScheduleCancellationReasons!: RollOverScheduleCancellationReason[];
  rollOverConfiguration?: RollOverConfiguration | undefined;
  classifications!: NationalProgramClassification[];
  isNationalProgrammingEnabled!: boolean;
  paymentFees!: PaymentFees;

  constructor(data?: IGetCommonDataHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.states = [];
      this.genders = [];
      this.bookingCancellationStatuses = [];
      this.careTypes = [];
      this.popularLanguages = [];
      this.contactTypes = [];
      this.medicalConditions = [];
      this.priorityAccess = [];
      this.childSituations = [];
      this.transQueryTypes = [];
      this.medicalPlanTemplate = new TemplateHttpResponse();
      this.programActivityTypes = [];
      this.rollOverScheduleCancellationReasons = [];
      this.classifications = [];
      this.paymentFees = new PaymentFees();
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["states"])) {
        this.states = [] as any;
        for (let item of _data["states"]) this.states!.push(State.fromJS(item));
      }
      if (Array.isArray(_data["genders"])) {
        this.genders = [] as any;
        for (let item of _data["genders"]) this.genders!.push(Gender.fromJS(item));
      }
      if (Array.isArray(_data["bookingCancellationStatuses"])) {
        this.bookingCancellationStatuses = [] as any;
        for (let item of _data["bookingCancellationStatuses"])
          this.bookingCancellationStatuses!.push(BookingCancellationStatus.fromJS(item));
      }
      if (Array.isArray(_data["careTypes"])) {
        this.careTypes = [] as any;
        for (let item of _data["careTypes"]) this.careTypes!.push(CareType.fromJS(item));
      }
      if (Array.isArray(_data["popularLanguages"])) {
        this.popularLanguages = [] as any;
        for (let item of _data["popularLanguages"]) this.popularLanguages!.push(item);
      }
      if (Array.isArray(_data["contactTypes"])) {
        this.contactTypes = [] as any;
        for (let item of _data["contactTypes"]) this.contactTypes!.push(ContactType.fromJS(item));
      }
      if (Array.isArray(_data["medicalConditions"])) {
        this.medicalConditions = [] as any;
        for (let item of _data["medicalConditions"]) this.medicalConditions!.push(MedicalCondition.fromJS(item));
      }
      if (Array.isArray(_data["priorityAccess"])) {
        this.priorityAccess = [] as any;
        for (let item of _data["priorityAccess"]) this.priorityAccess!.push(PriorityAccess.fromJS(item));
      }
      if (Array.isArray(_data["childSituations"])) {
        this.childSituations = [] as any;
        for (let item of _data["childSituations"]) this.childSituations!.push(ChildSituation.fromJS(item));
      }
      if (Array.isArray(_data["transQueryTypes"])) {
        this.transQueryTypes = [] as any;
        for (let item of _data["transQueryTypes"]) this.transQueryTypes!.push(TransactionQueryType.fromJS(item));
      }
      this.medicalPlanTemplate = _data["medicalPlanTemplate"]
        ? TemplateHttpResponse.fromJS(_data["medicalPlanTemplate"])
        : new TemplateHttpResponse();
      if (Array.isArray(_data["programActivityTypes"])) {
        this.programActivityTypes = [] as any;
        for (let item of _data["programActivityTypes"])
          this.programActivityTypes!.push(ProgramActivityType.fromJS(item));
      }
      if (Array.isArray(_data["rollOverScheduleCancellationReasons"])) {
        this.rollOverScheduleCancellationReasons = [] as any;
        for (let item of _data["rollOverScheduleCancellationReasons"])
          this.rollOverScheduleCancellationReasons!.push(RollOverScheduleCancellationReason.fromJS(item));
      }
      this.rollOverConfiguration = _data["rollOverConfiguration"]
        ? RollOverConfiguration.fromJS(_data["rollOverConfiguration"])
        : (undefined as any);
      if (Array.isArray(_data["classifications"])) {
        this.classifications = [] as any;
        for (let item of _data["classifications"])
          this.classifications!.push(NationalProgramClassification.fromJS(item));
      }
      this.isNationalProgrammingEnabled = _data["isNationalProgrammingEnabled"];
      this.paymentFees = _data["paymentFees"] ? PaymentFees.fromJS(_data["paymentFees"]) : new PaymentFees();
    }
  }

  static fromJS(data: any): GetCommonDataHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetCommonDataHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.states)) {
      data["states"] = [];
      for (let item of this.states) data["states"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.genders)) {
      data["genders"] = [];
      for (let item of this.genders) data["genders"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.bookingCancellationStatuses)) {
      data["bookingCancellationStatuses"] = [];
      for (let item of this.bookingCancellationStatuses)
        data["bookingCancellationStatuses"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.careTypes)) {
      data["careTypes"] = [];
      for (let item of this.careTypes) data["careTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.popularLanguages)) {
      data["popularLanguages"] = [];
      for (let item of this.popularLanguages) data["popularLanguages"].push(item);
    }
    if (Array.isArray(this.contactTypes)) {
      data["contactTypes"] = [];
      for (let item of this.contactTypes) data["contactTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.medicalConditions)) {
      data["medicalConditions"] = [];
      for (let item of this.medicalConditions)
        data["medicalConditions"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.priorityAccess)) {
      data["priorityAccess"] = [];
      for (let item of this.priorityAccess) data["priorityAccess"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.childSituations)) {
      data["childSituations"] = [];
      for (let item of this.childSituations) data["childSituations"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.transQueryTypes)) {
      data["transQueryTypes"] = [];
      for (let item of this.transQueryTypes) data["transQueryTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    data["medicalPlanTemplate"] = this.medicalPlanTemplate ? this.medicalPlanTemplate.toJSON() : (undefined as any);
    if (Array.isArray(this.programActivityTypes)) {
      data["programActivityTypes"] = [];
      for (let item of this.programActivityTypes)
        data["programActivityTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.rollOverScheduleCancellationReasons)) {
      data["rollOverScheduleCancellationReasons"] = [];
      for (let item of this.rollOverScheduleCancellationReasons)
        data["rollOverScheduleCancellationReasons"].push(item ? item.toJSON() : (undefined as any));
    }
    data["rollOverConfiguration"] = this.rollOverConfiguration
      ? this.rollOverConfiguration.toJSON()
      : (undefined as any);
    if (Array.isArray(this.classifications)) {
      data["classifications"] = [];
      for (let item of this.classifications) data["classifications"].push(item ? item.toJSON() : (undefined as any));
    }
    data["isNationalProgrammingEnabled"] = this.isNationalProgrammingEnabled;
    data["paymentFees"] = this.paymentFees ? this.paymentFees.toJSON() : (undefined as any);
    return data;
  }
}

export interface IGetCommonDataHttpResponse {
  states: State[];
  genders: Gender[];
  bookingCancellationStatuses: BookingCancellationStatus[];
  careTypes: CareType[];
  popularLanguages: string[];
  contactTypes: ContactType[];
  medicalConditions: MedicalCondition[];
  priorityAccess: PriorityAccess[];
  childSituations: ChildSituation[];
  transQueryTypes: TransactionQueryType[];
  medicalPlanTemplate: TemplateHttpResponse;
  programActivityTypes: ProgramActivityType[];
  rollOverScheduleCancellationReasons: RollOverScheduleCancellationReason[];
  rollOverConfiguration?: RollOverConfiguration | undefined;
  classifications: NationalProgramClassification[];
  isNationalProgrammingEnabled: boolean;
  paymentFees: PaymentFees;
}

export class State implements IState {
  uniqueId!: string;
  stateId!: number;
  shortName!: string;
  fullName!: string;
  timeZoneId!: string;
  timeZone!: TimeZone;

  constructor(data?: IState) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.timeZone = new TimeZone();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.stateId = _data["stateId"];
      this.shortName = _data["shortName"];
      this.fullName = _data["fullName"];
      this.timeZoneId = _data["timeZoneId"];
      this.timeZone = _data["timeZone"] ? TimeZone.fromJS(_data["timeZone"]) : new TimeZone();
    }
  }

  static fromJS(data: any): State {
    data = typeof data === "object" ? data : {};
    let result = new State();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["stateId"] = this.stateId;
    data["shortName"] = this.shortName;
    data["fullName"] = this.fullName;
    data["timeZoneId"] = this.timeZoneId;
    data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : (undefined as any);
    return data;
  }
}

export interface IState {
  uniqueId: string;
  stateId: number;
  shortName: string;
  fullName: string;
  timeZoneId: string;
  timeZone: TimeZone;
}

export class TimeZone implements ITimeZone {
  uniqueId!: string;
  windowsName!: string;
  linuxName!: string;

  constructor(data?: ITimeZone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.windowsName = _data["windowsName"];
      this.linuxName = _data["linuxName"];
    }
  }

  static fromJS(data: any): TimeZone {
    data = typeof data === "object" ? data : {};
    let result = new TimeZone();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["windowsName"] = this.windowsName;
    data["linuxName"] = this.linuxName;
    return data;
  }
}

export interface ITimeZone {
  uniqueId: string;
  windowsName: string;
  linuxName: string;
}

export class Gender implements IGender {
  genderId!: number;
  name!: string;

  constructor(data?: IGender) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.genderId = _data["genderId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): Gender {
    data = typeof data === "object" ? data : {};
    let result = new Gender();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["genderId"] = this.genderId;
    data["name"] = this.name;
    return data;
  }
}

export interface IGender {
  genderId: number;
  name: string;
}

export class BookingCancellationStatus implements IBookingCancellationStatus {
  bookingCancellationStatusId?: number | undefined;
  description!: string;
  isChargeable!: boolean;

  constructor(data?: IBookingCancellationStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingCancellationStatusId = _data["bookingCancellationStatusId"];
      this.description = _data["description"];
      this.isChargeable = _data["isChargeable"];
    }
  }

  static fromJS(data: any): BookingCancellationStatus {
    data = typeof data === "object" ? data : {};
    let result = new BookingCancellationStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingCancellationStatusId"] = this.bookingCancellationStatusId;
    data["description"] = this.description;
    data["isChargeable"] = this.isChargeable;
    return data;
  }
}

export interface IBookingCancellationStatus {
  bookingCancellationStatusId?: number | undefined;
  description: string;
  isChargeable: boolean;
}

export class CareType implements ICareType {
  value!: number;
  code!: string;
  description!: string;

  constructor(data?: ICareType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CareType {
    data = typeof data === "object" ? data : {};
    let result = new CareType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["value"] = this.value;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface ICareType {
  value: number;
  code: string;
  description: string;
}

export class ContactType implements IContactType {
  contactTypeId!: number;
  name!: string;
  contactTypeCategoryId!: number;
  order!: number;

  constructor(data?: IContactType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contactTypeId = _data["contactTypeId"];
      this.name = _data["name"];
      this.contactTypeCategoryId = _data["contactTypeCategoryId"];
      this.order = _data["order"];
    }
  }

  static fromJS(data: any): ContactType {
    data = typeof data === "object" ? data : {};
    let result = new ContactType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contactTypeId"] = this.contactTypeId;
    data["name"] = this.name;
    data["contactTypeCategoryId"] = this.contactTypeCategoryId;
    data["order"] = this.order;
    return data;
  }
}

export interface IContactType {
  contactTypeId: number;
  name: string;
  contactTypeCategoryId: number;
  order: number;
}

export class MedicalCondition implements IMedicalCondition {
  medicalConditionId!: number;
  name!: string;
  medicalConditionDetails?: MedicalConditionDetail[] | undefined;

  constructor(data?: IMedicalCondition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.medicalConditionId = _data["medicalConditionId"];
      this.name = _data["name"];
      if (Array.isArray(_data["medicalConditionDetails"])) {
        this.medicalConditionDetails = [] as any;
        for (let item of _data["medicalConditionDetails"])
          this.medicalConditionDetails!.push(MedicalConditionDetail.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MedicalCondition {
    data = typeof data === "object" ? data : {};
    let result = new MedicalCondition();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["medicalConditionId"] = this.medicalConditionId;
    data["name"] = this.name;
    if (Array.isArray(this.medicalConditionDetails)) {
      data["medicalConditionDetails"] = [];
      for (let item of this.medicalConditionDetails)
        data["medicalConditionDetails"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IMedicalCondition {
  medicalConditionId: number;
  name: string;
  medicalConditionDetails?: MedicalConditionDetail[] | undefined;
}

export class MedicalConditionDetail implements IMedicalConditionDetail {
  medicalConditionDetailId!: number;
  medicalConditionId!: number;
  name!: string;
  description?: string | undefined;
  isOptional!: boolean;
  documents?: string | undefined;
  order!: number;
  medicalConditionDetailTypeId!: number;
  allowedFileTypes!: string;
  allowedFileSizeInKb!: number;

  constructor(data?: IMedicalConditionDetail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.medicalConditionDetailId = _data["medicalConditionDetailId"];
      this.medicalConditionId = _data["medicalConditionId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.isOptional = _data["isOptional"];
      this.documents = _data["documents"];
      this.order = _data["order"];
      this.medicalConditionDetailTypeId = _data["medicalConditionDetailTypeId"];
      this.allowedFileTypes = _data["allowedFileTypes"];
      this.allowedFileSizeInKb = _data["allowedFileSizeInKb"];
    }
  }

  static fromJS(data: any): MedicalConditionDetail {
    data = typeof data === "object" ? data : {};
    let result = new MedicalConditionDetail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["medicalConditionDetailId"] = this.medicalConditionDetailId;
    data["medicalConditionId"] = this.medicalConditionId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["isOptional"] = this.isOptional;
    data["documents"] = this.documents;
    data["order"] = this.order;
    data["medicalConditionDetailTypeId"] = this.medicalConditionDetailTypeId;
    data["allowedFileTypes"] = this.allowedFileTypes;
    data["allowedFileSizeInKb"] = this.allowedFileSizeInKb;
    return data;
  }
}

export interface IMedicalConditionDetail {
  medicalConditionDetailId: number;
  medicalConditionId: number;
  name: string;
  description?: string | undefined;
  isOptional: boolean;
  documents?: string | undefined;
  order: number;
  medicalConditionDetailTypeId: number;
  allowedFileTypes: string;
  allowedFileSizeInKb: number;
}

export class PriorityAccess implements IPriorityAccess {
  priorityAccessId!: number;
  name!: string;
  description?: string | undefined;

  constructor(data?: IPriorityAccess) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.priorityAccessId = _data["priorityAccessId"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PriorityAccess {
    data = typeof data === "object" ? data : {};
    let result = new PriorityAccess();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["priorityAccessId"] = this.priorityAccessId;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IPriorityAccess {
  priorityAccessId: number;
  name: string;
  description?: string | undefined;
}

export class ChildSituation implements IChildSituation {
  childSituationId!: number;
  name!: string;
  description?: string | undefined;

  constructor(data?: IChildSituation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childSituationId = _data["childSituationId"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ChildSituation {
    data = typeof data === "object" ? data : {};
    let result = new ChildSituation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childSituationId"] = this.childSituationId;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IChildSituation {
  childSituationId: number;
  name: string;
  description?: string | undefined;
}

export class TransactionQueryType implements ITransactionQueryType {
  id!: number;
  description?: string | undefined;

  constructor(data?: ITransactionQueryType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): TransactionQueryType {
    data = typeof data === "object" ? data : {};
    let result = new TransactionQueryType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["description"] = this.description;
    return data;
  }
}

export interface ITransactionQueryType {
  id: number;
  description?: string | undefined;
}

export class TemplateHttpResponse implements ITemplateHttpResponse {
  conditions!: ConditionHttpResponse[];
  questions!: QuestionHttpResponse[];
  conditionTypes!: ConditionTypeHttpResponse[];

  constructor(data?: ITemplateHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.conditions = [];
      this.questions = [];
      this.conditionTypes = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["conditions"])) {
        this.conditions = [] as any;
        for (let item of _data["conditions"]) this.conditions!.push(ConditionHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["questions"])) {
        this.questions = [] as any;
        for (let item of _data["questions"]) this.questions!.push(QuestionHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["conditionTypes"])) {
        this.conditionTypes = [] as any;
        for (let item of _data["conditionTypes"]) this.conditionTypes!.push(ConditionTypeHttpResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TemplateHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new TemplateHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.conditions)) {
      data["conditions"] = [];
      for (let item of this.conditions) data["conditions"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.questions)) {
      data["questions"] = [];
      for (let item of this.questions) data["questions"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.conditionTypes)) {
      data["conditionTypes"] = [];
      for (let item of this.conditionTypes) data["conditionTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ITemplateHttpResponse {
  conditions: ConditionHttpResponse[];
  questions: QuestionHttpResponse[];
  conditionTypes: ConditionTypeHttpResponse[];
}

export class ConditionHttpResponse implements IConditionHttpResponse {
  conditionId!: number;
  name!: string;
  conditionTypeId!: number;

  constructor(data?: IConditionHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conditionId = _data["conditionId"];
      this.name = _data["name"];
      this.conditionTypeId = _data["conditionTypeId"];
    }
  }

  static fromJS(data: any): ConditionHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ConditionHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["conditionId"] = this.conditionId;
    data["name"] = this.name;
    data["conditionTypeId"] = this.conditionTypeId;
    return data;
  }
}

export interface IConditionHttpResponse {
  conditionId: number;
  name: string;
  conditionTypeId: number;
}

export class QuestionHttpResponse implements IQuestionHttpResponse {
  questionId!: number;
  questionCategoryId!: number;
  questionTypeId!: number;
  parentQuestionId?: number | undefined;
  parentQuestionOptionId?: number | undefined;
  text?: string | undefined;
  defaultValue?: string | undefined;
  allowMultipleAnswers!: boolean;
  allowFreeText!: boolean;
  visible!: boolean;
  required!: boolean;
  addAnswerQuestion?: string | undefined;
  freeTextHint?: string | undefined;
  forMedicalConditions?: number[] | undefined;
  notForMedicalConditions?: number[] | undefined;
  allowedFileTypes?: string | undefined;
  allowedFileSizeInKb?: number | undefined;
  note?: string | undefined;
  allowUpload!: boolean;
  freeTextRequired?: boolean | undefined;
  uploadExpirationRequired?: boolean | undefined;
  link?: string | undefined;
  questionOptions?: QuestionOptionHttpResponse[] | undefined;
  questionDocuments?: QuestionDocumentHttpResponse[] | undefined;

  constructor(data?: IQuestionHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionId = _data["questionId"];
      this.questionCategoryId = _data["questionCategoryId"];
      this.questionTypeId = _data["questionTypeId"];
      this.parentQuestionId = _data["parentQuestionId"];
      this.parentQuestionOptionId = _data["parentQuestionOptionId"];
      this.text = _data["text"];
      this.defaultValue = _data["defaultValue"];
      this.allowMultipleAnswers = _data["allowMultipleAnswers"];
      this.allowFreeText = _data["allowFreeText"];
      this.visible = _data["visible"];
      this.required = _data["required"];
      this.addAnswerQuestion = _data["addAnswerQuestion"];
      this.freeTextHint = _data["freeTextHint"];
      if (Array.isArray(_data["forMedicalConditions"])) {
        this.forMedicalConditions = [] as any;
        for (let item of _data["forMedicalConditions"]) this.forMedicalConditions!.push(item);
      }
      if (Array.isArray(_data["notForMedicalConditions"])) {
        this.notForMedicalConditions = [] as any;
        for (let item of _data["notForMedicalConditions"]) this.notForMedicalConditions!.push(item);
      }
      this.allowedFileTypes = _data["allowedFileTypes"];
      this.allowedFileSizeInKb = _data["allowedFileSizeInKb"];
      this.note = _data["note"];
      this.allowUpload = _data["allowUpload"];
      this.freeTextRequired = _data["freeTextRequired"];
      this.uploadExpirationRequired = _data["uploadExpirationRequired"];
      this.link = _data["link"];
      if (Array.isArray(_data["questionOptions"])) {
        this.questionOptions = [] as any;
        for (let item of _data["questionOptions"]) this.questionOptions!.push(QuestionOptionHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["questionDocuments"])) {
        this.questionDocuments = [] as any;
        for (let item of _data["questionDocuments"])
          this.questionDocuments!.push(QuestionDocumentHttpResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new QuestionHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["questionId"] = this.questionId;
    data["questionCategoryId"] = this.questionCategoryId;
    data["questionTypeId"] = this.questionTypeId;
    data["parentQuestionId"] = this.parentQuestionId;
    data["parentQuestionOptionId"] = this.parentQuestionOptionId;
    data["text"] = this.text;
    data["defaultValue"] = this.defaultValue;
    data["allowMultipleAnswers"] = this.allowMultipleAnswers;
    data["allowFreeText"] = this.allowFreeText;
    data["visible"] = this.visible;
    data["required"] = this.required;
    data["addAnswerQuestion"] = this.addAnswerQuestion;
    data["freeTextHint"] = this.freeTextHint;
    if (Array.isArray(this.forMedicalConditions)) {
      data["forMedicalConditions"] = [];
      for (let item of this.forMedicalConditions) data["forMedicalConditions"].push(item);
    }
    if (Array.isArray(this.notForMedicalConditions)) {
      data["notForMedicalConditions"] = [];
      for (let item of this.notForMedicalConditions) data["notForMedicalConditions"].push(item);
    }
    data["allowedFileTypes"] = this.allowedFileTypes;
    data["allowedFileSizeInKb"] = this.allowedFileSizeInKb;
    data["note"] = this.note;
    data["allowUpload"] = this.allowUpload;
    data["freeTextRequired"] = this.freeTextRequired;
    data["uploadExpirationRequired"] = this.uploadExpirationRequired;
    data["link"] = this.link;
    if (Array.isArray(this.questionOptions)) {
      data["questionOptions"] = [];
      for (let item of this.questionOptions) data["questionOptions"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.questionDocuments)) {
      data["questionDocuments"] = [];
      for (let item of this.questionDocuments)
        data["questionDocuments"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IQuestionHttpResponse {
  questionId: number;
  questionCategoryId: number;
  questionTypeId: number;
  parentQuestionId?: number | undefined;
  parentQuestionOptionId?: number | undefined;
  text?: string | undefined;
  defaultValue?: string | undefined;
  allowMultipleAnswers: boolean;
  allowFreeText: boolean;
  visible: boolean;
  required: boolean;
  addAnswerQuestion?: string | undefined;
  freeTextHint?: string | undefined;
  forMedicalConditions?: number[] | undefined;
  notForMedicalConditions?: number[] | undefined;
  allowedFileTypes?: string | undefined;
  allowedFileSizeInKb?: number | undefined;
  note?: string | undefined;
  allowUpload: boolean;
  freeTextRequired?: boolean | undefined;
  uploadExpirationRequired?: boolean | undefined;
  link?: string | undefined;
  questionOptions?: QuestionOptionHttpResponse[] | undefined;
  questionDocuments?: QuestionDocumentHttpResponse[] | undefined;
}

export class QuestionOptionHttpResponse implements IQuestionOptionHttpResponse {
  questionOptionId!: number;
  questionId!: number;
  name!: string;

  constructor(data?: IQuestionOptionHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionOptionId = _data["questionOptionId"];
      this.questionId = _data["questionId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): QuestionOptionHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new QuestionOptionHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["questionOptionId"] = this.questionOptionId;
    data["questionId"] = this.questionId;
    data["name"] = this.name;
    return data;
  }
}

export interface IQuestionOptionHttpResponse {
  questionOptionId: number;
  questionId: number;
  name: string;
}

export class QuestionDocumentHttpResponse implements IQuestionDocumentHttpResponse {
  title!: string;
  url!: string;
  forMedicalConditions?: number[] | undefined;

  constructor(data?: IQuestionDocumentHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.url = _data["url"];
      if (Array.isArray(_data["forMedicalConditions"])) {
        this.forMedicalConditions = [] as any;
        for (let item of _data["forMedicalConditions"]) this.forMedicalConditions!.push(item);
      }
    }
  }

  static fromJS(data: any): QuestionDocumentHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new QuestionDocumentHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["url"] = this.url;
    if (Array.isArray(this.forMedicalConditions)) {
      data["forMedicalConditions"] = [];
      for (let item of this.forMedicalConditions) data["forMedicalConditions"].push(item);
    }
    return data;
  }
}

export interface IQuestionDocumentHttpResponse {
  title: string;
  url: string;
  forMedicalConditions?: number[] | undefined;
}

export class ConditionTypeHttpResponse implements IConditionTypeHttpResponse {
  conditionTypeId!: number;
  name!: string;

  constructor(data?: IConditionTypeHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conditionTypeId = _data["conditionTypeId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): ConditionTypeHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ConditionTypeHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["conditionTypeId"] = this.conditionTypeId;
    data["name"] = this.name;
    return data;
  }
}

export interface IConditionTypeHttpResponse {
  conditionTypeId: number;
  name: string;
}

export class ProgramActivityType implements IProgramActivityType {
  programActivityTypeId!: number;
  activityTypeName!: string;

  constructor(data?: IProgramActivityType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programActivityTypeId = _data["programActivityTypeId"];
      this.activityTypeName = _data["activityTypeName"];
    }
  }

  static fromJS(data: any): ProgramActivityType {
    data = typeof data === "object" ? data : {};
    let result = new ProgramActivityType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programActivityTypeId"] = this.programActivityTypeId;
    data["activityTypeName"] = this.activityTypeName;
    return data;
  }
}

export interface IProgramActivityType {
  programActivityTypeId: number;
  activityTypeName: string;
}

export class RollOverScheduleCancellationReason implements IRollOverScheduleCancellationReason {
  scheduleCancellationReasonId!: number;
  name!: string;

  constructor(data?: IRollOverScheduleCancellationReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scheduleCancellationReasonId = _data["scheduleCancellationReasonId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): RollOverScheduleCancellationReason {
    data = typeof data === "object" ? data : {};
    let result = new RollOverScheduleCancellationReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["scheduleCancellationReasonId"] = this.scheduleCancellationReasonId;
    data["name"] = this.name;
    return data;
  }
}

export interface IRollOverScheduleCancellationReason {
  scheduleCancellationReasonId: number;
  name: string;
}

export class RollOverConfiguration implements IRollOverConfiguration {
  forYear!: number;
  optFrom!: dayjs.Dayjs;
  optTo!: dayjs.Dayjs;
  bookingsOpenOn!: dayjs.Dayjs;

  constructor(data?: IRollOverConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.forYear = _data["forYear"];
      this.optFrom = _data["optFrom"] ? dayjs(_data["optFrom"].toString()) : (undefined as any);
      this.optTo = _data["optTo"] ? dayjs(_data["optTo"].toString()) : (undefined as any);
      this.bookingsOpenOn = _data["bookingsOpenOn"] ? dayjs(_data["bookingsOpenOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): RollOverConfiguration {
    data = typeof data === "object" ? data : {};
    let result = new RollOverConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["forYear"] = this.forYear;
    data["optFrom"] = this.optFrom ? this.optFrom.toISOString() : (undefined as any);
    data["optTo"] = this.optTo ? this.optTo.toISOString() : (undefined as any);
    data["bookingsOpenOn"] = this.bookingsOpenOn ? this.bookingsOpenOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IRollOverConfiguration {
  forYear: number;
  optFrom: dayjs.Dayjs;
  optTo: dayjs.Dayjs;
  bookingsOpenOn: dayjs.Dayjs;
}

export class NationalProgramClassification implements INationalProgramClassification {
  id!: number;
  name!: string;
  isRocketeers!: boolean;

  constructor(data?: INationalProgramClassification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.isRocketeers = _data["isRocketeers"];
    }
  }

  static fromJS(data: any): NationalProgramClassification {
    data = typeof data === "object" ? data : {};
    let result = new NationalProgramClassification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["isRocketeers"] = this.isRocketeers;
    return data;
  }
}

export interface INationalProgramClassification {
  id: number;
  name: string;
  isRocketeers: boolean;
}

export class PaymentFees implements IPaymentFees {
  creditCardSurcharge!: number;
  creditCardTransactionFee!: number;
  bankTransferTransactionFee!: number;

  constructor(data?: IPaymentFees) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creditCardSurcharge = _data["creditCardSurcharge"];
      this.creditCardTransactionFee = _data["creditCardTransactionFee"];
      this.bankTransferTransactionFee = _data["bankTransferTransactionFee"];
    }
  }

  static fromJS(data: any): PaymentFees {
    data = typeof data === "object" ? data : {};
    let result = new PaymentFees();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["creditCardSurcharge"] = this.creditCardSurcharge;
    data["creditCardTransactionFee"] = this.creditCardTransactionFee;
    data["bankTransferTransactionFee"] = this.bankTransferTransactionFee;
    return data;
  }
}

export interface IPaymentFees {
  creditCardSurcharge: number;
  creditCardTransactionFee: number;
  bankTransferTransactionFee: number;
}

export class AddressSearchResultHttpResponse implements IAddressSearchResultHttpResponse {
  suburb?: string | undefined;
  state?: string | undefined;
  postalCode?: string | undefined;
  streetLine1?: string | undefined;
  formattedAddress?: string | undefined;

  constructor(data?: IAddressSearchResultHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.suburb = _data["suburb"];
      this.state = _data["state"];
      this.postalCode = _data["postalCode"];
      this.streetLine1 = _data["streetLine1"];
      this.formattedAddress = _data["formattedAddress"];
    }
  }

  static fromJS(data: any): AddressSearchResultHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AddressSearchResultHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["suburb"] = this.suburb;
    data["state"] = this.state;
    data["postalCode"] = this.postalCode;
    data["streetLine1"] = this.streetLine1;
    data["formattedAddress"] = this.formattedAddress;
    return data;
  }
}

export interface IAddressSearchResultHttpResponse {
  suburb?: string | undefined;
  state?: string | undefined;
  postalCode?: string | undefined;
  streetLine1?: string | undefined;
  formattedAddress?: string | undefined;
}

export class AppConfig implements IAppConfig {
  name?: string | undefined;
  value?: string | undefined;

  constructor(data?: IAppConfig) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): AppConfig {
    data = typeof data === "object" ? data : {};
    let result = new AppConfig();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface IAppConfig {
  name?: string | undefined;
  value?: string | undefined;
}

export class PasswordSettings implements IPasswordSettings {
  passwordRequiredLength!: number;
  passwordRequiredUniqueChars!: number;
  passwordRequireNonAlphanumeric!: boolean;
  passwordRequireLowercase!: boolean;
  passwordRequireUppercase!: boolean;
  passwordRequireDigit!: boolean;

  constructor(data?: IPasswordSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.passwordRequiredLength = _data["passwordRequiredLength"];
      this.passwordRequiredUniqueChars = _data["passwordRequiredUniqueChars"];
      this.passwordRequireNonAlphanumeric = _data["passwordRequireNonAlphanumeric"];
      this.passwordRequireLowercase = _data["passwordRequireLowercase"];
      this.passwordRequireUppercase = _data["passwordRequireUppercase"];
      this.passwordRequireDigit = _data["passwordRequireDigit"];
    }
  }

  static fromJS(data: any): PasswordSettings {
    data = typeof data === "object" ? data : {};
    let result = new PasswordSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["passwordRequiredLength"] = this.passwordRequiredLength;
    data["passwordRequiredUniqueChars"] = this.passwordRequiredUniqueChars;
    data["passwordRequireNonAlphanumeric"] = this.passwordRequireNonAlphanumeric;
    data["passwordRequireLowercase"] = this.passwordRequireLowercase;
    data["passwordRequireUppercase"] = this.passwordRequireUppercase;
    data["passwordRequireDigit"] = this.passwordRequireDigit;
    return data;
  }
}

export interface IPasswordSettings {
  passwordRequiredLength: number;
  passwordRequiredUniqueChars: number;
  passwordRequireNonAlphanumeric: boolean;
  passwordRequireLowercase: boolean;
  passwordRequireUppercase: boolean;
  passwordRequireDigit: boolean;
}

export class GetCommonDatesHttpResponse implements IGetCommonDatesHttpResponse {
  publicHolidays!: PublicHoliday[];
  paymentDueDates!: dayjs.Dayjs[];

  constructor(data?: IGetCommonDatesHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.publicHolidays = [];
      this.paymentDueDates = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["publicHolidays"])) {
        this.publicHolidays = [] as any;
        for (let item of _data["publicHolidays"]) this.publicHolidays!.push(PublicHoliday.fromJS(item));
      }
      if (Array.isArray(_data["paymentDueDates"])) {
        this.paymentDueDates = [] as any;
        for (let item of _data["paymentDueDates"]) this.paymentDueDates!.push(dayjs(item));
      }
    }
  }

  static fromJS(data: any): GetCommonDatesHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetCommonDatesHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.publicHolidays)) {
      data["publicHolidays"] = [];
      for (let item of this.publicHolidays) data["publicHolidays"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.paymentDueDates)) {
      data["paymentDueDates"] = [];
      for (let item of this.paymentDueDates) data["paymentDueDates"].push(item.toISOString());
    }
    return data;
  }
}

export interface IGetCommonDatesHttpResponse {
  publicHolidays: PublicHoliday[];
  paymentDueDates: dayjs.Dayjs[];
}

export class PublicHoliday implements IPublicHoliday {
  state?: string | undefined;
  date!: dayjs.Dayjs;
  description?: string | undefined;

  constructor(data?: IPublicHoliday) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.state = _data["state"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PublicHoliday {
    data = typeof data === "object" ? data : {};
    let result = new PublicHoliday();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["state"] = this.state;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["description"] = this.description;
    return data;
  }
}

export interface IPublicHoliday {
  state?: string | undefined;
  date: dayjs.Dayjs;
  description?: string | undefined;
}

export class TokenHttpResponse implements ITokenHttpResponse {
  id!: string;
  value?: string | undefined;
  entityType!: EntityType;
  entityId!: number;
  validTo!: dayjs.Dayjs;

  constructor(data?: ITokenHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.value = _data["value"];
      this.entityType = _data["entityType"];
      this.entityId = _data["entityId"];
      this.validTo = _data["validTo"] ? dayjs(_data["validTo"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): TokenHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new TokenHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["value"] = this.value;
    data["entityType"] = this.entityType;
    data["entityId"] = this.entityId;
    data["validTo"] = this.validTo ? this.validTo.toISOString() : (undefined as any);
    return data;
  }
}

export interface ITokenHttpResponse {
  id: string;
  value?: string | undefined;
  entityType: EntityType;
  entityId: number;
  validTo: dayjs.Dayjs;
}

export enum EntityType {
  CustomerContact = "customerContact",
  CustomerAccount = "customerAccount",
  Employee = "employee",
}

export class SubmitFeedbackHttpRequest implements ISubmitFeedbackHttpRequest {
  overallExperience!: number;
  staffExperience!: number;
  feedbackTypeId!: number;
  comments!: string;

  constructor(data?: ISubmitFeedbackHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.overallExperience = _data["overallExperience"];
      this.staffExperience = _data["staffExperience"];
      this.feedbackTypeId = _data["feedbackTypeId"];
      this.comments = _data["comments"];
    }
  }

  static fromJS(data: any): SubmitFeedbackHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SubmitFeedbackHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["overallExperience"] = this.overallExperience;
    data["staffExperience"] = this.staffExperience;
    data["feedbackTypeId"] = this.feedbackTypeId;
    data["comments"] = this.comments;
    return data;
  }
}

export interface ISubmitFeedbackHttpRequest {
  overallExperience: number;
  staffExperience: number;
  feedbackTypeId: number;
  comments: string;
}

export class FeedbackTypeHttpResponse implements IFeedbackTypeHttpResponse {
  name!: string;
  feedbackTypeId!: number;

  constructor(data?: IFeedbackTypeHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.feedbackTypeId = _data["feedbackTypeId"];
    }
  }

  static fromJS(data: any): FeedbackTypeHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new FeedbackTypeHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["feedbackTypeId"] = this.feedbackTypeId;
    return data;
  }
}

export interface IFeedbackTypeHttpResponse {
  name: string;
  feedbackTypeId: number;
}

export class RegisterHttpResponse implements IRegisterHttpResponse {
  userAccountId?: string | undefined;
  status!: RegistrationStatus;
  errors!: ErrorDto[];

  constructor(data?: IRegisterHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.errors = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userAccountId = _data["userAccountId"];
      this.status = _data["status"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(ErrorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RegisterHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegisterHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userAccountId"] = this.userAccountId;
    data["status"] = this.status;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRegisterHttpResponse {
  userAccountId?: string | undefined;
  status: RegistrationStatus;
  errors: ErrorDto[];
}

export enum RegistrationStatus {
  Success = "success",
  AlreadyRegistered = "alreadyRegistered",
  UnknownError = "unknownError",
  NeedVerification = "needVerification",
  InvalidReferralCode = "invalidReferralCode",
}

export class ErrorDto implements IErrorDto {
  code!: string;
  description!: string;

  constructor(data?: IErrorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ErrorDto {
    data = typeof data === "object" ? data : {};
    let result = new ErrorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

export interface IErrorDto {
  code: string;
  description: string;
}

export class RegisterHttpRequest implements IRegisterHttpRequest {
  firstName!: string;
  lastName!: string;
  email!: string;
  password!: string;
  customerContactId?: number | undefined;
  referralCode?: string | undefined;

  constructor(data?: IRegisterHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.password = _data["password"];
      this.customerContactId = _data["customerContactId"];
      this.referralCode = _data["referralCode"];
    }
  }

  static fromJS(data: any): RegisterHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RegisterHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["password"] = this.password;
    data["customerContactId"] = this.customerContactId;
    data["referralCode"] = this.referralCode;
    return data;
  }
}

export interface IRegisterHttpRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  customerContactId?: number | undefined;
  referralCode?: string | undefined;
}

export class VerifyEmailHttpResponse implements IVerifyEmailHttpResponse {
  isValid!: boolean;

  constructor(data?: IVerifyEmailHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isValid = _data["isValid"];
    }
  }

  static fromJS(data: any): VerifyEmailHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new VerifyEmailHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isValid"] = this.isValid;
    return data;
  }
}

export interface IVerifyEmailHttpResponse {
  isValid: boolean;
}

export class VerifyEmailHttpRequest implements IVerifyEmailHttpRequest {
  email!: string;
  token!: string;

  constructor(data?: IVerifyEmailHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.token = _data["token"];
    }
  }

  static fromJS(data: any): VerifyEmailHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new VerifyEmailHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["token"] = this.token;
    return data;
  }
}

export interface IVerifyEmailHttpRequest {
  email: string;
  token: string;
}

export class ResendCodeHttpRequest implements IResendCodeHttpRequest {
  email!: string;

  constructor(data?: IResendCodeHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ResendCodeHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ResendCodeHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    return data;
  }
}

export interface IResendCodeHttpRequest {
  email: string;
}

export class ForgotPasswordHttpRequest implements IForgotPasswordHttpRequest {
  userName!: string;

  constructor(data?: IForgotPasswordHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
    }
  }

  static fromJS(data: any): ForgotPasswordHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ForgotPasswordHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    return data;
  }
}

export interface IForgotPasswordHttpRequest {
  userName: string;
}

export class ExpiredPasswordChangeHttpRequest implements IExpiredPasswordChangeHttpRequest {
  userName!: string;
  currentPassword!: string;
  newPassword!: string;

  constructor(data?: IExpiredPasswordChangeHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): ExpiredPasswordChangeHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ExpiredPasswordChangeHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }
}

export interface IExpiredPasswordChangeHttpRequest {
  userName: string;
  currentPassword: string;
  newPassword: string;
}

export class PasswordChangeHttpRequest implements IPasswordChangeHttpRequest {
  currentPassword!: string;
  newPassword!: string;

  constructor(data?: IPasswordChangeHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data["currentPassword"];
      this.newPassword = _data["newPassword"];
    }
  }

  static fromJS(data: any): PasswordChangeHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new PasswordChangeHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentPassword"] = this.currentPassword;
    data["newPassword"] = this.newPassword;
    return data;
  }
}

export interface IPasswordChangeHttpRequest {
  currentPassword: string;
  newPassword: string;
}

export class AcknowledgeSpecialNeedsHttpRequest implements IAcknowledgeSpecialNeedsHttpRequest {
  acknowledgeSpecialNeeds!: boolean;

  constructor(data?: IAcknowledgeSpecialNeedsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.acknowledgeSpecialNeeds = _data["acknowledgeSpecialNeeds"];
    }
  }

  static fromJS(data: any): AcknowledgeSpecialNeedsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new AcknowledgeSpecialNeedsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["acknowledgeSpecialNeeds"] = this.acknowledgeSpecialNeeds;
    return data;
  }
}

export interface IAcknowledgeSpecialNeedsHttpRequest {
  acknowledgeSpecialNeeds: boolean;
}

export class LoginResponse implements ILoginResponse {
  succeeded!: boolean;
  errorMessages!: string[];
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  customerContactId!: number;

  constructor(data?: ILoginResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.errorMessages = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      if (Array.isArray(_data["errorMessages"])) {
        this.errorMessages = [] as any;
        for (let item of _data["errorMessages"]) this.errorMessages!.push(item);
      }
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.customerContactId = _data["customerContactId"];
    }
  }

  static fromJS(data: any): LoginResponse {
    data = typeof data === "object" ? data : {};
    let result = new LoginResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    if (Array.isArray(this.errorMessages)) {
      data["errorMessages"] = [];
      for (let item of this.errorMessages) data["errorMessages"].push(item);
    }
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["customerContactId"] = this.customerContactId;
    return data;
  }
}

export interface ILoginResponse {
  succeeded: boolean;
  errorMessages: string[];
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  customerContactId: number;
}

export class LoginHttpRequest implements ILoginHttpRequest {
  customerAccountId!: number;
  password!: string;

  constructor(data?: ILoginHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerAccountId = _data["customerAccountId"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): LoginHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new LoginHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerAccountId"] = this.customerAccountId;
    data["password"] = this.password;
    return data;
  }
}

export interface ILoginHttpRequest {
  customerAccountId: number;
  password: string;
}

export class CustomerAccountHttpResponse implements ICustomerAccountHttpResponse {
  customerAccountId!: number;
  debtCategoryId?: number | undefined;
  isFriendlyFeeEligible?: boolean | undefined;
  primaryServiceId?: number | undefined;
  isExcluded!: boolean;
  isMaguireExcluded!: boolean;
  canBook!: boolean;
  showTutorial?: boolean | undefined;
  referredByCode?: string | undefined;
  referredCode?: string | undefined;
  referredByCustomerId?: number | undefined;
  ccbSubmissionContactId?: number | undefined;
  hasProvidedAuthorization!: boolean;
  isChatbotWhitelisted!: boolean;
  customerAccountDebtCategoryId?: number | undefined;
  contacts?: CustomerContactHttpResponse[] | undefined;
  documents?: DocumentHttpResponse[] | undefined;

  constructor(data?: ICustomerAccountHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerAccountId = _data["customerAccountId"];
      this.debtCategoryId = _data["debtCategoryId"];
      this.isFriendlyFeeEligible = _data["isFriendlyFeeEligible"];
      this.primaryServiceId = _data["primaryServiceId"];
      this.isExcluded = _data["isExcluded"];
      this.isMaguireExcluded = _data["isMaguireExcluded"];
      this.canBook = _data["canBook"];
      this.showTutorial = _data["showTutorial"];
      this.referredByCode = _data["referredByCode"];
      this.referredCode = _data["referredCode"];
      this.referredByCustomerId = _data["referredByCustomerId"];
      this.ccbSubmissionContactId = _data["ccbSubmissionContactId"];
      this.hasProvidedAuthorization = _data["hasProvidedAuthorization"];
      this.isChatbotWhitelisted = _data["isChatbotWhitelisted"];
      this.customerAccountDebtCategoryId = _data["customerAccountDebtCategoryId"];
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"]) this.contacts!.push(CustomerContactHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["documents"])) {
        this.documents = [] as any;
        for (let item of _data["documents"]) this.documents!.push(DocumentHttpResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerAccountHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerAccountHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerAccountId"] = this.customerAccountId;
    data["debtCategoryId"] = this.debtCategoryId;
    data["isFriendlyFeeEligible"] = this.isFriendlyFeeEligible;
    data["primaryServiceId"] = this.primaryServiceId;
    data["isExcluded"] = this.isExcluded;
    data["isMaguireExcluded"] = this.isMaguireExcluded;
    data["canBook"] = this.canBook;
    data["showTutorial"] = this.showTutorial;
    data["referredByCode"] = this.referredByCode;
    data["referredCode"] = this.referredCode;
    data["referredByCustomerId"] = this.referredByCustomerId;
    data["ccbSubmissionContactId"] = this.ccbSubmissionContactId;
    data["hasProvidedAuthorization"] = this.hasProvidedAuthorization;
    data["isChatbotWhitelisted"] = this.isChatbotWhitelisted;
    data["customerAccountDebtCategoryId"] = this.customerAccountDebtCategoryId;
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.documents)) {
      data["documents"] = [];
      for (let item of this.documents) data["documents"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICustomerAccountHttpResponse {
  customerAccountId: number;
  debtCategoryId?: number | undefined;
  isFriendlyFeeEligible?: boolean | undefined;
  primaryServiceId?: number | undefined;
  isExcluded: boolean;
  isMaguireExcluded: boolean;
  canBook: boolean;
  showTutorial?: boolean | undefined;
  referredByCode?: string | undefined;
  referredCode?: string | undefined;
  referredByCustomerId?: number | undefined;
  ccbSubmissionContactId?: number | undefined;
  hasProvidedAuthorization: boolean;
  isChatbotWhitelisted: boolean;
  customerAccountDebtCategoryId?: number | undefined;
  contacts?: CustomerContactHttpResponse[] | undefined;
  documents?: DocumentHttpResponse[] | undefined;
}

export class CustomerContactHttpResponse implements ICustomerContactHttpResponse {
  customerContactId!: number;
  createdAt!: dayjs.Dayjs;
  customerAccountId!: number;
  identityServerUserId?: string | undefined;
  isPrimary!: boolean;
  firstName?: string | undefined;
  lastName?: string | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  residentialAddressId!: string;
  workAddressId?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  contactTypeId?: number | undefined;
  avatarIndex?: number | undefined;
  residentialAddress?: AddressHttpResponse | undefined;
  workAddress?: AddressHttpResponse | undefined;
  authorisation!: AuthorisationHttpResponse;
  planToClaimChildCareSubsidy!: boolean;
  genderId?: number | undefined;
  otherGender?: string | undefined;

  constructor(data?: ICustomerContactHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.authorisation = new AuthorisationHttpResponse();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.customerAccountId = _data["customerAccountId"];
      this.identityServerUserId = _data["identityServerUserId"];
      this.isPrimary = _data["isPrimary"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.email = _data["email"];
      this.mobilePhone = _data["mobilePhone"];
      this.homePhone = _data["homePhone"];
      this.workPhone = _data["workPhone"];
      this.residentialAddressId = _data["residentialAddressId"];
      this.workAddressId = _data["workAddressId"];
      this.crn = _data["crn"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.contactTypeId = _data["contactTypeId"];
      this.avatarIndex = _data["avatarIndex"];
      this.residentialAddress = _data["residentialAddress"]
        ? AddressHttpResponse.fromJS(_data["residentialAddress"])
        : (undefined as any);
      this.workAddress = _data["workAddress"] ? AddressHttpResponse.fromJS(_data["workAddress"]) : (undefined as any);
      this.authorisation = _data["authorisation"]
        ? AuthorisationHttpResponse.fromJS(_data["authorisation"])
        : new AuthorisationHttpResponse();
      this.planToClaimChildCareSubsidy = _data["planToClaimChildCareSubsidy"];
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
    }
  }

  static fromJS(data: any): CustomerContactHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerContactHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["customerAccountId"] = this.customerAccountId;
    data["identityServerUserId"] = this.identityServerUserId;
    data["isPrimary"] = this.isPrimary;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["email"] = this.email;
    data["mobilePhone"] = this.mobilePhone;
    data["homePhone"] = this.homePhone;
    data["workPhone"] = this.workPhone;
    data["residentialAddressId"] = this.residentialAddressId;
    data["workAddressId"] = this.workAddressId;
    data["crn"] = this.crn;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["contactTypeId"] = this.contactTypeId;
    data["avatarIndex"] = this.avatarIndex;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["workAddress"] = this.workAddress ? this.workAddress.toJSON() : (undefined as any);
    data["authorisation"] = this.authorisation ? this.authorisation.toJSON() : (undefined as any);
    data["planToClaimChildCareSubsidy"] = this.planToClaimChildCareSubsidy;
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    return data;
  }
}

export interface ICustomerContactHttpResponse {
  customerContactId: number;
  createdAt: dayjs.Dayjs;
  customerAccountId: number;
  identityServerUserId?: string | undefined;
  isPrimary: boolean;
  firstName?: string | undefined;
  lastName?: string | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  residentialAddressId: string;
  workAddressId?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  contactTypeId?: number | undefined;
  avatarIndex?: number | undefined;
  residentialAddress?: AddressHttpResponse | undefined;
  workAddress?: AddressHttpResponse | undefined;
  authorisation: AuthorisationHttpResponse;
  planToClaimChildCareSubsidy: boolean;
  genderId?: number | undefined;
  otherGender?: string | undefined;
}

export class AuthorisationHttpResponse implements IAuthorisationHttpResponse {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;

  constructor(data?: IAuthorisationHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canApproveAmbulance = _data["canApproveAmbulance"];
      this.canManageAccount = _data["canManageAccount"];
      this.canMakeAndChangeBookings = _data["canMakeAndChangeBookings"];
      this.canPickUpChild = _data["canPickUpChild"];
      this.consentToAdministerMedicine = _data["consentToAdministerMedicine"];
      this.consentToMedicalTreatment = _data["consentToMedicalTreatment"];
      this.consentToTakeOutsidePremises = _data["consentToTakeOutsidePremises"];
      this.consentForTransportation = _data["consentForTransportation"];
    }
  }

  static fromJS(data: any): AuthorisationHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AuthorisationHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canApproveAmbulance"] = this.canApproveAmbulance;
    data["canManageAccount"] = this.canManageAccount;
    data["canMakeAndChangeBookings"] = this.canMakeAndChangeBookings;
    data["canPickUpChild"] = this.canPickUpChild;
    data["consentToAdministerMedicine"] = this.consentToAdministerMedicine;
    data["consentToMedicalTreatment"] = this.consentToMedicalTreatment;
    data["consentToTakeOutsidePremises"] = this.consentToTakeOutsidePremises;
    data["consentForTransportation"] = this.consentForTransportation;
    return data;
  }
}

export interface IAuthorisationHttpResponse {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;
}

export class DocumentHttpResponse implements IDocumentHttpResponse {
  uniqueId!: string;
  childId?: number | undefined;
  customerContactId?: number | undefined;
  fileName!: string;
  documentTypeId!: number;
  medicalConditionId?: number | undefined;
  medicalConditionDetailId?: number | undefined;
  documentId?: number | undefined;
  isRegistration!: boolean;
  medicalPlanConditionId?: number | undefined;
  medicalPlanQuestionId?: number | undefined;
  medicalPlanAnswerIndex?: number | undefined;
  expiresOn?: dayjs.Dayjs | undefined;

  constructor(data?: IDocumentHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.childId = _data["childId"];
      this.customerContactId = _data["customerContactId"];
      this.fileName = _data["fileName"];
      this.documentTypeId = _data["documentTypeId"];
      this.medicalConditionId = _data["medicalConditionId"];
      this.medicalConditionDetailId = _data["medicalConditionDetailId"];
      this.documentId = _data["documentId"];
      this.isRegistration = _data["isRegistration"];
      this.medicalPlanConditionId = _data["medicalPlanConditionId"];
      this.medicalPlanQuestionId = _data["medicalPlanQuestionId"];
      this.medicalPlanAnswerIndex = _data["medicalPlanAnswerIndex"];
      this.expiresOn = _data["expiresOn"] ? dayjs(_data["expiresOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): DocumentHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new DocumentHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["childId"] = this.childId;
    data["customerContactId"] = this.customerContactId;
    data["fileName"] = this.fileName;
    data["documentTypeId"] = this.documentTypeId;
    data["medicalConditionId"] = this.medicalConditionId;
    data["medicalConditionDetailId"] = this.medicalConditionDetailId;
    data["documentId"] = this.documentId;
    data["isRegistration"] = this.isRegistration;
    data["medicalPlanConditionId"] = this.medicalPlanConditionId;
    data["medicalPlanQuestionId"] = this.medicalPlanQuestionId;
    data["medicalPlanAnswerIndex"] = this.medicalPlanAnswerIndex;
    data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IDocumentHttpResponse {
  uniqueId: string;
  childId?: number | undefined;
  customerContactId?: number | undefined;
  fileName: string;
  documentTypeId: number;
  medicalConditionId?: number | undefined;
  medicalConditionDetailId?: number | undefined;
  documentId?: number | undefined;
  isRegistration: boolean;
  medicalPlanConditionId?: number | undefined;
  medicalPlanQuestionId?: number | undefined;
  medicalPlanAnswerIndex?: number | undefined;
  expiresOn?: dayjs.Dayjs | undefined;
}

export abstract class CustomerContactHttpRequestBase implements ICustomerContactHttpRequestBase {
  contactTypeId!: number;
  firstName!: string;
  lastName!: string;
  birthday!: dayjs.Dayjs;
  email!: string;
  mobilePhone!: string;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy?: boolean | undefined;
  avatarIndex?: number | undefined;
  residentialAddress!: CreateAddressHttpRequest;
  authorisation!: AuthorisationHttpRequest;
  documentIdsAdded?: string[] | undefined;
  documentIdsDeleted?: string[] | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  signature?: ParentAuthorizationHttpRequest | undefined;

  constructor(data?: ICustomerContactHttpRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.residentialAddress = new CreateAddressHttpRequest();
      this.authorisation = new AuthorisationHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contactTypeId = _data["contactTypeId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.email = _data["email"];
      this.mobilePhone = _data["mobilePhone"];
      this.homePhone = _data["homePhone"];
      this.workPhone = _data["workPhone"];
      this.crn = _data["crn"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.planToClaimChildCareSubsidy = _data["planToClaimChildCareSubsidy"];
      this.avatarIndex = _data["avatarIndex"];
      this.residentialAddress = _data["residentialAddress"]
        ? CreateAddressHttpRequest.fromJS(_data["residentialAddress"])
        : new CreateAddressHttpRequest();
      this.authorisation = _data["authorisation"]
        ? AuthorisationHttpRequest.fromJS(_data["authorisation"])
        : new AuthorisationHttpRequest();
      if (Array.isArray(_data["documentIdsAdded"])) {
        this.documentIdsAdded = [] as any;
        for (let item of _data["documentIdsAdded"]) this.documentIdsAdded!.push(item);
      }
      if (Array.isArray(_data["documentIdsDeleted"])) {
        this.documentIdsDeleted = [] as any;
        for (let item of _data["documentIdsDeleted"]) this.documentIdsDeleted!.push(item);
      }
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
      this.signature = _data["signature"]
        ? ParentAuthorizationHttpRequest.fromJS(_data["signature"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): CustomerContactHttpRequestBase {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'CustomerContactHttpRequestBase' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contactTypeId"] = this.contactTypeId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["email"] = this.email;
    data["mobilePhone"] = this.mobilePhone;
    data["homePhone"] = this.homePhone;
    data["workPhone"] = this.workPhone;
    data["crn"] = this.crn;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["planToClaimChildCareSubsidy"] = this.planToClaimChildCareSubsidy;
    data["avatarIndex"] = this.avatarIndex;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["authorisation"] = this.authorisation ? this.authorisation.toJSON() : (undefined as any);
    if (Array.isArray(this.documentIdsAdded)) {
      data["documentIdsAdded"] = [];
      for (let item of this.documentIdsAdded) data["documentIdsAdded"].push(item);
    }
    if (Array.isArray(this.documentIdsDeleted)) {
      data["documentIdsDeleted"] = [];
      for (let item of this.documentIdsDeleted) data["documentIdsDeleted"].push(item);
    }
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    data["signature"] = this.signature ? this.signature.toJSON() : (undefined as any);
    return data;
  }
}

export interface ICustomerContactHttpRequestBase {
  contactTypeId: number;
  firstName: string;
  lastName: string;
  birthday: dayjs.Dayjs;
  email: string;
  mobilePhone: string;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy?: boolean | undefined;
  avatarIndex?: number | undefined;
  residentialAddress: CreateAddressHttpRequest;
  authorisation: AuthorisationHttpRequest;
  documentIdsAdded?: string[] | undefined;
  documentIdsDeleted?: string[] | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  signature?: ParentAuthorizationHttpRequest | undefined;
}

export class CreateCustomerContactHttpRequest
  extends CustomerContactHttpRequestBase
  implements ICreateCustomerContactHttpRequest
{
  constructor(data?: ICreateCustomerContactHttpRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): CreateCustomerContactHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateCustomerContactHttpRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ICreateCustomerContactHttpRequest extends ICustomerContactHttpRequestBase {}

export class AuthorisationHttpRequest implements IAuthorisationHttpRequest {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;

  constructor(data?: IAuthorisationHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canApproveAmbulance = _data["canApproveAmbulance"];
      this.canManageAccount = _data["canManageAccount"];
      this.canMakeAndChangeBookings = _data["canMakeAndChangeBookings"];
      this.canPickUpChild = _data["canPickUpChild"];
      this.consentToAdministerMedicine = _data["consentToAdministerMedicine"];
      this.consentToMedicalTreatment = _data["consentToMedicalTreatment"];
      this.consentToTakeOutsidePremises = _data["consentToTakeOutsidePremises"];
      this.consentForTransportation = _data["consentForTransportation"];
    }
  }

  static fromJS(data: any): AuthorisationHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new AuthorisationHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canApproveAmbulance"] = this.canApproveAmbulance;
    data["canManageAccount"] = this.canManageAccount;
    data["canMakeAndChangeBookings"] = this.canMakeAndChangeBookings;
    data["canPickUpChild"] = this.canPickUpChild;
    data["consentToAdministerMedicine"] = this.consentToAdministerMedicine;
    data["consentToMedicalTreatment"] = this.consentToMedicalTreatment;
    data["consentToTakeOutsidePremises"] = this.consentToTakeOutsidePremises;
    data["consentForTransportation"] = this.consentForTransportation;
    return data;
  }
}

export interface IAuthorisationHttpRequest {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;
}

export class UpdateCustomerContactHttpRequest
  extends CustomerContactHttpRequestBase
  implements IUpdateCustomerContactHttpRequest
{
  customerContactId!: number;
  ccbSubmissionContactId?: number | undefined;
  childCrns?: ChildCrnPair[] | undefined;
  childrenIdsToUpdateAddress!: number[];

  constructor(data?: IUpdateCustomerContactHttpRequest) {
    super(data);
    if (!data) {
      this.childrenIdsToUpdateAddress = [];
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.ccbSubmissionContactId = _data["ccbSubmissionContactId"];
      if (Array.isArray(_data["childCrns"])) {
        this.childCrns = [] as any;
        for (let item of _data["childCrns"]) this.childCrns!.push(ChildCrnPair.fromJS(item));
      }
      if (Array.isArray(_data["childrenIdsToUpdateAddress"])) {
        this.childrenIdsToUpdateAddress = [] as any;
        for (let item of _data["childrenIdsToUpdateAddress"]) this.childrenIdsToUpdateAddress!.push(item);
      }
    }
  }

  static override fromJS(data: any): UpdateCustomerContactHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateCustomerContactHttpRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["ccbSubmissionContactId"] = this.ccbSubmissionContactId;
    if (Array.isArray(this.childCrns)) {
      data["childCrns"] = [];
      for (let item of this.childCrns) data["childCrns"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.childrenIdsToUpdateAddress)) {
      data["childrenIdsToUpdateAddress"] = [];
      for (let item of this.childrenIdsToUpdateAddress) data["childrenIdsToUpdateAddress"].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateCustomerContactHttpRequest extends ICustomerContactHttpRequestBase {
  customerContactId: number;
  ccbSubmissionContactId?: number | undefined;
  childCrns?: ChildCrnPair[] | undefined;
  childrenIdsToUpdateAddress: number[];
}

export class ChildCrnPair implements IChildCrnPair {
  childId!: number;
  crn!: string;
  birthday?: dayjs.Dayjs | undefined;

  constructor(data?: IChildCrnPair) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.crn = _data["crn"];
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): ChildCrnPair {
    data = typeof data === "object" ? data : {};
    let result = new ChildCrnPair();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["crn"] = this.crn;
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    return data;
  }
}

export interface IChildCrnPair {
  childId: number;
  crn: string;
  birthday?: dayjs.Dayjs | undefined;
}

export class ChangePasswordByOtpHttpRequest implements IChangePasswordByOtpHttpRequest {
  email!: string;
  otp!: string;
  password!: string;

  constructor(data?: IChangePasswordByOtpHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.otp = _data["otp"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): ChangePasswordByOtpHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordByOtpHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["otp"] = this.otp;
    data["password"] = this.password;
    return data;
  }
}

export interface IChangePasswordByOtpHttpRequest {
  email: string;
  otp: string;
  password: string;
}

export class RegisterDeviceHttpRequest implements IRegisterDeviceHttpRequest {
  model!: string;
  platform!: string;
  deviceFcmToken!: string;

  constructor(data?: IRegisterDeviceHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.model = _data["model"];
      this.platform = _data["platform"];
      this.deviceFcmToken = _data["deviceFcmToken"];
    }
  }

  static fromJS(data: any): RegisterDeviceHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RegisterDeviceHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["model"] = this.model;
    data["platform"] = this.platform;
    data["deviceFcmToken"] = this.deviceFcmToken;
    return data;
  }
}

export interface IRegisterDeviceHttpRequest {
  model: string;
  platform: string;
  deviceFcmToken: string;
}

export class ProgramVersionSummary implements IProgramVersionSummary {
  experienceNames?: string | undefined;
  programId!: number;
  serviceId!: number;
  serviceName?: string | undefined;
  careTypeGroupId!: number;
  publishStatusId!: number;
  submittedAt?: dayjs.Dayjs | undefined;
  employeeId!: number;
  version!: number;
  createdAt!: dayjs.Dayjs;
  isCurrent!: boolean;
  programVersionId!: number;
  themeId?: number | undefined;
  themeName?: string | undefined;
  careTypeGroup?: string | undefined;
  weekOf?: dayjs.Dayjs | undefined;
  isTemplate!: boolean;
  learningOutcomeNames?: string | undefined;
  versionRespondedAt?: dayjs.Dayjs | undefined;
  versionRespondedBy?: string | undefined;
  versionUpdatedAt?: dayjs.Dayjs | undefined;
  versionUpdatedBy?: string | undefined;
  fromAgeOptionId?: number | undefined;
  fromAgeOption?: string | undefined;
  fromAgeOptionOtherText?: string | undefined;
  toAgeOptionId?: number | undefined;
  toAgeOption?: string | undefined;
  toAgeOptionOtherText?: string | undefined;
  isInFuture!: boolean;
  rocketeersSeasonId?: number | undefined;
  rocketeersSeasonServiceId?: number | undefined;
  rollId?: number | undefined;
  rollName?: string | undefined;
  clientCode?: string | undefined;

  constructor(data?: IProgramVersionSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.experienceNames = _data["experienceNames"];
      this.programId = _data["programId"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.careTypeGroupId = _data["careTypeGroupId"];
      this.publishStatusId = _data["publishStatusId"];
      this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : (undefined as any);
      this.employeeId = _data["employeeId"];
      this.version = _data["version"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.isCurrent = _data["isCurrent"];
      this.programVersionId = _data["programVersionId"];
      this.themeId = _data["themeId"];
      this.themeName = _data["themeName"];
      this.careTypeGroup = _data["careTypeGroup"];
      this.weekOf = _data["weekOf"] ? dayjs(_data["weekOf"].toString()) : (undefined as any);
      this.isTemplate = _data["isTemplate"];
      this.learningOutcomeNames = _data["learningOutcomeNames"];
      this.versionRespondedAt = _data["versionRespondedAt"]
        ? dayjs(_data["versionRespondedAt"].toString())
        : (undefined as any);
      this.versionRespondedBy = _data["versionRespondedBy"];
      this.versionUpdatedAt = _data["versionUpdatedAt"]
        ? dayjs(_data["versionUpdatedAt"].toString())
        : (undefined as any);
      this.versionUpdatedBy = _data["versionUpdatedBy"];
      this.fromAgeOptionId = _data["fromAgeOptionId"];
      this.fromAgeOption = _data["fromAgeOption"];
      this.fromAgeOptionOtherText = _data["fromAgeOptionOtherText"];
      this.toAgeOptionId = _data["toAgeOptionId"];
      this.toAgeOption = _data["toAgeOption"];
      this.toAgeOptionOtherText = _data["toAgeOptionOtherText"];
      this.isInFuture = _data["isInFuture"];
      this.rocketeersSeasonId = _data["rocketeersSeasonId"];
      this.rocketeersSeasonServiceId = _data["rocketeersSeasonServiceId"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.clientCode = _data["clientCode"];
    }
  }

  static fromJS(data: any): ProgramVersionSummary {
    data = typeof data === "object" ? data : {};
    let result = new ProgramVersionSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["experienceNames"] = this.experienceNames;
    data["programId"] = this.programId;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["careTypeGroupId"] = this.careTypeGroupId;
    data["publishStatusId"] = this.publishStatusId;
    data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : (undefined as any);
    data["employeeId"] = this.employeeId;
    data["version"] = this.version;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["isCurrent"] = this.isCurrent;
    data["programVersionId"] = this.programVersionId;
    data["themeId"] = this.themeId;
    data["themeName"] = this.themeName;
    data["careTypeGroup"] = this.careTypeGroup;
    data["weekOf"] = this.weekOf ? this.weekOf.toISOString() : (undefined as any);
    data["isTemplate"] = this.isTemplate;
    data["learningOutcomeNames"] = this.learningOutcomeNames;
    data["versionRespondedAt"] = this.versionRespondedAt ? this.versionRespondedAt.toISOString() : (undefined as any);
    data["versionRespondedBy"] = this.versionRespondedBy;
    data["versionUpdatedAt"] = this.versionUpdatedAt ? this.versionUpdatedAt.toISOString() : (undefined as any);
    data["versionUpdatedBy"] = this.versionUpdatedBy;
    data["fromAgeOptionId"] = this.fromAgeOptionId;
    data["fromAgeOption"] = this.fromAgeOption;
    data["fromAgeOptionOtherText"] = this.fromAgeOptionOtherText;
    data["toAgeOptionId"] = this.toAgeOptionId;
    data["toAgeOption"] = this.toAgeOption;
    data["toAgeOptionOtherText"] = this.toAgeOptionOtherText;
    data["isInFuture"] = this.isInFuture;
    data["rocketeersSeasonId"] = this.rocketeersSeasonId;
    data["rocketeersSeasonServiceId"] = this.rocketeersSeasonServiceId;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["clientCode"] = this.clientCode;
    return data;
  }
}

export interface IProgramVersionSummary {
  experienceNames?: string | undefined;
  programId: number;
  serviceId: number;
  serviceName?: string | undefined;
  careTypeGroupId: number;
  publishStatusId: number;
  submittedAt?: dayjs.Dayjs | undefined;
  employeeId: number;
  version: number;
  createdAt: dayjs.Dayjs;
  isCurrent: boolean;
  programVersionId: number;
  themeId?: number | undefined;
  themeName?: string | undefined;
  careTypeGroup?: string | undefined;
  weekOf?: dayjs.Dayjs | undefined;
  isTemplate: boolean;
  learningOutcomeNames?: string | undefined;
  versionRespondedAt?: dayjs.Dayjs | undefined;
  versionRespondedBy?: string | undefined;
  versionUpdatedAt?: dayjs.Dayjs | undefined;
  versionUpdatedBy?: string | undefined;
  fromAgeOptionId?: number | undefined;
  fromAgeOption?: string | undefined;
  fromAgeOptionOtherText?: string | undefined;
  toAgeOptionId?: number | undefined;
  toAgeOption?: string | undefined;
  toAgeOptionOtherText?: string | undefined;
  isInFuture: boolean;
  rocketeersSeasonId?: number | undefined;
  rocketeersSeasonServiceId?: number | undefined;
  rollId?: number | undefined;
  rollName?: string | undefined;
  clientCode?: string | undefined;
}

export class DigitalProgramDetailsHttpResponse implements IDigitalProgramDetailsHttpResponse {
  programVersion?: ProgramVersionExtended | undefined;
  areas!: ProgramAreaExperienceSummary[];
  zones!: ProgramZoneExperienceSummary[];

  constructor(data?: IDigitalProgramDetailsHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.areas = [];
      this.zones = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programVersion = _data["programVersion"]
        ? ProgramVersionExtended.fromJS(_data["programVersion"])
        : (undefined as any);
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"]) this.areas!.push(ProgramAreaExperienceSummary.fromJS(item));
      }
      if (Array.isArray(_data["zones"])) {
        this.zones = [] as any;
        for (let item of _data["zones"]) this.zones!.push(ProgramZoneExperienceSummary.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DigitalProgramDetailsHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new DigitalProgramDetailsHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programVersion"] = this.programVersion ? this.programVersion.toJSON() : (undefined as any);
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas) data["areas"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.zones)) {
      data["zones"] = [];
      for (let item of this.zones) data["zones"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IDigitalProgramDetailsHttpResponse {
  programVersion?: ProgramVersionExtended | undefined;
  areas: ProgramAreaExperienceSummary[];
  zones: ProgramZoneExperienceSummary[];
}

export class ProgramVersionExtended implements IProgramVersionExtended {
  programId!: number;
  serviceId!: number;
  careTypeGroupId!: number;
  isTemplate!: boolean;
  weekOf?: dayjs.Dayjs | undefined;
  publishStatusId!: number;
  submittedAt?: dayjs.Dayjs | undefined;
  employeeId!: number;
  version!: number;
  createdAt!: dayjs.Dayjs;
  isCurrent!: boolean;
  programVersionId!: number;
  publishComment?: string | undefined;
  themeId?: number | undefined;
  themeName?: string | undefined;
  careTypeGroup?: string | undefined;
  serviceName?: string | undefined;
  fromAgeOptionId?: number | undefined;
  fromAgeOption?: string | undefined;
  fromAgeOptionOtherText?: string | undefined;
  toAgeOptionId?: number | undefined;
  toAgeOption?: string | undefined;
  toAgeOptionOtherText?: string | undefined;
  isInFuture!: boolean;
  rocketeersSeasonId?: number | undefined;
  rocketeersSeasonServiceId?: number | undefined;
  rollId?: number | undefined;
  rollName?: string | undefined;
  clientCode?: string | undefined;

  constructor(data?: IProgramVersionExtended) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.serviceId = _data["serviceId"];
      this.careTypeGroupId = _data["careTypeGroupId"];
      this.isTemplate = _data["isTemplate"];
      this.weekOf = _data["weekOf"] ? dayjs(_data["weekOf"].toString()) : (undefined as any);
      this.publishStatusId = _data["publishStatusId"];
      this.submittedAt = _data["submittedAt"] ? dayjs(_data["submittedAt"].toString()) : (undefined as any);
      this.employeeId = _data["employeeId"];
      this.version = _data["version"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.isCurrent = _data["isCurrent"];
      this.programVersionId = _data["programVersionId"];
      this.publishComment = _data["publishComment"];
      this.themeId = _data["themeId"];
      this.themeName = _data["themeName"];
      this.careTypeGroup = _data["careTypeGroup"];
      this.serviceName = _data["serviceName"];
      this.fromAgeOptionId = _data["fromAgeOptionId"];
      this.fromAgeOption = _data["fromAgeOption"];
      this.fromAgeOptionOtherText = _data["fromAgeOptionOtherText"];
      this.toAgeOptionId = _data["toAgeOptionId"];
      this.toAgeOption = _data["toAgeOption"];
      this.toAgeOptionOtherText = _data["toAgeOptionOtherText"];
      this.isInFuture = _data["isInFuture"];
      this.rocketeersSeasonId = _data["rocketeersSeasonId"];
      this.rocketeersSeasonServiceId = _data["rocketeersSeasonServiceId"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.clientCode = _data["clientCode"];
    }
  }

  static fromJS(data: any): ProgramVersionExtended {
    data = typeof data === "object" ? data : {};
    let result = new ProgramVersionExtended();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programId"] = this.programId;
    data["serviceId"] = this.serviceId;
    data["careTypeGroupId"] = this.careTypeGroupId;
    data["isTemplate"] = this.isTemplate;
    data["weekOf"] = this.weekOf ? this.weekOf.toISOString() : (undefined as any);
    data["publishStatusId"] = this.publishStatusId;
    data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : (undefined as any);
    data["employeeId"] = this.employeeId;
    data["version"] = this.version;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["isCurrent"] = this.isCurrent;
    data["programVersionId"] = this.programVersionId;
    data["publishComment"] = this.publishComment;
    data["themeId"] = this.themeId;
    data["themeName"] = this.themeName;
    data["careTypeGroup"] = this.careTypeGroup;
    data["serviceName"] = this.serviceName;
    data["fromAgeOptionId"] = this.fromAgeOptionId;
    data["fromAgeOption"] = this.fromAgeOption;
    data["fromAgeOptionOtherText"] = this.fromAgeOptionOtherText;
    data["toAgeOptionId"] = this.toAgeOptionId;
    data["toAgeOption"] = this.toAgeOption;
    data["toAgeOptionOtherText"] = this.toAgeOptionOtherText;
    data["isInFuture"] = this.isInFuture;
    data["rocketeersSeasonId"] = this.rocketeersSeasonId;
    data["rocketeersSeasonServiceId"] = this.rocketeersSeasonServiceId;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["clientCode"] = this.clientCode;
    return data;
  }
}

export interface IProgramVersionExtended {
  programId: number;
  serviceId: number;
  careTypeGroupId: number;
  isTemplate: boolean;
  weekOf?: dayjs.Dayjs | undefined;
  publishStatusId: number;
  submittedAt?: dayjs.Dayjs | undefined;
  employeeId: number;
  version: number;
  createdAt: dayjs.Dayjs;
  isCurrent: boolean;
  programVersionId: number;
  publishComment?: string | undefined;
  themeId?: number | undefined;
  themeName?: string | undefined;
  careTypeGroup?: string | undefined;
  serviceName?: string | undefined;
  fromAgeOptionId?: number | undefined;
  fromAgeOption?: string | undefined;
  fromAgeOptionOtherText?: string | undefined;
  toAgeOptionId?: number | undefined;
  toAgeOption?: string | undefined;
  toAgeOptionOtherText?: string | undefined;
  isInFuture: boolean;
  rocketeersSeasonId?: number | undefined;
  rocketeersSeasonServiceId?: number | undefined;
  rollId?: number | undefined;
  rollName?: string | undefined;
  clientCode?: string | undefined;
}

export class ProgramAreaExperienceSummary implements IProgramAreaExperienceSummary {
  programAreaId!: number;
  careTypeGroupId!: number;
  name!: string;
  description?: string | undefined;
  sortOrder!: number;
  programId!: number;
  serviceId!: number;
  programVersionId!: number;
  isAllWeek!: boolean;
  allowEdit?: boolean | undefined;
  canModifyBeforeWeek!: boolean;
  canModifyAfterWeek!: boolean;
  weekOf?: dayjs.Dayjs | undefined;
  programAreaTypeId!: number;
  days!: ProgramAreaDayExperienceSummary[];

  constructor(data?: IProgramAreaExperienceSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.days = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programAreaId = _data["programAreaId"];
      this.careTypeGroupId = _data["careTypeGroupId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.sortOrder = _data["sortOrder"];
      this.programId = _data["programId"];
      this.serviceId = _data["serviceId"];
      this.programVersionId = _data["programVersionId"];
      this.isAllWeek = _data["isAllWeek"];
      this.allowEdit = _data["allowEdit"];
      this.canModifyBeforeWeek = _data["canModifyBeforeWeek"];
      this.canModifyAfterWeek = _data["canModifyAfterWeek"];
      this.weekOf = _data["weekOf"] ? dayjs(_data["weekOf"].toString()) : (undefined as any);
      this.programAreaTypeId = _data["programAreaTypeId"];
      if (Array.isArray(_data["days"])) {
        this.days = [] as any;
        for (let item of _data["days"]) this.days!.push(ProgramAreaDayExperienceSummary.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProgramAreaExperienceSummary {
    data = typeof data === "object" ? data : {};
    let result = new ProgramAreaExperienceSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programAreaId"] = this.programAreaId;
    data["careTypeGroupId"] = this.careTypeGroupId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["sortOrder"] = this.sortOrder;
    data["programId"] = this.programId;
    data["serviceId"] = this.serviceId;
    data["programVersionId"] = this.programVersionId;
    data["isAllWeek"] = this.isAllWeek;
    data["allowEdit"] = this.allowEdit;
    data["canModifyBeforeWeek"] = this.canModifyBeforeWeek;
    data["canModifyAfterWeek"] = this.canModifyAfterWeek;
    data["weekOf"] = this.weekOf ? this.weekOf.toISOString() : (undefined as any);
    data["programAreaTypeId"] = this.programAreaTypeId;
    if (Array.isArray(this.days)) {
      data["days"] = [];
      for (let item of this.days) data["days"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IProgramAreaExperienceSummary {
  programAreaId: number;
  careTypeGroupId: number;
  name: string;
  description?: string | undefined;
  sortOrder: number;
  programId: number;
  serviceId: number;
  programVersionId: number;
  isAllWeek: boolean;
  allowEdit?: boolean | undefined;
  canModifyBeforeWeek: boolean;
  canModifyAfterWeek: boolean;
  weekOf?: dayjs.Dayjs | undefined;
  programAreaTypeId: number;
  days: ProgramAreaDayExperienceSummary[];
}

export class ProgramAreaDayExperienceSummary implements IProgramAreaDayExperienceSummary {
  programAreaId!: number;
  dayOfWeek!: number;
  date?: dayjs.Dayjs | undefined;
  content?: string | undefined;
  experienceId?: number | undefined;
  experienceVersionId?: number | undefined;
  experienceName?: string | undefined;
  experienceSummary?: string | undefined;
  theme?: string | undefined;
  duration?: string | undefined;
  experienceSourceId?: number | undefined;
  experienceSource?: string | undefined;
  experiencePublishStatusId?: number | undefined;
  learningOutcomes!: LearningOutcomeSimple[];
  skills!: LookupItem[];
  categories!: LookupItem[];
  programActivityTypeId?: number | undefined;
  programActivityType?: string | undefined;
  isAdminLocked!: boolean;
  hasShortBlurb!: boolean;
  hasLongBlurb!: boolean;

  constructor(data?: IProgramAreaDayExperienceSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.learningOutcomes = [];
      this.skills = [];
      this.categories = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programAreaId = _data["programAreaId"];
      this.dayOfWeek = _data["dayOfWeek"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.content = _data["content"];
      this.experienceId = _data["experienceId"];
      this.experienceVersionId = _data["experienceVersionId"];
      this.experienceName = _data["experienceName"];
      this.experienceSummary = _data["experienceSummary"];
      this.theme = _data["theme"];
      this.duration = _data["duration"];
      this.experienceSourceId = _data["experienceSourceId"];
      this.experienceSource = _data["experienceSource"];
      this.experiencePublishStatusId = _data["experiencePublishStatusId"];
      if (Array.isArray(_data["learningOutcomes"])) {
        this.learningOutcomes = [] as any;
        for (let item of _data["learningOutcomes"]) this.learningOutcomes!.push(LearningOutcomeSimple.fromJS(item));
      }
      if (Array.isArray(_data["skills"])) {
        this.skills = [] as any;
        for (let item of _data["skills"]) this.skills!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["categories"])) {
        this.categories = [] as any;
        for (let item of _data["categories"]) this.categories!.push(LookupItem.fromJS(item));
      }
      this.programActivityTypeId = _data["programActivityTypeId"];
      this.programActivityType = _data["programActivityType"];
      this.isAdminLocked = _data["isAdminLocked"];
      this.hasShortBlurb = _data["hasShortBlurb"];
      this.hasLongBlurb = _data["hasLongBlurb"];
    }
  }

  static fromJS(data: any): ProgramAreaDayExperienceSummary {
    data = typeof data === "object" ? data : {};
    let result = new ProgramAreaDayExperienceSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programAreaId"] = this.programAreaId;
    data["dayOfWeek"] = this.dayOfWeek;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["content"] = this.content;
    data["experienceId"] = this.experienceId;
    data["experienceVersionId"] = this.experienceVersionId;
    data["experienceName"] = this.experienceName;
    data["experienceSummary"] = this.experienceSummary;
    data["theme"] = this.theme;
    data["duration"] = this.duration;
    data["experienceSourceId"] = this.experienceSourceId;
    data["experienceSource"] = this.experienceSource;
    data["experiencePublishStatusId"] = this.experiencePublishStatusId;
    if (Array.isArray(this.learningOutcomes)) {
      data["learningOutcomes"] = [];
      for (let item of this.learningOutcomes) data["learningOutcomes"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.skills)) {
      data["skills"] = [];
      for (let item of this.skills) data["skills"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.categories)) {
      data["categories"] = [];
      for (let item of this.categories) data["categories"].push(item ? item.toJSON() : (undefined as any));
    }
    data["programActivityTypeId"] = this.programActivityTypeId;
    data["programActivityType"] = this.programActivityType;
    data["isAdminLocked"] = this.isAdminLocked;
    data["hasShortBlurb"] = this.hasShortBlurb;
    data["hasLongBlurb"] = this.hasLongBlurb;
    return data;
  }
}

export interface IProgramAreaDayExperienceSummary {
  programAreaId: number;
  dayOfWeek: number;
  date?: dayjs.Dayjs | undefined;
  content?: string | undefined;
  experienceId?: number | undefined;
  experienceVersionId?: number | undefined;
  experienceName?: string | undefined;
  experienceSummary?: string | undefined;
  theme?: string | undefined;
  duration?: string | undefined;
  experienceSourceId?: number | undefined;
  experienceSource?: string | undefined;
  experiencePublishStatusId?: number | undefined;
  learningOutcomes: LearningOutcomeSimple[];
  skills: LookupItem[];
  categories: LookupItem[];
  programActivityTypeId?: number | undefined;
  programActivityType?: string | undefined;
  isAdminLocked: boolean;
  hasShortBlurb: boolean;
  hasLongBlurb: boolean;
}

export class LearningOutcomeSimple implements ILearningOutcomeSimple {
  learningOutcomeId!: number;
  learningOutcomeGroupId!: number;
  name!: string;
  groupOrder!: number;
  order!: number;
  groupName!: string;

  constructor(data?: ILearningOutcomeSimple) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.learningOutcomeId = _data["learningOutcomeId"];
      this.learningOutcomeGroupId = _data["learningOutcomeGroupId"];
      this.name = _data["name"];
      this.groupOrder = _data["groupOrder"];
      this.order = _data["order"];
      this.groupName = _data["groupName"];
    }
  }

  static fromJS(data: any): LearningOutcomeSimple {
    data = typeof data === "object" ? data : {};
    let result = new LearningOutcomeSimple();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["learningOutcomeId"] = this.learningOutcomeId;
    data["learningOutcomeGroupId"] = this.learningOutcomeGroupId;
    data["name"] = this.name;
    data["groupOrder"] = this.groupOrder;
    data["order"] = this.order;
    data["groupName"] = this.groupName;
    return data;
  }
}

export interface ILearningOutcomeSimple {
  learningOutcomeId: number;
  learningOutcomeGroupId: number;
  name: string;
  groupOrder: number;
  order: number;
  groupName: string;
}

export class LookupItem implements ILookupItem {
  id!: number;
  name!: string;

  constructor(data?: ILookupItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): LookupItem {
    data = typeof data === "object" ? data : {};
    let result = new LookupItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface ILookupItem {
  id: number;
  name: string;
}

export class ProgramZoneExperienceSummary implements IProgramZoneExperienceSummary {
  slotNumber!: number;
  zoneId?: number | undefined;
  zoneName?: string | undefined;
  content?: string | undefined;

  constructor(data?: IProgramZoneExperienceSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slotNumber = _data["slotNumber"];
      this.zoneId = _data["zoneId"];
      this.zoneName = _data["zoneName"];
      this.content = _data["content"];
    }
  }

  static fromJS(data: any): ProgramZoneExperienceSummary {
    data = typeof data === "object" ? data : {};
    let result = new ProgramZoneExperienceSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["slotNumber"] = this.slotNumber;
    data["zoneId"] = this.zoneId;
    data["zoneName"] = this.zoneName;
    data["content"] = this.content;
    return data;
  }
}

export interface IProgramZoneExperienceSummary {
  slotNumber: number;
  zoneId?: number | undefined;
  zoneName?: string | undefined;
  content?: string | undefined;
}

export class NationalProgramHttpResponse implements INationalProgramHttpResponse {
  programId!: number;
  rollId!: number;
  rollName?: string | undefined;
  date!: dayjs.Dayjs;
  serviceId!: number;
  serviceName?: string | undefined;
  programVersionId!: number;
  sessionId!: number;
  theme!: string;
  shortBlurb?: string | undefined;
  longBlurb?: string | undefined;
  experienceVersionId!: number;
  experienceName?: string | undefined;
  previewFileId!: number;
  surcharge?: number | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  providerCode?: string | undefined;
  classificationId!: number;
  classification!: string;
  seasonName!: string;
  seasonStartDate!: dayjs.Dayjs;
  seasonEndDate?: dayjs.Dayjs | undefined;
  isCasualFee!: boolean;
  learningOutcomes!: LearningOutcome[];
  session!: SessionInfo;

  constructor(data?: INationalProgramHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.learningOutcomes = [];
      this.session = new SessionInfo();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.programVersionId = _data["programVersionId"];
      this.sessionId = _data["sessionId"];
      this.theme = _data["theme"];
      this.shortBlurb = _data["shortBlurb"];
      this.longBlurb = _data["longBlurb"];
      this.experienceVersionId = _data["experienceVersionId"];
      this.experienceName = _data["experienceName"];
      this.previewFileId = _data["previewFileId"];
      this.surcharge = _data["surcharge"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.excursionLeaveTime = _data["excursionLeaveTime"]
        ? dayjs(_data["excursionLeaveTime"].toString())
        : (undefined as any);
      this.excursionReturnTime = _data["excursionReturnTime"]
        ? dayjs(_data["excursionReturnTime"].toString())
        : (undefined as any);
      this.providerCode = _data["providerCode"];
      this.classificationId = _data["classificationId"];
      this.classification = _data["classification"];
      this.seasonName = _data["seasonName"];
      this.seasonStartDate = _data["seasonStartDate"] ? dayjs(_data["seasonStartDate"].toString()) : (undefined as any);
      this.seasonEndDate = _data["seasonEndDate"] ? dayjs(_data["seasonEndDate"].toString()) : (undefined as any);
      this.isCasualFee = _data["isCasualFee"];
      if (Array.isArray(_data["learningOutcomes"])) {
        this.learningOutcomes = [] as any;
        for (let item of _data["learningOutcomes"]) this.learningOutcomes!.push(LearningOutcome.fromJS(item));
      }
      this.session = _data["session"] ? SessionInfo.fromJS(_data["session"]) : new SessionInfo();
    }
  }

  static fromJS(data: any): NationalProgramHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new NationalProgramHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programId"] = this.programId;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["programVersionId"] = this.programVersionId;
    data["sessionId"] = this.sessionId;
    data["theme"] = this.theme;
    data["shortBlurb"] = this.shortBlurb;
    data["longBlurb"] = this.longBlurb;
    data["experienceVersionId"] = this.experienceVersionId;
    data["experienceName"] = this.experienceName;
    data["previewFileId"] = this.previewFileId;
    data["surcharge"] = this.surcharge;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["excursionLeaveTime"] = this.excursionLeaveTime
      ? this.excursionLeaveTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["excursionReturnTime"] = this.excursionReturnTime
      ? this.excursionReturnTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["providerCode"] = this.providerCode;
    data["classificationId"] = this.classificationId;
    data["classification"] = this.classification;
    data["seasonName"] = this.seasonName;
    data["seasonStartDate"] = this.seasonStartDate ? this.seasonStartDate.toISOString() : (undefined as any);
    data["seasonEndDate"] = this.seasonEndDate ? this.seasonEndDate.toISOString() : (undefined as any);
    data["isCasualFee"] = this.isCasualFee;
    if (Array.isArray(this.learningOutcomes)) {
      data["learningOutcomes"] = [];
      for (let item of this.learningOutcomes) data["learningOutcomes"].push(item ? item.toJSON() : (undefined as any));
    }
    data["session"] = this.session ? this.session.toJSON() : (undefined as any);
    return data;
  }
}

export interface INationalProgramHttpResponse {
  programId: number;
  rollId: number;
  rollName?: string | undefined;
  date: dayjs.Dayjs;
  serviceId: number;
  serviceName?: string | undefined;
  programVersionId: number;
  sessionId: number;
  theme: string;
  shortBlurb?: string | undefined;
  longBlurb?: string | undefined;
  experienceVersionId: number;
  experienceName?: string | undefined;
  previewFileId: number;
  surcharge?: number | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  providerCode?: string | undefined;
  classificationId: number;
  classification: string;
  seasonName: string;
  seasonStartDate: dayjs.Dayjs;
  seasonEndDate?: dayjs.Dayjs | undefined;
  isCasualFee: boolean;
  learningOutcomes: LearningOutcome[];
  session: SessionInfo;
}

export class LearningOutcome implements ILearningOutcome {
  learningOutcomeId!: number;
  learningOutcomeGroupId!: number;
  name!: string;
  groupOrder!: number;
  order!: number;
  groupName!: string;

  constructor(data?: ILearningOutcome) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.learningOutcomeId = _data["learningOutcomeId"];
      this.learningOutcomeGroupId = _data["learningOutcomeGroupId"];
      this.name = _data["name"];
      this.groupOrder = _data["groupOrder"];
      this.order = _data["order"];
      this.groupName = _data["groupName"];
    }
  }

  static fromJS(data: any): LearningOutcome {
    data = typeof data === "object" ? data : {};
    let result = new LearningOutcome();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["learningOutcomeId"] = this.learningOutcomeId;
    data["learningOutcomeGroupId"] = this.learningOutcomeGroupId;
    data["name"] = this.name;
    data["groupOrder"] = this.groupOrder;
    data["order"] = this.order;
    data["groupName"] = this.groupName;
    return data;
  }
}

export interface ILearningOutcome {
  learningOutcomeId: number;
  learningOutcomeGroupId: number;
  name: string;
  groupOrder: number;
  order: number;
  groupName: string;
}

export class SessionInfo implements ISessionInfo {
  date!: dayjs.Dayjs;
  sessionId!: number;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  serviceId!: number;
  sessionSubType?: string | undefined;
  sessionType?: string | undefined;
  rollId!: number;
  rollName?: string | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  minAgeMths!: number;
  maxAgeMths!: number;
  programActivityType?: string | undefined;
  programActivityTypeId?: number | undefined;
  ageCalculationMethod!: string;
  ageCalculation!: AgeCalculationMethod;
  defaultMinAgeMths!: number;
  defaultMaxAgeMths!: number;

  constructor(data?: ISessionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.sessionId = _data["sessionId"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.primaryFeeAmount = _data["primaryFeeAmount"];
      this.primaryFeeName = _data["primaryFeeName"];
      this.serviceId = _data["serviceId"];
      this.sessionSubType = _data["sessionSubType"];
      this.sessionType = _data["sessionType"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.casualFeeName = _data["casualFeeName"];
      this.casualFeeAmount = _data["casualFeeAmount"];
      this.minAgeMths = _data["minAgeMths"];
      this.maxAgeMths = _data["maxAgeMths"];
      this.programActivityType = _data["programActivityType"];
      this.programActivityTypeId = _data["programActivityTypeId"];
      this.ageCalculationMethod = _data["ageCalculationMethod"];
      this.ageCalculation = _data["ageCalculation"];
      this.defaultMinAgeMths = _data["defaultMinAgeMths"];
      this.defaultMaxAgeMths = _data["defaultMaxAgeMths"];
    }
  }

  static fromJS(data: any): SessionInfo {
    data = typeof data === "object" ? data : {};
    let result = new SessionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["sessionId"] = this.sessionId;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["primaryFeeAmount"] = this.primaryFeeAmount;
    data["primaryFeeName"] = this.primaryFeeName;
    data["serviceId"] = this.serviceId;
    data["sessionSubType"] = this.sessionSubType;
    data["sessionType"] = this.sessionType;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["casualFeeName"] = this.casualFeeName;
    data["casualFeeAmount"] = this.casualFeeAmount;
    data["minAgeMths"] = this.minAgeMths;
    data["maxAgeMths"] = this.maxAgeMths;
    data["programActivityType"] = this.programActivityType;
    data["programActivityTypeId"] = this.programActivityTypeId;
    data["ageCalculationMethod"] = this.ageCalculationMethod;
    data["ageCalculation"] = this.ageCalculation;
    data["defaultMinAgeMths"] = this.defaultMinAgeMths;
    data["defaultMaxAgeMths"] = this.defaultMaxAgeMths;
    return data;
  }
}

export interface ISessionInfo {
  date: dayjs.Dayjs;
  sessionId: number;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  serviceId: number;
  sessionSubType?: string | undefined;
  sessionType?: string | undefined;
  rollId: number;
  rollName?: string | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  minAgeMths: number;
  maxAgeMths: number;
  programActivityType?: string | undefined;
  programActivityTypeId?: number | undefined;
  ageCalculationMethod: string;
  ageCalculation: AgeCalculationMethod;
  defaultMinAgeMths: number;
  defaultMaxAgeMths: number;
}

export class ServiceWithUpcomingProgram implements IServiceWithUpcomingProgram {
  service!: Service;
  distanceKM!: number;
  programsCount!: number;

  constructor(data?: IServiceWithUpcomingProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.service = new Service();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.service = _data["service"] ? Service.fromJS(_data["service"]) : new Service();
      this.distanceKM = _data["distanceKM"];
      this.programsCount = _data["programsCount"];
    }
  }

  static fromJS(data: any): ServiceWithUpcomingProgram {
    data = typeof data === "object" ? data : {};
    let result = new ServiceWithUpcomingProgram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["service"] = this.service ? this.service.toJSON() : (undefined as any);
    data["distanceKM"] = this.distanceKM;
    data["programsCount"] = this.programsCount;
    return data;
  }
}

export interface IServiceWithUpcomingProgram {
  service: Service;
  distanceKM: number;
  programsCount: number;
}

export class Service implements IService {
  serviceId!: number;
  isOperating?: boolean | undefined;
  licensedPlaces?: number | undefined;
  primaryAddressCountry?: string | undefined;
  primaryAddressPostcode?: string | undefined;
  primaryAddressState?: string | undefined;
  primaryAddressStreet?: string | undefined;
  primaryAddressSuburb?: string | undefined;
  primaryAddressType?: string | undefined;
  serviceName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
  currentDateTimeOffset!: dayjs.Dayjs;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumBookingFeeDaysForDiscount?: number | undefined;
  firstMinimumBookingsRequired?: number | undefined;
  checkCapacityForScheduledBookings?: boolean | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking!: number;
  minimumVacBookingFeeDaysForDiscount!: number;
  isNationalProgrammingEnabled!: boolean;
  minRepetitiveBookingsRequired!: number;

  constructor(data?: IService) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.isOperating = _data["isOperating"];
      this.licensedPlaces = _data["licensedPlaces"];
      this.primaryAddressCountry = _data["primaryAddressCountry"];
      this.primaryAddressPostcode = _data["primaryAddressPostcode"];
      this.primaryAddressState = _data["primaryAddressState"];
      this.primaryAddressStreet = _data["primaryAddressStreet"];
      this.primaryAddressSuburb = _data["primaryAddressSuburb"];
      this.primaryAddressType = _data["primaryAddressType"];
      this.serviceName = _data["serviceName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
      this.mobile = _data["mobile"];
      this.currentDateTimeOffset = _data["currentDateTimeOffset"]
        ? dayjs(_data["currentDateTimeOffset"].toString())
        : (undefined as any);
      this.minimumDaysToAvoidCancellationFeeRecurringBooking =
        _data["minimumDaysToAvoidCancellationFeeRecurringBooking"];
      this.minimumDaysToAvoidCancellationFeeCasualBooking = _data["minimumDaysToAvoidCancellationFeeCasualBooking"];
      this.minimumBookingFeeDaysForDiscount = _data["minimumBookingFeeDaysForDiscount"];
      this.firstMinimumBookingsRequired = _data["firstMinimumBookingsRequired"];
      this.checkCapacityForScheduledBookings = _data["checkCapacityForScheduledBookings"];
      this.minimumDaysToAvoidCancellationFeeVacBooking = _data["minimumDaysToAvoidCancellationFeeVacBooking"];
      this.minimumVacBookingFeeDaysForDiscount = _data["minimumVacBookingFeeDaysForDiscount"];
      this.isNationalProgrammingEnabled = _data["isNationalProgrammingEnabled"];
      this.minRepetitiveBookingsRequired = _data["minRepetitiveBookingsRequired"];
    }
  }

  static fromJS(data: any): Service {
    data = typeof data === "object" ? data : {};
    let result = new Service();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["isOperating"] = this.isOperating;
    data["licensedPlaces"] = this.licensedPlaces;
    data["primaryAddressCountry"] = this.primaryAddressCountry;
    data["primaryAddressPostcode"] = this.primaryAddressPostcode;
    data["primaryAddressState"] = this.primaryAddressState;
    data["primaryAddressStreet"] = this.primaryAddressStreet;
    data["primaryAddressSuburb"] = this.primaryAddressSuburb;
    data["primaryAddressType"] = this.primaryAddressType;
    data["serviceName"] = this.serviceName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    data["mobile"] = this.mobile;
    data["currentDateTimeOffset"] = this.currentDateTimeOffset
      ? this.currentDateTimeOffset.toISOString()
      : (undefined as any);
    data["minimumDaysToAvoidCancellationFeeRecurringBooking"] = this.minimumDaysToAvoidCancellationFeeRecurringBooking;
    data["minimumDaysToAvoidCancellationFeeCasualBooking"] = this.minimumDaysToAvoidCancellationFeeCasualBooking;
    data["minimumBookingFeeDaysForDiscount"] = this.minimumBookingFeeDaysForDiscount;
    data["firstMinimumBookingsRequired"] = this.firstMinimumBookingsRequired;
    data["checkCapacityForScheduledBookings"] = this.checkCapacityForScheduledBookings;
    data["minimumDaysToAvoidCancellationFeeVacBooking"] = this.minimumDaysToAvoidCancellationFeeVacBooking;
    data["minimumVacBookingFeeDaysForDiscount"] = this.minimumVacBookingFeeDaysForDiscount;
    data["isNationalProgrammingEnabled"] = this.isNationalProgrammingEnabled;
    data["minRepetitiveBookingsRequired"] = this.minRepetitiveBookingsRequired;
    return data;
  }
}

export interface IService {
  serviceId: number;
  isOperating?: boolean | undefined;
  licensedPlaces?: number | undefined;
  primaryAddressCountry?: string | undefined;
  primaryAddressPostcode?: string | undefined;
  primaryAddressState?: string | undefined;
  primaryAddressStreet?: string | undefined;
  primaryAddressSuburb?: string | undefined;
  primaryAddressType?: string | undefined;
  serviceName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
  currentDateTimeOffset: dayjs.Dayjs;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumBookingFeeDaysForDiscount?: number | undefined;
  firstMinimumBookingsRequired?: number | undefined;
  checkCapacityForScheduledBookings?: boolean | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking: number;
  minimumVacBookingFeeDaysForDiscount: number;
  isNationalProgrammingEnabled: boolean;
  minRepetitiveBookingsRequired: number;
}

export class PageableObjectOfServiceWithUpcomingProgram implements IPageableObjectOfServiceWithUpcomingProgram {
  records!: ServiceWithUpcomingProgram[];
  total!: number;

  constructor(data?: IPageableObjectOfServiceWithUpcomingProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.records = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["records"])) {
        this.records = [] as any;
        for (let item of _data["records"]) this.records!.push(ServiceWithUpcomingProgram.fromJS(item));
      }
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): PageableObjectOfServiceWithUpcomingProgram {
    data = typeof data === "object" ? data : {};
    let result = new PageableObjectOfServiceWithUpcomingProgram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.records)) {
      data["records"] = [];
      for (let item of this.records) data["records"].push(item ? item.toJSON() : (undefined as any));
    }
    data["total"] = this.total;
    return data;
  }
}

export interface IPageableObjectOfServiceWithUpcomingProgram {
  records: ServiceWithUpcomingProgram[];
  total: number;
}

export class ClassificationLookup implements IClassificationLookup {
  id!: number;
  name!: string;
  isRocketeers!: boolean;

  constructor(data?: IClassificationLookup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.isRocketeers = _data["isRocketeers"];
    }
  }

  static fromJS(data: any): ClassificationLookup {
    data = typeof data === "object" ? data : {};
    let result = new ClassificationLookup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["isRocketeers"] = this.isRocketeers;
    return data;
  }
}

export interface IClassificationLookup {
  id: number;
  name: string;
  isRocketeers: boolean;
}

export class GalleryPhoto implements IGalleryPhoto {
  uniqueId!: string;
  uploadedAt!: dayjs.Dayjs;
  title?: string | undefined;
  learningAreaName?: string | undefined;
  learningAreaDescription?: string | undefined;

  constructor(data?: IGalleryPhoto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.uploadedAt = _data["uploadedAt"] ? dayjs(_data["uploadedAt"].toString()) : (undefined as any);
      this.title = _data["title"];
      this.learningAreaName = _data["learningAreaName"];
      this.learningAreaDescription = _data["learningAreaDescription"];
    }
  }

  static fromJS(data: any): GalleryPhoto {
    data = typeof data === "object" ? data : {};
    let result = new GalleryPhoto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : (undefined as any);
    data["title"] = this.title;
    data["learningAreaName"] = this.learningAreaName;
    data["learningAreaDescription"] = this.learningAreaDescription;
    return data;
  }
}

export interface IGalleryPhoto {
  uniqueId: string;
  uploadedAt: dayjs.Dayjs;
  title?: string | undefined;
  learningAreaName?: string | undefined;
  learningAreaDescription?: string | undefined;
}

export class ImportResultHttpResponse implements IImportResultHttpResponse {
  result!: string;
  status!: string;
  customerAccountId?: number | undefined;

  constructor(data?: IImportResultHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.status = _data["status"];
      this.customerAccountId = _data["customerAccountId"];
    }
  }

  static fromJS(data: any): ImportResultHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ImportResultHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["result"] = this.result;
    data["status"] = this.status;
    data["customerAccountId"] = this.customerAccountId;
    return data;
  }
}

export interface IImportResultHttpResponse {
  result: string;
  status: string;
  customerAccountId?: number | undefined;
}

export class ImportBatchHttpResponse implements IImportBatchHttpResponse {
  created!: number;
  errors!: number;
  errorEmails!: string[];
  importedEmails!: string[];

  constructor(data?: IImportBatchHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.errorEmails = [];
      this.importedEmails = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.created = _data["created"];
      this.errors = _data["errors"];
      if (Array.isArray(_data["errorEmails"])) {
        this.errorEmails = [] as any;
        for (let item of _data["errorEmails"]) this.errorEmails!.push(item);
      }
      if (Array.isArray(_data["importedEmails"])) {
        this.importedEmails = [] as any;
        for (let item of _data["importedEmails"]) this.importedEmails!.push(item);
      }
    }
  }

  static fromJS(data: any): ImportBatchHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ImportBatchHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["created"] = this.created;
    data["errors"] = this.errors;
    if (Array.isArray(this.errorEmails)) {
      data["errorEmails"] = [];
      for (let item of this.errorEmails) data["errorEmails"].push(item);
    }
    if (Array.isArray(this.importedEmails)) {
      data["importedEmails"] = [];
      for (let item of this.importedEmails) data["importedEmails"].push(item);
    }
    return data;
  }
}

export interface IImportBatchHttpResponse {
  created: number;
  errors: number;
  errorEmails: string[];
  importedEmails: string[];
}

export class ImportStatsHttpResponse implements IImportStatsHttpResponse {
  count!: number;
  status!: string;

  constructor(data?: IImportStatsHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.count = _data["count"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): ImportStatsHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ImportStatsHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["count"] = this.count;
    data["status"] = this.status;
    return data;
  }
}

export interface IImportStatsHttpResponse {
  count: number;
  status: string;
}

export class AppMessageHttpResponse implements IAppMessageHttpResponse {
  appMessageId!: number;
  section!: string;
  startDate!: dayjs.Dayjs;
  endDate?: dayjs.Dayjs | undefined;
  createdAt!: dayjs.Dayjs;
  createdBy!: string;
  message!: string;
  severity!: MessageSeverity;

  constructor(data?: IAppMessageHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.appMessageId = _data["appMessageId"];
      this.section = _data["section"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.createdBy = _data["createdBy"];
      this.message = _data["message"];
      this.severity = _data["severity"];
    }
  }

  static fromJS(data: any): AppMessageHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AppMessageHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["appMessageId"] = this.appMessageId;
    data["section"] = this.section;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.toISOString() : (undefined as any);
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["createdBy"] = this.createdBy;
    data["message"] = this.message;
    data["severity"] = this.severity;
    return data;
  }
}

export interface IAppMessageHttpResponse {
  appMessageId: number;
  section: string;
  startDate: dayjs.Dayjs;
  endDate?: dayjs.Dayjs | undefined;
  createdAt: dayjs.Dayjs;
  createdBy: string;
  message: string;
  severity: MessageSeverity;
}

export enum MessageSeverity {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
}

export class NotificationSettings implements INotificationSettings {
  smsBookingOffers!: boolean;
  smsGeneral!: boolean;
  smsHolidayClubMarketing!: boolean;
  smsInSessionActivities!: boolean;
  smsIndustryThoughts!: boolean;
  emailBookingOffers!: boolean;
  emailGeneral!: boolean;
  emailHolidayClubMarketing!: boolean;
  emailInSessionActivities!: boolean;
  emailIndustryThoughts!: boolean;
  printBookingOffers!: boolean;
  printGeneral!: boolean;
  printHolidayClubMarketing!: boolean;
  printInSessionActivities!: boolean;
  printIndustryThoughts!: boolean;

  constructor(data?: INotificationSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.smsBookingOffers = _data["smsBookingOffers"];
      this.smsGeneral = _data["smsGeneral"];
      this.smsHolidayClubMarketing = _data["smsHolidayClubMarketing"];
      this.smsInSessionActivities = _data["smsInSessionActivities"];
      this.smsIndustryThoughts = _data["smsIndustryThoughts"];
      this.emailBookingOffers = _data["emailBookingOffers"];
      this.emailGeneral = _data["emailGeneral"];
      this.emailHolidayClubMarketing = _data["emailHolidayClubMarketing"];
      this.emailInSessionActivities = _data["emailInSessionActivities"];
      this.emailIndustryThoughts = _data["emailIndustryThoughts"];
      this.printBookingOffers = _data["printBookingOffers"];
      this.printGeneral = _data["printGeneral"];
      this.printHolidayClubMarketing = _data["printHolidayClubMarketing"];
      this.printInSessionActivities = _data["printInSessionActivities"];
      this.printIndustryThoughts = _data["printIndustryThoughts"];
    }
  }

  static fromJS(data: any): NotificationSettings {
    data = typeof data === "object" ? data : {};
    let result = new NotificationSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["smsBookingOffers"] = this.smsBookingOffers;
    data["smsGeneral"] = this.smsGeneral;
    data["smsHolidayClubMarketing"] = this.smsHolidayClubMarketing;
    data["smsInSessionActivities"] = this.smsInSessionActivities;
    data["smsIndustryThoughts"] = this.smsIndustryThoughts;
    data["emailBookingOffers"] = this.emailBookingOffers;
    data["emailGeneral"] = this.emailGeneral;
    data["emailHolidayClubMarketing"] = this.emailHolidayClubMarketing;
    data["emailInSessionActivities"] = this.emailInSessionActivities;
    data["emailIndustryThoughts"] = this.emailIndustryThoughts;
    data["printBookingOffers"] = this.printBookingOffers;
    data["printGeneral"] = this.printGeneral;
    data["printHolidayClubMarketing"] = this.printHolidayClubMarketing;
    data["printInSessionActivities"] = this.printInSessionActivities;
    data["printIndustryThoughts"] = this.printIndustryThoughts;
    return data;
  }
}

export interface INotificationSettings {
  smsBookingOffers: boolean;
  smsGeneral: boolean;
  smsHolidayClubMarketing: boolean;
  smsInSessionActivities: boolean;
  smsIndustryThoughts: boolean;
  emailBookingOffers: boolean;
  emailGeneral: boolean;
  emailHolidayClubMarketing: boolean;
  emailInSessionActivities: boolean;
  emailIndustryThoughts: boolean;
  printBookingOffers: boolean;
  printGeneral: boolean;
  printHolidayClubMarketing: boolean;
  printInSessionActivities: boolean;
  printIndustryThoughts: boolean;
}

export class ToggleNotificationSettingHttpRequest implements IToggleNotificationSettingHttpRequest {
  category!: NotificationCategory;
  subscribed!: boolean;
  channel!: NotificationChannel;

  constructor(data?: IToggleNotificationSettingHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.category = _data["category"];
      this.subscribed = _data["subscribed"];
      this.channel = _data["channel"];
    }
  }

  static fromJS(data: any): ToggleNotificationSettingHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ToggleNotificationSettingHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["category"] = this.category;
    data["subscribed"] = this.subscribed;
    data["channel"] = this.channel;
    return data;
  }
}

export interface IToggleNotificationSettingHttpRequest {
  category: NotificationCategory;
  subscribed: boolean;
  channel: NotificationChannel;
}

export enum NotificationCategory {
  BookingOffers = "bookingOffers",
  General = "general",
  HolidayClubMarketing = "holidayClubMarketing",
  InSessionActivities = "inSessionActivities",
  IndustryThoughts = "industryThoughts",
}

export enum NotificationChannel {
  Sms = "sms",
  Email = "email",
  PushNotification = "pushNotification",
  Print = "print",
}

export class RedeemHttpResponse implements IRedeemHttpResponse {
  result!: RedeemResult;
  message?: string | undefined;

  constructor(data?: IRedeemHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.message = _data["message"];
    }
  }

  static fromJS(data: any): RedeemHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RedeemHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["result"] = this.result;
    data["message"] = this.message;
    return data;
  }
}

export interface IRedeemHttpResponse {
  result: RedeemResult;
  message?: string | undefined;
}

export enum RedeemResult {
  Redeemed = "redeemed",
  AlreadyRedeemed = "alreadyRedeemed",
  AlreadyRedeemedForChild = "alreadyRedeemedForChild",
  Expired = "expired",
  Cancelled = "cancelled",
  ApiError = "apiError",
  Failed = "failed",
}

export class RedeemHttpRequest implements IRedeemHttpRequest {
  childId!: number;
  code?: string | undefined;
  userName?: string | undefined;

  constructor(data?: IRedeemHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.code = _data["code"];
      this.userName = _data["userName"];
    }
  }

  static fromJS(data: any): RedeemHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RedeemHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["code"] = this.code;
    data["userName"] = this.userName;
    return data;
  }
}

export interface IRedeemHttpRequest {
  childId: number;
  code?: string | undefined;
  userName?: string | undefined;
}

export class OnlineSession implements IOnlineSession {
  onlineSessionId!: number;
  name!: string;
  shortDescription?: string | undefined;
  description!: string;
  workshopRequirements?: string | undefined;
  dateAest!: dayjs.Dayjs;
  dateAcst?: dayjs.Dayjs | undefined;
  dateAwst?: dayjs.Dayjs | undefined;
  duration!: dayjs.Dayjs;
  cost!: number;
  imageUrl!: string;
  allowBooking!: boolean;
  allowCancel!: boolean;
  datesText?: string | undefined;
  timeText?: string | undefined;
  durationText?: string | undefined;

  constructor(data?: IOnlineSession) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.onlineSessionId = _data["onlineSessionId"];
      this.name = _data["name"];
      this.shortDescription = _data["shortDescription"];
      this.description = _data["description"];
      this.workshopRequirements = _data["workshopRequirements"];
      this.dateAest = _data["dateAest"] ? dayjs(_data["dateAest"].toString()) : (undefined as any);
      this.dateAcst = _data["dateAcst"] ? dayjs(_data["dateAcst"].toString()) : (undefined as any);
      this.dateAwst = _data["dateAwst"] ? dayjs(_data["dateAwst"].toString()) : (undefined as any);
      this.duration = _data["duration"] ? dayjs(_data["duration"].toString()) : (undefined as any);
      this.cost = _data["cost"];
      this.imageUrl = _data["imageUrl"];
      this.allowBooking = _data["allowBooking"];
      this.allowCancel = _data["allowCancel"];
      this.datesText = _data["datesText"];
      this.timeText = _data["timeText"];
      this.durationText = _data["durationText"];
    }
  }

  static fromJS(data: any): OnlineSession {
    data = typeof data === "object" ? data : {};
    let result = new OnlineSession();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["onlineSessionId"] = this.onlineSessionId;
    data["name"] = this.name;
    data["shortDescription"] = this.shortDescription;
    data["description"] = this.description;
    data["workshopRequirements"] = this.workshopRequirements;
    data["dateAest"] = this.dateAest ? this.dateAest.toISOString() : (undefined as any);
    data["dateAcst"] = this.dateAcst ? this.dateAcst.toISOString() : (undefined as any);
    data["dateAwst"] = this.dateAwst ? this.dateAwst.toISOString() : (undefined as any);
    data["duration"] = this.duration ? this.duration.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["cost"] = this.cost;
    data["imageUrl"] = this.imageUrl;
    data["allowBooking"] = this.allowBooking;
    data["allowCancel"] = this.allowCancel;
    data["datesText"] = this.datesText;
    data["timeText"] = this.timeText;
    data["durationText"] = this.durationText;
    return data;
  }
}

export interface IOnlineSession {
  onlineSessionId: number;
  name: string;
  shortDescription?: string | undefined;
  description: string;
  workshopRequirements?: string | undefined;
  dateAest: dayjs.Dayjs;
  dateAcst?: dayjs.Dayjs | undefined;
  dateAwst?: dayjs.Dayjs | undefined;
  duration: dayjs.Dayjs;
  cost: number;
  imageUrl: string;
  allowBooking: boolean;
  allowCancel: boolean;
  datesText?: string | undefined;
  timeText?: string | undefined;
  durationText?: string | undefined;
}

export class OnlineSessionBookingsHttpResponse implements IOnlineSessionBookingsHttpResponse {
  uniqueId!: string;
  onlineSessionId!: number;
  childId!: number;
  createdDate!: dayjs.Dayjs;
  isDeleted?: boolean | undefined;

  constructor(data?: IOnlineSessionBookingsHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.onlineSessionId = _data["onlineSessionId"];
      this.childId = _data["childId"];
      this.createdDate = _data["createdDate"] ? dayjs(_data["createdDate"].toString()) : (undefined as any);
      this.isDeleted = _data["isDeleted"];
    }
  }

  static fromJS(data: any): OnlineSessionBookingsHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new OnlineSessionBookingsHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["onlineSessionId"] = this.onlineSessionId;
    data["childId"] = this.childId;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : (undefined as any);
    data["isDeleted"] = this.isDeleted;
    return data;
  }
}

export interface IOnlineSessionBookingsHttpResponse {
  uniqueId: string;
  onlineSessionId: number;
  childId: number;
  createdDate: dayjs.Dayjs;
  isDeleted?: boolean | undefined;
}

export class UpdateOnlineSessionBookingsHttpRequest implements IUpdateOnlineSessionBookingsHttpRequest {
  bookings!: SaveOnlineSessionBookingHttpRequest[];

  constructor(data?: IUpdateOnlineSessionBookingsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bookings = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["bookings"])) {
        this.bookings = [] as any;
        for (let item of _data["bookings"]) this.bookings!.push(SaveOnlineSessionBookingHttpRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateOnlineSessionBookingsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateOnlineSessionBookingsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.bookings)) {
      data["bookings"] = [];
      for (let item of this.bookings) data["bookings"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IUpdateOnlineSessionBookingsHttpRequest {
  bookings: SaveOnlineSessionBookingHttpRequest[];
}

export class SaveOnlineSessionBookingHttpRequest implements ISaveOnlineSessionBookingHttpRequest {
  onlineSessionId!: number;
  childrenIds!: number[];

  constructor(data?: ISaveOnlineSessionBookingHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.onlineSessionId = _data["onlineSessionId"];
      if (Array.isArray(_data["childrenIds"])) {
        this.childrenIds = [] as any;
        for (let item of _data["childrenIds"]) this.childrenIds!.push(item);
      }
    }
  }

  static fromJS(data: any): SaveOnlineSessionBookingHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveOnlineSessionBookingHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["onlineSessionId"] = this.onlineSessionId;
    if (Array.isArray(this.childrenIds)) {
      data["childrenIds"] = [];
      for (let item of this.childrenIds) data["childrenIds"].push(item);
    }
    return data;
  }
}

export interface ISaveOnlineSessionBookingHttpRequest {
  onlineSessionId: number;
  childrenIds: number[];
}

export class PaymentMethodHttpResponse implements IPaymentMethodHttpResponse {
  paymentMethodId!: number;
  paymentType!: PaymentType;
  customerAccountId!: number;
  paymentTypeName?: string | undefined;
  paymentMethodCreated!: dayjs.Dayjs;
  accountName?: string | undefined;
  expiryMonth?: number | undefined;
  expiryYear?: number | undefined;
  isCurrentPaymentMethod!: boolean;
  masked?: string | undefined;

  constructor(data?: IPaymentMethodHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentMethodId = _data["paymentMethodId"];
      this.paymentType = _data["paymentType"];
      this.customerAccountId = _data["customerAccountId"];
      this.paymentTypeName = _data["paymentTypeName"];
      this.paymentMethodCreated = _data["paymentMethodCreated"]
        ? dayjs(_data["paymentMethodCreated"].toString())
        : (undefined as any);
      this.accountName = _data["accountName"];
      this.expiryMonth = _data["expiryMonth"];
      this.expiryYear = _data["expiryYear"];
      this.isCurrentPaymentMethod = _data["isCurrentPaymentMethod"];
      this.masked = _data["masked"];
    }
  }

  static fromJS(data: any): PaymentMethodHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new PaymentMethodHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["paymentMethodId"] = this.paymentMethodId;
    data["paymentType"] = this.paymentType;
    data["customerAccountId"] = this.customerAccountId;
    data["paymentTypeName"] = this.paymentTypeName;
    data["paymentMethodCreated"] = this.paymentMethodCreated
      ? this.paymentMethodCreated.toISOString()
      : (undefined as any);
    data["accountName"] = this.accountName;
    data["expiryMonth"] = this.expiryMonth;
    data["expiryYear"] = this.expiryYear;
    data["isCurrentPaymentMethod"] = this.isCurrentPaymentMethod;
    data["masked"] = this.masked;
    return data;
  }
}

export interface IPaymentMethodHttpResponse {
  paymentMethodId: number;
  paymentType: PaymentType;
  customerAccountId: number;
  paymentTypeName?: string | undefined;
  paymentMethodCreated: dayjs.Dayjs;
  accountName?: string | undefined;
  expiryMonth?: number | undefined;
  expiryYear?: number | undefined;
  isCurrentPaymentMethod: boolean;
  masked?: string | undefined;
}

export enum PaymentType {
  BankAccount = "bankAccount",
  CreditCard = "creditCard",
}

export class PageableObjectOfBillingCycleSummaryModel implements IPageableObjectOfBillingCycleSummaryModel {
  records!: BillingCycleSummaryModel[];
  total!: number;

  constructor(data?: IPageableObjectOfBillingCycleSummaryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.records = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["records"])) {
        this.records = [] as any;
        for (let item of _data["records"]) this.records!.push(BillingCycleSummaryModel.fromJS(item));
      }
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): PageableObjectOfBillingCycleSummaryModel {
    data = typeof data === "object" ? data : {};
    let result = new PageableObjectOfBillingCycleSummaryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.records)) {
      data["records"] = [];
      for (let item of this.records) data["records"].push(item ? item.toJSON() : (undefined as any));
    }
    data["total"] = this.total;
    return data;
  }
}

export interface IPageableObjectOfBillingCycleSummaryModel {
  records: BillingCycleSummaryModel[];
  total: number;
}

export class BillingCycleSummaryModel implements IBillingCycleSummaryModel {
  transactionId!: number;
  billingCycleId!: number;
  billingPeriodStart!: dayjs.Dayjs;
  billingPeriodEnd!: dayjs.Dayjs;
  dueDate!: dayjs.Dayjs;
  openBalance?: number | undefined;
  totalAmount?: number | undefined;
  closingBalance?: number | undefined;
  paymentsMade!: number;
  isStatementCleared?: boolean | undefined;
  isOverDue?: boolean | undefined;
  isPostCCITS!: boolean;
  isDue!: boolean;
  transactions!: StatementTransactionModel[];
  balance?: number | undefined;
  statementDate!: dayjs.Dayjs;

  constructor(data?: IBillingCycleSummaryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.transactions = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data["transactionId"];
      this.billingCycleId = _data["billingCycleId"];
      this.billingPeriodStart = _data["billingPeriodStart"]
        ? dayjs(_data["billingPeriodStart"].toString())
        : (undefined as any);
      this.billingPeriodEnd = _data["billingPeriodEnd"]
        ? dayjs(_data["billingPeriodEnd"].toString())
        : (undefined as any);
      this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : (undefined as any);
      this.openBalance = _data["openBalance"];
      this.totalAmount = _data["totalAmount"];
      this.closingBalance = _data["closingBalance"];
      this.paymentsMade = _data["paymentsMade"];
      this.isStatementCleared = _data["isStatementCleared"];
      this.isOverDue = _data["isOverDue"];
      this.isPostCCITS = _data["isPostCCITS"];
      this.isDue = _data["isDue"];
      if (Array.isArray(_data["transactions"])) {
        this.transactions = [] as any;
        for (let item of _data["transactions"]) this.transactions!.push(StatementTransactionModel.fromJS(item));
      }
      this.balance = _data["balance"];
      this.statementDate = _data["statementDate"] ? dayjs(_data["statementDate"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): BillingCycleSummaryModel {
    data = typeof data === "object" ? data : {};
    let result = new BillingCycleSummaryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transactionId"] = this.transactionId;
    data["billingCycleId"] = this.billingCycleId;
    data["billingPeriodStart"] = this.billingPeriodStart ? this.billingPeriodStart.toISOString() : (undefined as any);
    data["billingPeriodEnd"] = this.billingPeriodEnd ? this.billingPeriodEnd.toISOString() : (undefined as any);
    data["dueDate"] = this.dueDate ? this.dueDate.format("YYYY-MM-DD") : (undefined as any);
    data["openBalance"] = this.openBalance;
    data["totalAmount"] = this.totalAmount;
    data["closingBalance"] = this.closingBalance;
    data["paymentsMade"] = this.paymentsMade;
    data["isStatementCleared"] = this.isStatementCleared;
    data["isOverDue"] = this.isOverDue;
    data["isPostCCITS"] = this.isPostCCITS;
    data["isDue"] = this.isDue;
    if (Array.isArray(this.transactions)) {
      data["transactions"] = [];
      for (let item of this.transactions) data["transactions"].push(item ? item.toJSON() : (undefined as any));
    }
    data["balance"] = this.balance;
    data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface IBillingCycleSummaryModel {
  transactionId: number;
  billingCycleId: number;
  billingPeriodStart: dayjs.Dayjs;
  billingPeriodEnd: dayjs.Dayjs;
  dueDate: dayjs.Dayjs;
  openBalance?: number | undefined;
  totalAmount?: number | undefined;
  closingBalance?: number | undefined;
  paymentsMade: number;
  isStatementCleared?: boolean | undefined;
  isOverDue?: boolean | undefined;
  isPostCCITS: boolean;
  isDue: boolean;
  transactions: StatementTransactionModel[];
  balance?: number | undefined;
  statementDate: dayjs.Dayjs;
}

export class StatementTransactionModel implements IStatementTransactionModel {
  rollWeekBegin?: dayjs.Dayjs | undefined;
  rollWeekEnd?: dayjs.Dayjs | undefined;
  parentID?: number | undefined;
  ccb?: number | undefined;
  ccr?: number | undefined;
  sServiceID?: number | undefined;
  qkLedgerId?: number | undefined;
  accs!: number;
  ccs!: number;
  entryDate?: dayjs.Dayjs | undefined;
  entryDescr?: string | undefined;
  entryType?: string | undefined;
  transactionTypeId?: number | undefined;
  transactionClassId?: number | undefined;
  totalDebits?: number | undefined;
  totalCredits?: number | undefined;
  fees?: number | undefined;
  description?: string | undefined;
  totalMovement?: number | undefined;
  serviceName?: string | undefined;
  transactionId!: number;
  bookingId?: number | undefined;
  hours?: number | undefined;
  sessionTimeStart?: dayjs.Dayjs | undefined;
  sessionTimeEnd?: dayjs.Dayjs | undefined;
  attendanceTimeStart?: dayjs.Dayjs | undefined;
  attendanceTimeEnd?: dayjs.Dayjs | undefined;
  sessionType?: string | undefined;
  childId?: number | undefined;
  parentFeeWaiver?: number | undefined;
  hasAttended?: number | undefined;
  cancellationStatusId?: number | undefined;
  bookingDescription?: string | undefined;
  reversalDate?: dayjs.Dayjs | undefined;
  billingCycleId!: number;

  constructor(data?: IStatementTransactionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollWeekBegin = _data["rollWeekBegin"] ? dayjs(_data["rollWeekBegin"].toString()) : (undefined as any);
      this.rollWeekEnd = _data["rollWeekEnd"] ? dayjs(_data["rollWeekEnd"].toString()) : (undefined as any);
      this.parentID = _data["parentID"];
      this.ccb = _data["ccb"];
      this.ccr = _data["ccr"];
      this.sServiceID = _data["sServiceID"];
      this.qkLedgerId = _data["qkLedgerId"];
      this.accs = _data["accs"];
      this.ccs = _data["ccs"];
      this.entryDate = _data["entryDate"] ? dayjs(_data["entryDate"].toString()) : (undefined as any);
      this.entryDescr = _data["entryDescr"];
      this.entryType = _data["entryType"];
      this.transactionTypeId = _data["transactionTypeId"];
      this.transactionClassId = _data["transactionClassId"];
      this.totalDebits = _data["totalDebits"];
      this.totalCredits = _data["totalCredits"];
      this.fees = _data["fees"];
      this.description = _data["description"];
      this.totalMovement = _data["totalMovement"];
      this.serviceName = _data["serviceName"];
      this.transactionId = _data["transactionId"];
      this.bookingId = _data["bookingId"];
      this.hours = _data["hours"];
      this.sessionTimeStart = _data["sessionTimeStart"]
        ? dayjs(_data["sessionTimeStart"].toString())
        : (undefined as any);
      this.sessionTimeEnd = _data["sessionTimeEnd"] ? dayjs(_data["sessionTimeEnd"].toString()) : (undefined as any);
      this.attendanceTimeStart = _data["attendanceTimeStart"]
        ? dayjs(_data["attendanceTimeStart"].toString())
        : (undefined as any);
      this.attendanceTimeEnd = _data["attendanceTimeEnd"]
        ? dayjs(_data["attendanceTimeEnd"].toString())
        : (undefined as any);
      this.sessionType = _data["sessionType"];
      this.childId = _data["childId"];
      this.parentFeeWaiver = _data["parentFeeWaiver"];
      this.hasAttended = _data["hasAttended"];
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.bookingDescription = _data["bookingDescription"];
      this.reversalDate = _data["reversalDate"] ? dayjs(_data["reversalDate"].toString()) : (undefined as any);
      this.billingCycleId = _data["billingCycleId"];
    }
  }

  static fromJS(data: any): StatementTransactionModel {
    data = typeof data === "object" ? data : {};
    let result = new StatementTransactionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollWeekBegin"] = this.rollWeekBegin ? this.rollWeekBegin.toISOString() : (undefined as any);
    data["rollWeekEnd"] = this.rollWeekEnd ? this.rollWeekEnd.toISOString() : (undefined as any);
    data["parentID"] = this.parentID;
    data["ccb"] = this.ccb;
    data["ccr"] = this.ccr;
    data["sServiceID"] = this.sServiceID;
    data["qkLedgerId"] = this.qkLedgerId;
    data["accs"] = this.accs;
    data["ccs"] = this.ccs;
    data["entryDate"] = this.entryDate ? this.entryDate.format("YYYY-MM-DD") : (undefined as any);
    data["entryDescr"] = this.entryDescr;
    data["entryType"] = this.entryType;
    data["transactionTypeId"] = this.transactionTypeId;
    data["transactionClassId"] = this.transactionClassId;
    data["totalDebits"] = this.totalDebits;
    data["totalCredits"] = this.totalCredits;
    data["fees"] = this.fees;
    data["description"] = this.description;
    data["totalMovement"] = this.totalMovement;
    data["serviceName"] = this.serviceName;
    data["transactionId"] = this.transactionId;
    data["bookingId"] = this.bookingId;
    data["hours"] = this.hours;
    data["sessionTimeStart"] = this.sessionTimeStart
      ? this.sessionTimeStart.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["sessionTimeEnd"] = this.sessionTimeEnd ? this.sessionTimeEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["attendanceTimeStart"] = this.attendanceTimeStart
      ? this.attendanceTimeStart.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["attendanceTimeEnd"] = this.attendanceTimeEnd
      ? this.attendanceTimeEnd.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["sessionType"] = this.sessionType;
    data["childId"] = this.childId;
    data["parentFeeWaiver"] = this.parentFeeWaiver;
    data["hasAttended"] = this.hasAttended;
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["bookingDescription"] = this.bookingDescription;
    data["reversalDate"] = this.reversalDate ? this.reversalDate.toISOString() : (undefined as any);
    data["billingCycleId"] = this.billingCycleId;
    return data;
  }
}

export interface IStatementTransactionModel {
  rollWeekBegin?: dayjs.Dayjs | undefined;
  rollWeekEnd?: dayjs.Dayjs | undefined;
  parentID?: number | undefined;
  ccb?: number | undefined;
  ccr?: number | undefined;
  sServiceID?: number | undefined;
  qkLedgerId?: number | undefined;
  accs: number;
  ccs: number;
  entryDate?: dayjs.Dayjs | undefined;
  entryDescr?: string | undefined;
  entryType?: string | undefined;
  transactionTypeId?: number | undefined;
  transactionClassId?: number | undefined;
  totalDebits?: number | undefined;
  totalCredits?: number | undefined;
  fees?: number | undefined;
  description?: string | undefined;
  totalMovement?: number | undefined;
  serviceName?: string | undefined;
  transactionId: number;
  bookingId?: number | undefined;
  hours?: number | undefined;
  sessionTimeStart?: dayjs.Dayjs | undefined;
  sessionTimeEnd?: dayjs.Dayjs | undefined;
  attendanceTimeStart?: dayjs.Dayjs | undefined;
  attendanceTimeEnd?: dayjs.Dayjs | undefined;
  sessionType?: string | undefined;
  childId?: number | undefined;
  parentFeeWaiver?: number | undefined;
  hasAttended?: number | undefined;
  cancellationStatusId?: number | undefined;
  bookingDescription?: string | undefined;
  reversalDate?: dayjs.Dayjs | undefined;
  billingCycleId: number;
}

export class PageableObjectOfStatementInformationSummaryModel
  implements IPageableObjectOfStatementInformationSummaryModel
{
  records!: StatementInformationSummaryModel[];
  total!: number;

  constructor(data?: IPageableObjectOfStatementInformationSummaryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.records = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["records"])) {
        this.records = [] as any;
        for (let item of _data["records"]) this.records!.push(StatementInformationSummaryModel.fromJS(item));
      }
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): PageableObjectOfStatementInformationSummaryModel {
    data = typeof data === "object" ? data : {};
    let result = new PageableObjectOfStatementInformationSummaryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.records)) {
      data["records"] = [];
      for (let item of this.records) data["records"].push(item ? item.toJSON() : (undefined as any));
    }
    data["total"] = this.total;
    return data;
  }
}

export interface IPageableObjectOfStatementInformationSummaryModel {
  records: StatementInformationSummaryModel[];
  total: number;
}

export class StatementInformationSummaryModel implements IStatementInformationSummaryModel {
  id!: number;
  dueAmount!: number;
  statementId!: number;
  billingCycleId!: number;
  dueDate!: dayjs.Dayjs;
  bookingCharges!: number;
  credits!: number;
  ccs!: number;
  accs!: number;
  otherCharges!: number;
  totalAmount!: number;
  fromDate!: dayjs.Dayjs;
  toDate!: dayjs.Dayjs;
  paymentStatusId!: number;
  currentDueAmount?: number | undefined;
  debtCategoryId!: number;
  statementInformationDetail?: StatementInformationDetailModel[] | undefined;

  constructor(data?: IStatementInformationSummaryModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.dueAmount = _data["dueAmount"];
      this.statementId = _data["statementId"];
      this.billingCycleId = _data["billingCycleId"];
      this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : (undefined as any);
      this.bookingCharges = _data["bookingCharges"];
      this.credits = _data["credits"];
      this.ccs = _data["ccs"];
      this.accs = _data["accs"];
      this.otherCharges = _data["otherCharges"];
      this.totalAmount = _data["totalAmount"];
      this.fromDate = _data["fromDate"] ? dayjs(_data["fromDate"].toString()) : (undefined as any);
      this.toDate = _data["toDate"] ? dayjs(_data["toDate"].toString()) : (undefined as any);
      this.paymentStatusId = _data["paymentStatusId"];
      this.currentDueAmount = _data["currentDueAmount"];
      this.debtCategoryId = _data["debtCategoryId"];
      if (Array.isArray(_data["statementInformationDetail"])) {
        this.statementInformationDetail = [] as any;
        for (let item of _data["statementInformationDetail"])
          this.statementInformationDetail!.push(StatementInformationDetailModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StatementInformationSummaryModel {
    data = typeof data === "object" ? data : {};
    let result = new StatementInformationSummaryModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["dueAmount"] = this.dueAmount;
    data["statementId"] = this.statementId;
    data["billingCycleId"] = this.billingCycleId;
    data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : (undefined as any);
    data["bookingCharges"] = this.bookingCharges;
    data["credits"] = this.credits;
    data["ccs"] = this.ccs;
    data["accs"] = this.accs;
    data["otherCharges"] = this.otherCharges;
    data["totalAmount"] = this.totalAmount;
    data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : (undefined as any);
    data["toDate"] = this.toDate ? this.toDate.toISOString() : (undefined as any);
    data["paymentStatusId"] = this.paymentStatusId;
    data["currentDueAmount"] = this.currentDueAmount;
    data["debtCategoryId"] = this.debtCategoryId;
    if (Array.isArray(this.statementInformationDetail)) {
      data["statementInformationDetail"] = [];
      for (let item of this.statementInformationDetail)
        data["statementInformationDetail"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IStatementInformationSummaryModel {
  id: number;
  dueAmount: number;
  statementId: number;
  billingCycleId: number;
  dueDate: dayjs.Dayjs;
  bookingCharges: number;
  credits: number;
  ccs: number;
  accs: number;
  otherCharges: number;
  totalAmount: number;
  fromDate: dayjs.Dayjs;
  toDate: dayjs.Dayjs;
  paymentStatusId: number;
  currentDueAmount?: number | undefined;
  debtCategoryId: number;
  statementInformationDetail?: StatementInformationDetailModel[] | undefined;
}

export class StatementInformationDetailModel implements IStatementInformationDetailModel {
  statementId!: number;
  billingCycleStatementId!: number;
  transactionId!: number;
  transactionClassId!: number;
  entryId!: number;
  totalDebits!: number;
  totalCredits!: number;
  fees!: number;
  totalMovement!: number;
  serviceId!: number;
  sequenceNumber!: number;
  bookingId!: number;
  accs!: number;
  ccs!: number;
  transactionDate!: dayjs.Dayjs;
  serviceName?: string | undefined;
  transactionDescription?: string | undefined;

  constructor(data?: IStatementInformationDetailModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statementId = _data["statementId"];
      this.billingCycleStatementId = _data["billingCycleStatementId"];
      this.transactionId = _data["transactionId"];
      this.transactionClassId = _data["transactionClassId"];
      this.entryId = _data["entryId"];
      this.totalDebits = _data["totalDebits"];
      this.totalCredits = _data["totalCredits"];
      this.fees = _data["fees"];
      this.totalMovement = _data["totalMovement"];
      this.serviceId = _data["serviceId"];
      this.sequenceNumber = _data["sequenceNumber"];
      this.bookingId = _data["bookingId"];
      this.accs = _data["accs"];
      this.ccs = _data["ccs"];
      this.transactionDate = _data["transactionDate"] ? dayjs(_data["transactionDate"].toString()) : (undefined as any);
      this.serviceName = _data["serviceName"];
      this.transactionDescription = _data["transactionDescription"];
    }
  }

  static fromJS(data: any): StatementInformationDetailModel {
    data = typeof data === "object" ? data : {};
    let result = new StatementInformationDetailModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["statementId"] = this.statementId;
    data["billingCycleStatementId"] = this.billingCycleStatementId;
    data["transactionId"] = this.transactionId;
    data["transactionClassId"] = this.transactionClassId;
    data["entryId"] = this.entryId;
    data["totalDebits"] = this.totalDebits;
    data["totalCredits"] = this.totalCredits;
    data["fees"] = this.fees;
    data["totalMovement"] = this.totalMovement;
    data["serviceId"] = this.serviceId;
    data["sequenceNumber"] = this.sequenceNumber;
    data["bookingId"] = this.bookingId;
    data["accs"] = this.accs;
    data["ccs"] = this.ccs;
    data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : (undefined as any);
    data["serviceName"] = this.serviceName;
    data["transactionDescription"] = this.transactionDescription;
    return data;
  }
}

export interface IStatementInformationDetailModel {
  statementId: number;
  billingCycleStatementId: number;
  transactionId: number;
  transactionClassId: number;
  entryId: number;
  totalDebits: number;
  totalCredits: number;
  fees: number;
  totalMovement: number;
  serviceId: number;
  sequenceNumber: number;
  bookingId: number;
  accs: number;
  ccs: number;
  transactionDate: dayjs.Dayjs;
  serviceName?: string | undefined;
  transactionDescription?: string | undefined;
}

export class BillingCycleSummaryList
  extends PageableObjectOfBillingCycleSummaryModel
  implements IBillingCycleSummaryList
{
  accountBalance!: number;
  statementBalance!: number;
  statementDate!: dayjs.Dayjs;

  constructor(data?: IBillingCycleSummaryList) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.accountBalance = _data["accountBalance"];
      this.statementBalance = _data["statementBalance"];
      this.statementDate = _data["statementDate"] ? dayjs(_data["statementDate"].toString()) : (undefined as any);
    }
  }

  static override fromJS(data: any): BillingCycleSummaryList {
    data = typeof data === "object" ? data : {};
    let result = new BillingCycleSummaryList();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accountBalance"] = this.accountBalance;
    data["statementBalance"] = this.statementBalance;
    data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : (undefined as any);
    super.toJSON(data);
    return data;
  }
}

export interface IBillingCycleSummaryList extends IPageableObjectOfBillingCycleSummaryModel {
  accountBalance: number;
  statementBalance: number;
  statementDate: dayjs.Dayjs;
}

export class MakePaymentHttpResponse implements IMakePaymentHttpResponse {
  title!: string;
  description!: string;
  result!: string;
  reference!: string;
  isSuccess!: boolean;
  amount?: string | undefined;

  constructor(data?: IMakePaymentHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.description = _data["description"];
      this.result = _data["result"];
      this.reference = _data["reference"];
      this.isSuccess = _data["isSuccess"];
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): MakePaymentHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new MakePaymentHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["description"] = this.description;
    data["result"] = this.result;
    data["reference"] = this.reference;
    data["isSuccess"] = this.isSuccess;
    data["amount"] = this.amount;
    return data;
  }
}

export interface IMakePaymentHttpResponse {
  title: string;
  description: string;
  result: string;
  reference: string;
  isSuccess: boolean;
  amount?: string | undefined;
}

export class MakeRegularPaymentHttpRequest implements IMakeRegularPaymentHttpRequest {
  customerContactId!: number;
  amount!: number;

  constructor(data?: IMakeRegularPaymentHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.amount = _data["amount"];
    }
  }

  static fromJS(data: any): MakeRegularPaymentHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new MakeRegularPaymentHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["amount"] = this.amount;
    return data;
  }
}

export interface IMakeRegularPaymentHttpRequest {
  customerContactId: number;
  amount: number;
}

export class MakeOneOffBankPaymentHttpRequest implements IMakeOneOffBankPaymentHttpRequest {
  customerContactId!: number;
  amount!: number;
  bank!: BankInfoHttpRequest;

  constructor(data?: IMakeOneOffBankPaymentHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bank = new BankInfoHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.amount = _data["amount"];
      this.bank = _data["bank"] ? BankInfoHttpRequest.fromJS(_data["bank"]) : new BankInfoHttpRequest();
    }
  }

  static fromJS(data: any): MakeOneOffBankPaymentHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new MakeOneOffBankPaymentHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["amount"] = this.amount;
    data["bank"] = this.bank ? this.bank.toJSON() : (undefined as any);
    return data;
  }
}

export interface IMakeOneOffBankPaymentHttpRequest {
  customerContactId: number;
  amount: number;
  bank: BankInfoHttpRequest;
}

export class BankInfoHttpRequest implements IBankInfoHttpRequest {
  bsb!: string;
  accountNumber!: string;
  accountName!: string;

  constructor(data?: IBankInfoHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bsb = _data["bsb"];
      this.accountNumber = _data["accountNumber"];
      this.accountName = _data["accountName"];
    }
  }

  static fromJS(data: any): BankInfoHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new BankInfoHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bsb"] = this.bsb;
    data["accountNumber"] = this.accountNumber;
    data["accountName"] = this.accountName;
    return data;
  }
}

export interface IBankInfoHttpRequest {
  bsb: string;
  accountNumber: string;
  accountName: string;
}

export class EncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest
  implements IEncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest
{
  cryptoSignature!: CryptoSignatureHttpRequest;
  payload!: string;

  constructor(data?: IEncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.cryptoSignature = new CryptoSignatureHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cryptoSignature = _data["cryptoSignature"]
        ? CryptoSignatureHttpRequest.fromJS(_data["cryptoSignature"])
        : new CryptoSignatureHttpRequest();
      this.payload = _data["payload"];
    }
  }

  static fromJS(data: any): EncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new EncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["cryptoSignature"] = this.cryptoSignature ? this.cryptoSignature.toJSON() : (undefined as any);
    data["payload"] = this.payload;
    return data;
  }
}

export interface IEncryptedPayloadHttpRequestOfMakeOneOffCardPaymentHttpRequest {
  cryptoSignature: CryptoSignatureHttpRequest;
  payload: string;
}

export class CryptoSignatureHttpRequest implements ICryptoSignatureHttpRequest {
  value!: string;
  tokenId!: string;
  customerAccountId!: number;

  constructor(data?: ICryptoSignatureHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.tokenId = _data["tokenId"];
      this.customerAccountId = _data["customerAccountId"];
    }
  }

  static fromJS(data: any): CryptoSignatureHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CryptoSignatureHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["value"] = this.value;
    data["tokenId"] = this.tokenId;
    data["customerAccountId"] = this.customerAccountId;
    return data;
  }
}

export interface ICryptoSignatureHttpRequest {
  value: string;
  tokenId: string;
  customerAccountId: number;
}

export class CreatePaymentMethodHttpResponse implements ICreatePaymentMethodHttpResponse {
  paymentMethodId!: number;
  result?: string | undefined;
  isSuccess!: boolean;

  constructor(data?: ICreatePaymentMethodHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentMethodId = _data["paymentMethodId"];
      this.result = _data["result"];
      this.isSuccess = _data["isSuccess"];
    }
  }

  static fromJS(data: any): CreatePaymentMethodHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new CreatePaymentMethodHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["paymentMethodId"] = this.paymentMethodId;
    data["result"] = this.result;
    data["isSuccess"] = this.isSuccess;
    return data;
  }
}

export interface ICreatePaymentMethodHttpResponse {
  paymentMethodId: number;
  result?: string | undefined;
  isSuccess: boolean;
}

export class AddBankPaymentMethodHttpRequest implements IAddBankPaymentMethodHttpRequest {
  customerContactId!: number;
  bank!: BankInfoHttpRequest;

  constructor(data?: IAddBankPaymentMethodHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bank = new BankInfoHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.bank = _data["bank"] ? BankInfoHttpRequest.fromJS(_data["bank"]) : new BankInfoHttpRequest();
    }
  }

  static fromJS(data: any): AddBankPaymentMethodHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new AddBankPaymentMethodHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["bank"] = this.bank ? this.bank.toJSON() : (undefined as any);
    return data;
  }
}

export interface IAddBankPaymentMethodHttpRequest {
  customerContactId: number;
  bank: BankInfoHttpRequest;
}

export class AddCreditCardPaymentMethodHttpRequest implements IAddCreditCardPaymentMethodHttpRequest {
  customerContactId!: number;
  creditCard!: CreditCardInfoHttpRequest;

  constructor(data?: IAddCreditCardPaymentMethodHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.creditCard = new CreditCardInfoHttpRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerContactId = _data["customerContactId"];
      this.creditCard = _data["creditCard"]
        ? CreditCardInfoHttpRequest.fromJS(_data["creditCard"])
        : new CreditCardInfoHttpRequest();
    }
  }

  static fromJS(data: any): AddCreditCardPaymentMethodHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new AddCreditCardPaymentMethodHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customerContactId"] = this.customerContactId;
    data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : (undefined as any);
    return data;
  }
}

export interface IAddCreditCardPaymentMethodHttpRequest {
  customerContactId: number;
  creditCard: CreditCardInfoHttpRequest;
}

export class CreditCardInfoHttpRequest implements ICreditCardInfoHttpRequest {
  cvc!: string;
  month!: number;
  name!: string;
  number!: string;
  year!: number;

  constructor(data?: ICreditCardInfoHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cvc = _data["cvc"];
      this.month = _data["month"];
      this.name = _data["name"];
      this.number = _data["number"];
      this.year = _data["year"];
    }
  }

  static fromJS(data: any): CreditCardInfoHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreditCardInfoHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["cvc"] = this.cvc;
    data["month"] = this.month;
    data["name"] = this.name;
    data["number"] = this.number;
    data["year"] = this.year;
    return data;
  }
}

export interface ICreditCardInfoHttpRequest {
  cvc: string;
  month: number;
  name: string;
  number: string;
  year: number;
}

export class UpcomingChargeModel implements IUpcomingChargeModel {
  bookingId?: number | undefined;
  date!: dayjs.Dayjs;
  childId!: number;
  rollId!: number;
  grossAmount!: number;
  discountAmount!: number;
  ccs!: number;
  accs!: number;
  serviceName!: string;
  firstName!: string;
  lastName!: string;
  feeName!: string;
  cancellationStatusId!: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName!: string;
  multiChildrenDiscount!: number;

  constructor(data?: IUpcomingChargeModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingId = _data["bookingId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.grossAmount = _data["grossAmount"];
      this.discountAmount = _data["discountAmount"];
      this.ccs = _data["ccs"];
      this.accs = _data["accs"];
      this.serviceName = _data["serviceName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.feeName = _data["feeName"];
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.hasAttended = _data["hasAttended"];
      this.isMarked = _data["isMarked"];
      this.rollName = _data["rollName"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): UpcomingChargeModel {
    data = typeof data === "object" ? data : {};
    let result = new UpcomingChargeModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingId"] = this.bookingId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["grossAmount"] = this.grossAmount;
    data["discountAmount"] = this.discountAmount;
    data["ccs"] = this.ccs;
    data["accs"] = this.accs;
    data["serviceName"] = this.serviceName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["feeName"] = this.feeName;
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["hasAttended"] = this.hasAttended;
    data["isMarked"] = this.isMarked;
    data["rollName"] = this.rollName;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IUpcomingChargeModel {
  bookingId?: number | undefined;
  date: dayjs.Dayjs;
  childId: number;
  rollId: number;
  grossAmount: number;
  discountAmount: number;
  ccs: number;
  accs: number;
  serviceName: string;
  firstName: string;
  lastName: string;
  feeName: string;
  cancellationStatusId: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName: string;
  multiChildrenDiscount: number;
}

export class GetAccountStatementHttpResponse implements IGetAccountStatementHttpResponse {
  balance!: number;
  statementDate!: dayjs.Dayjs;
  statementBalance?: number | undefined;

  constructor(data?: IGetAccountStatementHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.balance = _data["balance"];
      this.statementDate = _data["statementDate"] ? dayjs(_data["statementDate"].toString()) : (undefined as any);
      this.statementBalance = _data["statementBalance"];
    }
  }

  static fromJS(data: any): GetAccountStatementHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetAccountStatementHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["balance"] = this.balance;
    data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : (undefined as any);
    data["statementBalance"] = this.statementBalance;
    return data;
  }
}

export interface IGetAccountStatementHttpResponse {
  balance: number;
  statementDate: dayjs.Dayjs;
  statementBalance?: number | undefined;
}

export class AccountBalanceResponse implements IAccountBalanceResponse {
  currentBalance!: number;

  constructor(data?: IAccountBalanceResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentBalance = _data["currentBalance"];
    }
  }

  static fromJS(data: any): AccountBalanceResponse {
    data = typeof data === "object" ? data : {};
    let result = new AccountBalanceResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["currentBalance"] = this.currentBalance;
    return data;
  }
}

export interface IAccountBalanceResponse {
  currentBalance: number;
}

export class GetNextBillingChargesHttpResponse implements IGetNextBillingChargesHttpResponse {
  charges!: UpcomingCharge[];
  billingCycleId!: number;
  billingPeriodStart!: dayjs.Dayjs;
  billingPeriodEnd!: dayjs.Dayjs;

  constructor(data?: IGetNextBillingChargesHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.charges = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["charges"])) {
        this.charges = [] as any;
        for (let item of _data["charges"]) this.charges!.push(UpcomingCharge.fromJS(item));
      }
      this.billingCycleId = _data["billingCycleId"];
      this.billingPeriodStart = _data["billingPeriodStart"]
        ? dayjs(_data["billingPeriodStart"].toString())
        : (undefined as any);
      this.billingPeriodEnd = _data["billingPeriodEnd"]
        ? dayjs(_data["billingPeriodEnd"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): GetNextBillingChargesHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetNextBillingChargesHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.charges)) {
      data["charges"] = [];
      for (let item of this.charges) data["charges"].push(item ? item.toJSON() : (undefined as any));
    }
    data["billingCycleId"] = this.billingCycleId;
    data["billingPeriodStart"] = this.billingPeriodStart ? this.billingPeriodStart.toISOString() : (undefined as any);
    data["billingPeriodEnd"] = this.billingPeriodEnd ? this.billingPeriodEnd.toISOString() : (undefined as any);
    return data;
  }
}

export interface IGetNextBillingChargesHttpResponse {
  charges: UpcomingCharge[];
  billingCycleId: number;
  billingPeriodStart: dayjs.Dayjs;
  billingPeriodEnd: dayjs.Dayjs;
}

export class UpcomingCharge implements IUpcomingCharge {
  bookingId?: number | undefined;
  date!: dayjs.Dayjs;
  childId!: number;
  rollId!: number;
  grossAmount!: number;
  discountAmount!: number;
  ccs!: number;
  accs!: number;
  serviceName!: string;
  firstName!: string;
  lastName!: string;
  feeName!: string;
  cancellationStatusId!: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName!: string;
  multiChildrenDiscount!: number;

  constructor(data?: IUpcomingCharge) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingId = _data["bookingId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.grossAmount = _data["grossAmount"];
      this.discountAmount = _data["discountAmount"];
      this.ccs = _data["ccs"];
      this.accs = _data["accs"];
      this.serviceName = _data["serviceName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.feeName = _data["feeName"];
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.hasAttended = _data["hasAttended"];
      this.isMarked = _data["isMarked"];
      this.rollName = _data["rollName"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): UpcomingCharge {
    data = typeof data === "object" ? data : {};
    let result = new UpcomingCharge();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingId"] = this.bookingId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["grossAmount"] = this.grossAmount;
    data["discountAmount"] = this.discountAmount;
    data["ccs"] = this.ccs;
    data["accs"] = this.accs;
    data["serviceName"] = this.serviceName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["feeName"] = this.feeName;
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["hasAttended"] = this.hasAttended;
    data["isMarked"] = this.isMarked;
    data["rollName"] = this.rollName;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IUpcomingCharge {
  bookingId?: number | undefined;
  date: dayjs.Dayjs;
  childId: number;
  rollId: number;
  grossAmount: number;
  discountAmount: number;
  ccs: number;
  accs: number;
  serviceName: string;
  firstName: string;
  lastName: string;
  feeName: string;
  cancellationStatusId: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName: string;
  multiChildrenDiscount: number;
}

export class GetWeeklyUpcomingChargesHttpResponse implements IGetWeeklyUpcomingChargesHttpResponse {
  charges!: WeeklyUpcomingCharge[];
  billingPeriodStart!: dayjs.Dayjs;
  billingPeriodEnd!: dayjs.Dayjs;

  constructor(data?: IGetWeeklyUpcomingChargesHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.charges = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["charges"])) {
        this.charges = [] as any;
        for (let item of _data["charges"]) this.charges!.push(WeeklyUpcomingCharge.fromJS(item));
      }
      this.billingPeriodStart = _data["billingPeriodStart"]
        ? dayjs(_data["billingPeriodStart"].toString())
        : (undefined as any);
      this.billingPeriodEnd = _data["billingPeriodEnd"]
        ? dayjs(_data["billingPeriodEnd"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): GetWeeklyUpcomingChargesHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetWeeklyUpcomingChargesHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.charges)) {
      data["charges"] = [];
      for (let item of this.charges) data["charges"].push(item ? item.toJSON() : (undefined as any));
    }
    data["billingPeriodStart"] = this.billingPeriodStart ? this.billingPeriodStart.toISOString() : (undefined as any);
    data["billingPeriodEnd"] = this.billingPeriodEnd ? this.billingPeriodEnd.toISOString() : (undefined as any);
    return data;
  }
}

export interface IGetWeeklyUpcomingChargesHttpResponse {
  charges: WeeklyUpcomingCharge[];
  billingPeriodStart: dayjs.Dayjs;
  billingPeriodEnd: dayjs.Dayjs;
}

export class WeeklyUpcomingCharge implements IWeeklyUpcomingCharge {
  bookingId?: number | undefined;
  date!: dayjs.Dayjs;
  childId!: number;
  rollId!: number;
  grossAmount!: number;
  discountAmount!: number;
  ccs!: number;
  accs!: number;
  serviceName!: string;
  firstName!: string;
  lastName!: string;
  feeName!: string;
  cancellationStatusId!: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName!: string;
  multiChildrenDiscount!: number;

  constructor(data?: IWeeklyUpcomingCharge) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingId = _data["bookingId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.grossAmount = _data["grossAmount"];
      this.discountAmount = _data["discountAmount"];
      this.ccs = _data["ccs"];
      this.accs = _data["accs"];
      this.serviceName = _data["serviceName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.feeName = _data["feeName"];
      this.cancellationStatusId = _data["cancellationStatusId"];
      this.hasAttended = _data["hasAttended"];
      this.isMarked = _data["isMarked"];
      this.rollName = _data["rollName"];
      this.multiChildrenDiscount = _data["multiChildrenDiscount"];
    }
  }

  static fromJS(data: any): WeeklyUpcomingCharge {
    data = typeof data === "object" ? data : {};
    let result = new WeeklyUpcomingCharge();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingId"] = this.bookingId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["grossAmount"] = this.grossAmount;
    data["discountAmount"] = this.discountAmount;
    data["ccs"] = this.ccs;
    data["accs"] = this.accs;
    data["serviceName"] = this.serviceName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["feeName"] = this.feeName;
    data["cancellationStatusId"] = this.cancellationStatusId;
    data["hasAttended"] = this.hasAttended;
    data["isMarked"] = this.isMarked;
    data["rollName"] = this.rollName;
    data["multiChildrenDiscount"] = this.multiChildrenDiscount;
    return data;
  }
}

export interface IWeeklyUpcomingCharge {
  bookingId?: number | undefined;
  date: dayjs.Dayjs;
  childId: number;
  rollId: number;
  grossAmount: number;
  discountAmount: number;
  ccs: number;
  accs: number;
  serviceName: string;
  firstName: string;
  lastName: string;
  feeName: string;
  cancellationStatusId: number;
  hasAttended?: boolean | undefined;
  isMarked?: boolean | undefined;
  rollName: string;
  multiChildrenDiscount: number;
}

export class PrivacySetting implements IPrivacySetting {
  allowActivityPhoto!: boolean;
  allowAutoLogin!: boolean;

  constructor(data?: IPrivacySetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowActivityPhoto = _data["allowActivityPhoto"];
      this.allowAutoLogin = _data["allowAutoLogin"];
    }
  }

  static fromJS(data: any): PrivacySetting {
    data = typeof data === "object" ? data : {};
    let result = new PrivacySetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["allowActivityPhoto"] = this.allowActivityPhoto;
    data["allowAutoLogin"] = this.allowAutoLogin;
    return data;
  }
}

export interface IPrivacySetting {
  allowActivityPhoto: boolean;
  allowAutoLogin: boolean;
}

export class TogglePrivacySettingHttpRequest implements ITogglePrivacySettingHttpRequest {
  privacySetting!: PrivacySettingType;
  value!: boolean;

  constructor(data?: ITogglePrivacySettingHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.privacySetting = _data["privacySetting"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): TogglePrivacySettingHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new TogglePrivacySettingHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["privacySetting"] = this.privacySetting;
    data["value"] = this.value;
    return data;
  }
}

export interface ITogglePrivacySettingHttpRequest {
  privacySetting: PrivacySettingType;
  value: boolean;
}

export enum PrivacySettingType {
  AllowAutoLogin = "allowAutoLogin",
  AllowActivityPhoto = "allowActivityPhoto",
}

export class ProgramHttpResponse implements IProgramHttpResponse {
  programDateId!: number;
  sessionId!: number;
  season!: string;
  year!: number;
  serviceId!: number;
  serviceName!: string;
  rollId!: number;
  rollName?: string | undefined;
  isELC!: boolean;
  supplierId?: number | undefined;
  provider?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  activityCode?: string | undefined;
  programDescription?: string | undefined;
  programName!: string;
  date!: dayjs.Dayjs;
  imageUrl?: string | undefined;
  session!: SessionInfo;
  programPrivateDescription?: string | undefined;

  constructor(data?: IProgramHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.session = new SessionInfo();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programDateId = _data["programDateId"];
      this.sessionId = _data["sessionId"];
      this.season = _data["season"];
      this.year = _data["year"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.isELC = _data["isELC"];
      this.supplierId = _data["supplierId"];
      this.provider = _data["provider"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.activityCode = _data["activityCode"];
      this.programDescription = _data["programDescription"];
      this.programName = _data["programName"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.imageUrl = _data["imageUrl"];
      this.session = _data["session"] ? SessionInfo.fromJS(_data["session"]) : new SessionInfo();
      this.programPrivateDescription = _data["programPrivateDescription"];
    }
  }

  static fromJS(data: any): ProgramHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ProgramHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programDateId"] = this.programDateId;
    data["sessionId"] = this.sessionId;
    data["season"] = this.season;
    data["year"] = this.year;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["isELC"] = this.isELC;
    data["supplierId"] = this.supplierId;
    data["provider"] = this.provider;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["activityCode"] = this.activityCode;
    data["programDescription"] = this.programDescription;
    data["programName"] = this.programName;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["imageUrl"] = this.imageUrl;
    data["session"] = this.session ? this.session.toJSON() : (undefined as any);
    data["programPrivateDescription"] = this.programPrivateDescription;
    return data;
  }
}

export interface IProgramHttpResponse {
  programDateId: number;
  sessionId: number;
  season: string;
  year: number;
  serviceId: number;
  serviceName: string;
  rollId: number;
  rollName?: string | undefined;
  isELC: boolean;
  supplierId?: number | undefined;
  provider?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  activityCode?: string | undefined;
  programDescription?: string | undefined;
  programName: string;
  date: dayjs.Dayjs;
  imageUrl?: string | undefined;
  session: SessionInfo;
  programPrivateDescription?: string | undefined;
}

export class CustomerProgramHttpResponse extends ProgramHttpResponse implements ICustomerProgramHttpResponse {
  isCasualFee!: boolean;

  constructor(data?: ICustomerProgramHttpResponse) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.isCasualFee = _data["isCasualFee"];
    }
  }

  static override fromJS(data: any): CustomerProgramHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerProgramHttpResponse();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isCasualFee"] = this.isCasualFee;
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerProgramHttpResponse extends IProgramHttpResponse {
  isCasualFee: boolean;
}

export class ServiceDistance implements IServiceDistance {
  service!: Service;
  distanceKM!: number;

  constructor(data?: IServiceDistance) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.service = new Service();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.service = _data["service"] ? Service.fromJS(_data["service"]) : new Service();
      this.distanceKM = _data["distanceKM"];
    }
  }

  static fromJS(data: any): ServiceDistance {
    data = typeof data === "object" ? data : {};
    let result = new ServiceDistance();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["service"] = this.service ? this.service.toJSON() : (undefined as any);
    data["distanceKM"] = this.distanceKM;
    return data;
  }
}

export interface IServiceDistance {
  service: Service;
  distanceKM: number;
}

export class ServiceProgramSummary implements IServiceProgramSummary {
  serviceId!: number;
  distanceKm!: number;
  programsCount!: number;

  constructor(data?: IServiceProgramSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.distanceKm = _data["distanceKm"];
      this.programsCount = _data["programsCount"];
    }
  }

  static fromJS(data: any): ServiceProgramSummary {
    data = typeof data === "object" ? data : {};
    let result = new ServiceProgramSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["distanceKm"] = this.distanceKm;
    data["programsCount"] = this.programsCount;
    return data;
  }
}

export interface IServiceProgramSummary {
  serviceId: number;
  distanceKm: number;
  programsCount: number;
}

export class RegistrationHttpResponse implements IRegistrationHttpResponse {
  children!: RegistrationChildHttpResponse[];
  contacts!: RegistrationContactHttpResponse[];
  documents!: RegistrationDocumentHttpResponse[];
  possibleDuplicatedAccount!: boolean;

  constructor(data?: IRegistrationHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.children = [];
      this.contacts = [];
      this.documents = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["children"])) {
        this.children = [] as any;
        for (let item of _data["children"]) this.children!.push(RegistrationChildHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"]) this.contacts!.push(RegistrationContactHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["documents"])) {
        this.documents = [] as any;
        for (let item of _data["documents"]) this.documents!.push(RegistrationDocumentHttpResponse.fromJS(item));
      }
      this.possibleDuplicatedAccount = _data["possibleDuplicatedAccount"];
    }
  }

  static fromJS(data: any): RegistrationHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.children)) {
      data["children"] = [];
      for (let item of this.children) data["children"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.documents)) {
      data["documents"] = [];
      for (let item of this.documents) data["documents"].push(item ? item.toJSON() : (undefined as any));
    }
    data["possibleDuplicatedAccount"] = this.possibleDuplicatedAccount;
    return data;
  }
}

export interface IRegistrationHttpResponse {
  children: RegistrationChildHttpResponse[];
  contacts: RegistrationContactHttpResponse[];
  documents: RegistrationDocumentHttpResponse[];
  possibleDuplicatedAccount: boolean;
}

export class RegistrationChildHttpResponse implements IRegistrationChildHttpResponse {
  uniqueId!: string;
  crn?: string | undefined;
  firstName!: string;
  lastName!: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  residentialAddressId?: string | undefined;
  schoolId?: number | undefined;
  schoolName?: string | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary!: boolean;
  sameCulturalDetailsAsPrimary!: boolean;
  sameSchoolDetailsAsFirstChild!: boolean;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  residentialAddress?: RegistrationAddressHttpResponse | undefined;
  medicalConditions?: number[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild!: boolean;
  sameMedicalContactAsFirstChild!: boolean;
  otherMedicalCondition?: string | undefined;
  medicalPlanAnswers?: RegistrationMedicalPlanAnswerHttpResponse[] | undefined;
  authorize?: boolean | undefined;
  informationIsTrue?: boolean | undefined;
  signatureDocumentId?: string | undefined;

  constructor(data?: IRegistrationChildHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.crn = _data["crn"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
      this.residentialAddressId = _data["residentialAddressId"];
      this.schoolId = _data["schoolId"];
      this.schoolName = _data["schoolName"];
      this.homePhone = _data["homePhone"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.sameAddressDetailsAsPrimary = _data["sameAddressDetailsAsPrimary"];
      this.sameCulturalDetailsAsPrimary = _data["sameCulturalDetailsAsPrimary"];
      this.sameSchoolDetailsAsFirstChild = _data["sameSchoolDetailsAsFirstChild"];
      this.indigenousStatus = _data["indigenousStatus"];
      this.dietaryRequirements = _data["dietaryRequirements"];
      this.specialNeeds = _data["specialNeeds"];
      this.educationNeeds = _data["educationNeeds"];
      this.behaviouralNeeds = _data["behaviouralNeeds"];
      this.physicalNeeds = _data["physicalNeeds"];
      this.medicalNeeds = _data["medicalNeeds"];
      this.disability = _data["disability"];
      this.allergies = _data["allergies"];
      this.anaphylaxisProblem = _data["anaphylaxisProblem"];
      this.anaphylaxisSeverity = _data["anaphylaxisSeverity"];
      this.anaphylaxisType = _data["anaphylaxisType"];
      this.anaphylaxisTreatment = _data["anaphylaxisTreatment"];
      this.medicalServiceName = _data["medicalServiceName"];
      this.doctorName = _data["doctorName"];
      this.doctorAddress = _data["doctorAddress"];
      this.doctorPhone = _data["doctorPhone"];
      this.doctorSuburb = _data["doctorSuburb"];
      this.doctorState = _data["doctorState"];
      this.doctorPostcode = _data["doctorPostcode"];
      this.ambulanceNumber = _data["ambulanceNumber"];
      this.hasBeenImmunised = _data["hasBeenImmunised"];
      this.hasMedicalConditions = _data["hasMedicalConditions"];
      this.hasPhysicalNeeds = _data["hasPhysicalNeeds"];
      this.hasBehaviouralNeeds = _data["hasBehaviouralNeeds"];
      this.hasSpecialNeeds = _data["hasSpecialNeeds"];
      this.hasDietaryRequirements = _data["hasDietaryRequirements"];
      this.residentialAddress = _data["residentialAddress"]
        ? RegistrationAddressHttpResponse.fromJS(_data["residentialAddress"])
        : (undefined as any);
      if (Array.isArray(_data["medicalConditions"])) {
        this.medicalConditions = [] as any;
        for (let item of _data["medicalConditions"]) this.medicalConditions!.push(item);
      }
      if (Array.isArray(_data["medicalConditionDetails"])) {
        this.medicalConditionDetails = [] as any;
        for (let item of _data["medicalConditionDetails"]) this.medicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["noMedicalConditionDetails"])) {
        this.noMedicalConditionDetails = [] as any;
        for (let item of _data["noMedicalConditionDetails"]) this.noMedicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["childSituations"])) {
        this.childSituations = [] as any;
        for (let item of _data["childSituations"]) this.childSituations!.push(item);
      }
      this.allowAdministerMedicine = _data["allowAdministerMedicine"];
      this.allowAmbulanceTransportation = _data["allowAmbulanceTransportation"];
      this.allowMedicalTreatment = _data["allowMedicalTreatment"];
      this.allowTakeOutside = _data["allowTakeOutside"];
      this.priorityAccessId = _data["priorityAccessId"];
      this.avatarIndex = _data["avatarIndex"];
      this.medicareNumber = _data["medicareNumber"];
      this.sameLivingCareAsFirstChild = _data["sameLivingCareAsFirstChild"];
      this.sameMedicalContactAsFirstChild = _data["sameMedicalContactAsFirstChild"];
      this.otherMedicalCondition = _data["otherMedicalCondition"];
      if (Array.isArray(_data["medicalPlanAnswers"])) {
        this.medicalPlanAnswers = [] as any;
        for (let item of _data["medicalPlanAnswers"])
          this.medicalPlanAnswers!.push(RegistrationMedicalPlanAnswerHttpResponse.fromJS(item));
      }
      this.authorize = _data["authorize"];
      this.informationIsTrue = _data["informationIsTrue"];
      this.signatureDocumentId = _data["signatureDocumentId"];
    }
  }

  static fromJS(data: any): RegistrationChildHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationChildHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["crn"] = this.crn;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    data["residentialAddressId"] = this.residentialAddressId;
    data["schoolId"] = this.schoolId;
    data["schoolName"] = this.schoolName;
    data["homePhone"] = this.homePhone;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["sameAddressDetailsAsPrimary"] = this.sameAddressDetailsAsPrimary;
    data["sameCulturalDetailsAsPrimary"] = this.sameCulturalDetailsAsPrimary;
    data["sameSchoolDetailsAsFirstChild"] = this.sameSchoolDetailsAsFirstChild;
    data["indigenousStatus"] = this.indigenousStatus;
    data["dietaryRequirements"] = this.dietaryRequirements;
    data["specialNeeds"] = this.specialNeeds;
    data["educationNeeds"] = this.educationNeeds;
    data["behaviouralNeeds"] = this.behaviouralNeeds;
    data["physicalNeeds"] = this.physicalNeeds;
    data["medicalNeeds"] = this.medicalNeeds;
    data["disability"] = this.disability;
    data["allergies"] = this.allergies;
    data["anaphylaxisProblem"] = this.anaphylaxisProblem;
    data["anaphylaxisSeverity"] = this.anaphylaxisSeverity;
    data["anaphylaxisType"] = this.anaphylaxisType;
    data["anaphylaxisTreatment"] = this.anaphylaxisTreatment;
    data["medicalServiceName"] = this.medicalServiceName;
    data["doctorName"] = this.doctorName;
    data["doctorAddress"] = this.doctorAddress;
    data["doctorPhone"] = this.doctorPhone;
    data["doctorSuburb"] = this.doctorSuburb;
    data["doctorState"] = this.doctorState;
    data["doctorPostcode"] = this.doctorPostcode;
    data["ambulanceNumber"] = this.ambulanceNumber;
    data["hasBeenImmunised"] = this.hasBeenImmunised;
    data["hasMedicalConditions"] = this.hasMedicalConditions;
    data["hasPhysicalNeeds"] = this.hasPhysicalNeeds;
    data["hasBehaviouralNeeds"] = this.hasBehaviouralNeeds;
    data["hasSpecialNeeds"] = this.hasSpecialNeeds;
    data["hasDietaryRequirements"] = this.hasDietaryRequirements;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    if (Array.isArray(this.medicalConditions)) {
      data["medicalConditions"] = [];
      for (let item of this.medicalConditions) data["medicalConditions"].push(item);
    }
    if (Array.isArray(this.medicalConditionDetails)) {
      data["medicalConditionDetails"] = [];
      for (let item of this.medicalConditionDetails) data["medicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.noMedicalConditionDetails)) {
      data["noMedicalConditionDetails"] = [];
      for (let item of this.noMedicalConditionDetails) data["noMedicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.childSituations)) {
      data["childSituations"] = [];
      for (let item of this.childSituations) data["childSituations"].push(item);
    }
    data["allowAdministerMedicine"] = this.allowAdministerMedicine;
    data["allowAmbulanceTransportation"] = this.allowAmbulanceTransportation;
    data["allowMedicalTreatment"] = this.allowMedicalTreatment;
    data["allowTakeOutside"] = this.allowTakeOutside;
    data["priorityAccessId"] = this.priorityAccessId;
    data["avatarIndex"] = this.avatarIndex;
    data["medicareNumber"] = this.medicareNumber;
    data["sameLivingCareAsFirstChild"] = this.sameLivingCareAsFirstChild;
    data["sameMedicalContactAsFirstChild"] = this.sameMedicalContactAsFirstChild;
    data["otherMedicalCondition"] = this.otherMedicalCondition;
    if (Array.isArray(this.medicalPlanAnswers)) {
      data["medicalPlanAnswers"] = [];
      for (let item of this.medicalPlanAnswers)
        data["medicalPlanAnswers"].push(item ? item.toJSON() : (undefined as any));
    }
    data["authorize"] = this.authorize;
    data["informationIsTrue"] = this.informationIsTrue;
    data["signatureDocumentId"] = this.signatureDocumentId;
    return data;
  }
}

export interface IRegistrationChildHttpResponse {
  uniqueId: string;
  crn?: string | undefined;
  firstName: string;
  lastName: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  residentialAddressId?: string | undefined;
  schoolId?: number | undefined;
  schoolName?: string | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary: boolean;
  sameCulturalDetailsAsPrimary: boolean;
  sameSchoolDetailsAsFirstChild: boolean;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  residentialAddress?: RegistrationAddressHttpResponse | undefined;
  medicalConditions?: number[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild: boolean;
  sameMedicalContactAsFirstChild: boolean;
  otherMedicalCondition?: string | undefined;
  medicalPlanAnswers?: RegistrationMedicalPlanAnswerHttpResponse[] | undefined;
  authorize?: boolean | undefined;
  informationIsTrue?: boolean | undefined;
  signatureDocumentId?: string | undefined;
}

export class RegistrationAddressHttpResponse implements IRegistrationAddressHttpResponse {
  uniqueId!: string;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;

  constructor(data?: IRegistrationAddressHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.streetLine1 = _data["streetLine1"];
      this.streetLine2 = _data["streetLine2"];
      this.suburb = _data["suburb"];
      this.postCode = _data["postCode"];
      this.state = _data["state"];
      this.country = _data["country"];
    }
  }

  static fromJS(data: any): RegistrationAddressHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationAddressHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["streetLine1"] = this.streetLine1;
    data["streetLine2"] = this.streetLine2;
    data["suburb"] = this.suburb;
    data["postCode"] = this.postCode;
    data["state"] = this.state;
    data["country"] = this.country;
    return data;
  }
}

export interface IRegistrationAddressHttpResponse {
  uniqueId: string;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
}

export class RegistrationMedicalPlanAnswerHttpResponse implements IRegistrationMedicalPlanAnswerHttpResponse {
  questionId!: number;
  conditionId!: number;
  multipleAnswerIndex!: number;
  value?: string | undefined;
  freeText?: string | undefined;

  constructor(data?: IRegistrationMedicalPlanAnswerHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionId = _data["questionId"];
      this.conditionId = _data["conditionId"];
      this.multipleAnswerIndex = _data["multipleAnswerIndex"];
      this.value = _data["value"];
      this.freeText = _data["freeText"];
    }
  }

  static fromJS(data: any): RegistrationMedicalPlanAnswerHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationMedicalPlanAnswerHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["questionId"] = this.questionId;
    data["conditionId"] = this.conditionId;
    data["multipleAnswerIndex"] = this.multipleAnswerIndex;
    data["value"] = this.value;
    data["freeText"] = this.freeText;
    return data;
  }
}

export interface IRegistrationMedicalPlanAnswerHttpResponse {
  questionId: number;
  conditionId: number;
  multipleAnswerIndex: number;
  value?: string | undefined;
  freeText?: string | undefined;
}

export class RegistrationContactHttpResponse implements IRegistrationContactHttpResponse {
  uniqueId!: string;
  contactTypeId?: number | undefined;
  isPrimary!: boolean;
  firstName!: string;
  lastName!: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  residentialAddressId?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy!: boolean;
  sameAddressDetailsAsPrimary!: boolean;
  sameCulturalDetailsAsPrimary!: boolean;
  avatarIndex?: number | undefined;
  residentialAddress?: RegistrationAddressHttpResponse | undefined;
  authorisation?: RegistrationAuthorisationHttpResponse | undefined;
  genderId?: number | undefined;

  constructor(data?: IRegistrationContactHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.contactTypeId = _data["contactTypeId"];
      this.isPrimary = _data["isPrimary"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.email = _data["email"];
      this.mobilePhone = _data["mobilePhone"];
      this.homePhone = _data["homePhone"];
      this.workPhone = _data["workPhone"];
      this.residentialAddressId = _data["residentialAddressId"];
      this.crn = _data["crn"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.planToClaimChildCareSubsidy = _data["planToClaimChildCareSubsidy"];
      this.sameAddressDetailsAsPrimary = _data["sameAddressDetailsAsPrimary"];
      this.sameCulturalDetailsAsPrimary = _data["sameCulturalDetailsAsPrimary"];
      this.avatarIndex = _data["avatarIndex"];
      this.residentialAddress = _data["residentialAddress"]
        ? RegistrationAddressHttpResponse.fromJS(_data["residentialAddress"])
        : (undefined as any);
      this.authorisation = _data["authorisation"]
        ? RegistrationAuthorisationHttpResponse.fromJS(_data["authorisation"])
        : (undefined as any);
      this.genderId = _data["genderId"];
    }
  }

  static fromJS(data: any): RegistrationContactHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationContactHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["contactTypeId"] = this.contactTypeId;
    data["isPrimary"] = this.isPrimary;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["email"] = this.email;
    data["mobilePhone"] = this.mobilePhone;
    data["homePhone"] = this.homePhone;
    data["workPhone"] = this.workPhone;
    data["residentialAddressId"] = this.residentialAddressId;
    data["crn"] = this.crn;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["planToClaimChildCareSubsidy"] = this.planToClaimChildCareSubsidy;
    data["sameAddressDetailsAsPrimary"] = this.sameAddressDetailsAsPrimary;
    data["sameCulturalDetailsAsPrimary"] = this.sameCulturalDetailsAsPrimary;
    data["avatarIndex"] = this.avatarIndex;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["authorisation"] = this.authorisation ? this.authorisation.toJSON() : (undefined as any);
    data["genderId"] = this.genderId;
    return data;
  }
}

export interface IRegistrationContactHttpResponse {
  uniqueId: string;
  contactTypeId?: number | undefined;
  isPrimary: boolean;
  firstName: string;
  lastName: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  residentialAddressId?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy: boolean;
  sameAddressDetailsAsPrimary: boolean;
  sameCulturalDetailsAsPrimary: boolean;
  avatarIndex?: number | undefined;
  residentialAddress?: RegistrationAddressHttpResponse | undefined;
  authorisation?: RegistrationAuthorisationHttpResponse | undefined;
  genderId?: number | undefined;
}

export class RegistrationAuthorisationHttpResponse implements IRegistrationAuthorisationHttpResponse {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;

  constructor(data?: IRegistrationAuthorisationHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canApproveAmbulance = _data["canApproveAmbulance"];
      this.canManageAccount = _data["canManageAccount"];
      this.canMakeAndChangeBookings = _data["canMakeAndChangeBookings"];
      this.canPickUpChild = _data["canPickUpChild"];
      this.consentToAdministerMedicine = _data["consentToAdministerMedicine"];
      this.consentToMedicalTreatment = _data["consentToMedicalTreatment"];
      this.consentToTakeOutsidePremises = _data["consentToTakeOutsidePremises"];
      this.consentForTransportation = _data["consentForTransportation"];
    }
  }

  static fromJS(data: any): RegistrationAuthorisationHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationAuthorisationHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canApproveAmbulance"] = this.canApproveAmbulance;
    data["canManageAccount"] = this.canManageAccount;
    data["canMakeAndChangeBookings"] = this.canMakeAndChangeBookings;
    data["canPickUpChild"] = this.canPickUpChild;
    data["consentToAdministerMedicine"] = this.consentToAdministerMedicine;
    data["consentToMedicalTreatment"] = this.consentToMedicalTreatment;
    data["consentToTakeOutsidePremises"] = this.consentToTakeOutsidePremises;
    data["consentForTransportation"] = this.consentForTransportation;
    return data;
  }
}

export interface IRegistrationAuthorisationHttpResponse {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;
}

export class RegistrationDocumentHttpResponse implements IRegistrationDocumentHttpResponse {
  uniqueId!: string;
  registrationChildUniqueId?: string | undefined;
  registrationContactUniqueId?: string | undefined;
  fileName!: string;
  documentTypeId!: number;
  medicalConditionId?: number | undefined;
  medicalConditionDetailId?: number | undefined;
  isRegistration!: boolean;
  medicalPlanConditionId?: number | undefined;
  medicalPlanQuestionId?: number | undefined;
  medicalPlanAnswerIndex?: number | undefined;
  expiresOn?: dayjs.Dayjs | undefined;

  constructor(data?: IRegistrationDocumentHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.registrationChildUniqueId = _data["registrationChildUniqueId"];
      this.registrationContactUniqueId = _data["registrationContactUniqueId"];
      this.fileName = _data["fileName"];
      this.documentTypeId = _data["documentTypeId"];
      this.medicalConditionId = _data["medicalConditionId"];
      this.medicalConditionDetailId = _data["medicalConditionDetailId"];
      this.isRegistration = _data["isRegistration"];
      this.medicalPlanConditionId = _data["medicalPlanConditionId"];
      this.medicalPlanQuestionId = _data["medicalPlanQuestionId"];
      this.medicalPlanAnswerIndex = _data["medicalPlanAnswerIndex"];
      this.expiresOn = _data["expiresOn"] ? dayjs(_data["expiresOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): RegistrationDocumentHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RegistrationDocumentHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["registrationChildUniqueId"] = this.registrationChildUniqueId;
    data["registrationContactUniqueId"] = this.registrationContactUniqueId;
    data["fileName"] = this.fileName;
    data["documentTypeId"] = this.documentTypeId;
    data["medicalConditionId"] = this.medicalConditionId;
    data["medicalConditionDetailId"] = this.medicalConditionDetailId;
    data["isRegistration"] = this.isRegistration;
    data["medicalPlanConditionId"] = this.medicalPlanConditionId;
    data["medicalPlanQuestionId"] = this.medicalPlanQuestionId;
    data["medicalPlanAnswerIndex"] = this.medicalPlanAnswerIndex;
    data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IRegistrationDocumentHttpResponse {
  uniqueId: string;
  registrationChildUniqueId?: string | undefined;
  registrationContactUniqueId?: string | undefined;
  fileName: string;
  documentTypeId: number;
  medicalConditionId?: number | undefined;
  medicalConditionDetailId?: number | undefined;
  isRegistration: boolean;
  medicalPlanConditionId?: number | undefined;
  medicalPlanQuestionId?: number | undefined;
  medicalPlanAnswerIndex?: number | undefined;
  expiresOn?: dayjs.Dayjs | undefined;
}

export class CompleteRegistrationHttpRequest implements ICompleteRegistrationHttpRequest {
  children!: SaveRegistrationChildHttpRequest[];
  contacts!: SaveRegistrationContactHttpRequest[];
  payment?: SaveRegistrationPaymentHttpRequest | undefined;

  constructor(data?: ICompleteRegistrationHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.children = [];
      this.contacts = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["children"])) {
        this.children = [] as any;
        for (let item of _data["children"]) this.children!.push(SaveRegistrationChildHttpRequest.fromJS(item));
      }
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"]) this.contacts!.push(SaveRegistrationContactHttpRequest.fromJS(item));
      }
      this.payment = _data["payment"]
        ? SaveRegistrationPaymentHttpRequest.fromJS(_data["payment"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): CompleteRegistrationHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new CompleteRegistrationHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.children)) {
      data["children"] = [];
      for (let item of this.children) data["children"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item ? item.toJSON() : (undefined as any));
    }
    data["payment"] = this.payment ? this.payment.toJSON() : (undefined as any);
    return data;
  }
}

export interface ICompleteRegistrationHttpRequest {
  children: SaveRegistrationChildHttpRequest[];
  contacts: SaveRegistrationContactHttpRequest[];
  payment?: SaveRegistrationPaymentHttpRequest | undefined;
}

export class SaveRegistrationChildHttpRequest implements ISaveRegistrationChildHttpRequest {
  uniqueId!: string;
  crn?: string | undefined;
  firstName!: string;
  lastName!: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  schoolId?: number | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  sameSchoolDetailsAsFirstChild?: boolean | undefined;
  residentialAddress?: SaveRegistrationAddressHttpRequest | undefined;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: number[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild?: boolean | undefined;
  sameMedicalContactAsFirstChild?: boolean | undefined;
  otherMedicalCondition?: string | undefined;
  medicalPlanAnswers?: SaveRegistrationMedicalPlanAnswerHttpRequest[] | undefined;
  signature?: string | undefined;
  authorize?: boolean | undefined;
  informationIsTrue?: boolean | undefined;
  signatureDocumentId?: string | undefined;

  constructor(data?: ISaveRegistrationChildHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.crn = _data["crn"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
      this.schoolId = _data["schoolId"];
      this.homePhone = _data["homePhone"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.sameAddressDetailsAsPrimary = _data["sameAddressDetailsAsPrimary"];
      this.sameCulturalDetailsAsPrimary = _data["sameCulturalDetailsAsPrimary"];
      this.sameSchoolDetailsAsFirstChild = _data["sameSchoolDetailsAsFirstChild"];
      this.residentialAddress = _data["residentialAddress"]
        ? SaveRegistrationAddressHttpRequest.fromJS(_data["residentialAddress"])
        : (undefined as any);
      this.indigenousStatus = _data["indigenousStatus"];
      this.dietaryRequirements = _data["dietaryRequirements"];
      this.specialNeeds = _data["specialNeeds"];
      this.educationNeeds = _data["educationNeeds"];
      this.behaviouralNeeds = _data["behaviouralNeeds"];
      this.physicalNeeds = _data["physicalNeeds"];
      this.medicalNeeds = _data["medicalNeeds"];
      this.disability = _data["disability"];
      this.allergies = _data["allergies"];
      this.anaphylaxisProblem = _data["anaphylaxisProblem"];
      this.anaphylaxisSeverity = _data["anaphylaxisSeverity"];
      this.anaphylaxisType = _data["anaphylaxisType"];
      this.anaphylaxisTreatment = _data["anaphylaxisTreatment"];
      this.medicalServiceName = _data["medicalServiceName"];
      this.doctorName = _data["doctorName"];
      this.doctorAddress = _data["doctorAddress"];
      this.doctorPhone = _data["doctorPhone"];
      this.doctorSuburb = _data["doctorSuburb"];
      this.doctorState = _data["doctorState"];
      this.doctorPostcode = _data["doctorPostcode"];
      this.ambulanceNumber = _data["ambulanceNumber"];
      this.hasBeenImmunised = _data["hasBeenImmunised"];
      this.hasMedicalConditions = _data["hasMedicalConditions"];
      this.hasPhysicalNeeds = _data["hasPhysicalNeeds"];
      this.hasBehaviouralNeeds = _data["hasBehaviouralNeeds"];
      this.hasSpecialNeeds = _data["hasSpecialNeeds"];
      this.hasDietaryRequirements = _data["hasDietaryRequirements"];
      if (Array.isArray(_data["medicalConditions"])) {
        this.medicalConditions = [] as any;
        for (let item of _data["medicalConditions"]) this.medicalConditions!.push(item);
      }
      if (Array.isArray(_data["medicalConditionDetails"])) {
        this.medicalConditionDetails = [] as any;
        for (let item of _data["medicalConditionDetails"]) this.medicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["noMedicalConditionDetails"])) {
        this.noMedicalConditionDetails = [] as any;
        for (let item of _data["noMedicalConditionDetails"]) this.noMedicalConditionDetails!.push(item);
      }
      if (Array.isArray(_data["childSituations"])) {
        this.childSituations = [] as any;
        for (let item of _data["childSituations"]) this.childSituations!.push(item);
      }
      this.allowAdministerMedicine = _data["allowAdministerMedicine"];
      this.allowAmbulanceTransportation = _data["allowAmbulanceTransportation"];
      this.allowMedicalTreatment = _data["allowMedicalTreatment"];
      this.allowTakeOutside = _data["allowTakeOutside"];
      this.priorityAccessId = _data["priorityAccessId"];
      this.avatarIndex = _data["avatarIndex"];
      this.medicareNumber = _data["medicareNumber"];
      this.sameLivingCareAsFirstChild = _data["sameLivingCareAsFirstChild"];
      this.sameMedicalContactAsFirstChild = _data["sameMedicalContactAsFirstChild"];
      this.otherMedicalCondition = _data["otherMedicalCondition"];
      if (Array.isArray(_data["medicalPlanAnswers"])) {
        this.medicalPlanAnswers = [] as any;
        for (let item of _data["medicalPlanAnswers"])
          this.medicalPlanAnswers!.push(SaveRegistrationMedicalPlanAnswerHttpRequest.fromJS(item));
      }
      this.signature = _data["signature"];
      this.authorize = _data["authorize"];
      this.informationIsTrue = _data["informationIsTrue"];
      this.signatureDocumentId = _data["signatureDocumentId"];
    }
  }

  static fromJS(data: any): SaveRegistrationChildHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationChildHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["crn"] = this.crn;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    data["schoolId"] = this.schoolId;
    data["homePhone"] = this.homePhone;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["sameAddressDetailsAsPrimary"] = this.sameAddressDetailsAsPrimary;
    data["sameCulturalDetailsAsPrimary"] = this.sameCulturalDetailsAsPrimary;
    data["sameSchoolDetailsAsFirstChild"] = this.sameSchoolDetailsAsFirstChild;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["indigenousStatus"] = this.indigenousStatus;
    data["dietaryRequirements"] = this.dietaryRequirements;
    data["specialNeeds"] = this.specialNeeds;
    data["educationNeeds"] = this.educationNeeds;
    data["behaviouralNeeds"] = this.behaviouralNeeds;
    data["physicalNeeds"] = this.physicalNeeds;
    data["medicalNeeds"] = this.medicalNeeds;
    data["disability"] = this.disability;
    data["allergies"] = this.allergies;
    data["anaphylaxisProblem"] = this.anaphylaxisProblem;
    data["anaphylaxisSeverity"] = this.anaphylaxisSeverity;
    data["anaphylaxisType"] = this.anaphylaxisType;
    data["anaphylaxisTreatment"] = this.anaphylaxisTreatment;
    data["medicalServiceName"] = this.medicalServiceName;
    data["doctorName"] = this.doctorName;
    data["doctorAddress"] = this.doctorAddress;
    data["doctorPhone"] = this.doctorPhone;
    data["doctorSuburb"] = this.doctorSuburb;
    data["doctorState"] = this.doctorState;
    data["doctorPostcode"] = this.doctorPostcode;
    data["ambulanceNumber"] = this.ambulanceNumber;
    data["hasBeenImmunised"] = this.hasBeenImmunised;
    data["hasMedicalConditions"] = this.hasMedicalConditions;
    data["hasPhysicalNeeds"] = this.hasPhysicalNeeds;
    data["hasBehaviouralNeeds"] = this.hasBehaviouralNeeds;
    data["hasSpecialNeeds"] = this.hasSpecialNeeds;
    data["hasDietaryRequirements"] = this.hasDietaryRequirements;
    if (Array.isArray(this.medicalConditions)) {
      data["medicalConditions"] = [];
      for (let item of this.medicalConditions) data["medicalConditions"].push(item);
    }
    if (Array.isArray(this.medicalConditionDetails)) {
      data["medicalConditionDetails"] = [];
      for (let item of this.medicalConditionDetails) data["medicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.noMedicalConditionDetails)) {
      data["noMedicalConditionDetails"] = [];
      for (let item of this.noMedicalConditionDetails) data["noMedicalConditionDetails"].push(item);
    }
    if (Array.isArray(this.childSituations)) {
      data["childSituations"] = [];
      for (let item of this.childSituations) data["childSituations"].push(item);
    }
    data["allowAdministerMedicine"] = this.allowAdministerMedicine;
    data["allowAmbulanceTransportation"] = this.allowAmbulanceTransportation;
    data["allowMedicalTreatment"] = this.allowMedicalTreatment;
    data["allowTakeOutside"] = this.allowTakeOutside;
    data["priorityAccessId"] = this.priorityAccessId;
    data["avatarIndex"] = this.avatarIndex;
    data["medicareNumber"] = this.medicareNumber;
    data["sameLivingCareAsFirstChild"] = this.sameLivingCareAsFirstChild;
    data["sameMedicalContactAsFirstChild"] = this.sameMedicalContactAsFirstChild;
    data["otherMedicalCondition"] = this.otherMedicalCondition;
    if (Array.isArray(this.medicalPlanAnswers)) {
      data["medicalPlanAnswers"] = [];
      for (let item of this.medicalPlanAnswers)
        data["medicalPlanAnswers"].push(item ? item.toJSON() : (undefined as any));
    }
    data["signature"] = this.signature;
    data["authorize"] = this.authorize;
    data["informationIsTrue"] = this.informationIsTrue;
    data["signatureDocumentId"] = this.signatureDocumentId;
    return data;
  }
}

export interface ISaveRegistrationChildHttpRequest {
  uniqueId: string;
  crn?: string | undefined;
  firstName: string;
  lastName: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
  schoolId?: number | undefined;
  homePhone?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  sameSchoolDetailsAsFirstChild?: boolean | undefined;
  residentialAddress?: SaveRegistrationAddressHttpRequest | undefined;
  indigenousStatus?: string | undefined;
  dietaryRequirements?: string | undefined;
  specialNeeds?: string | undefined;
  educationNeeds?: string | undefined;
  behaviouralNeeds?: string | undefined;
  physicalNeeds?: string | undefined;
  medicalNeeds?: string | undefined;
  disability?: string | undefined;
  allergies?: string | undefined;
  anaphylaxisProblem?: string | undefined;
  anaphylaxisSeverity?: string | undefined;
  anaphylaxisType?: string | undefined;
  anaphylaxisTreatment?: string | undefined;
  medicalServiceName?: string | undefined;
  doctorName?: string | undefined;
  doctorAddress?: string | undefined;
  doctorPhone?: string | undefined;
  doctorSuburb?: string | undefined;
  doctorState?: string | undefined;
  doctorPostcode?: string | undefined;
  ambulanceNumber?: string | undefined;
  hasBeenImmunised?: boolean | undefined;
  hasMedicalConditions?: boolean | undefined;
  hasPhysicalNeeds?: boolean | undefined;
  hasBehaviouralNeeds?: boolean | undefined;
  hasSpecialNeeds?: boolean | undefined;
  hasDietaryRequirements?: boolean | undefined;
  medicalConditions?: number[] | undefined;
  medicalConditionDetails?: number[] | undefined;
  noMedicalConditionDetails?: number[] | undefined;
  childSituations?: number[] | undefined;
  allowAdministerMedicine?: boolean | undefined;
  allowAmbulanceTransportation?: boolean | undefined;
  allowMedicalTreatment?: boolean | undefined;
  allowTakeOutside?: boolean | undefined;
  priorityAccessId?: number | undefined;
  avatarIndex?: number | undefined;
  medicareNumber?: string | undefined;
  sameLivingCareAsFirstChild?: boolean | undefined;
  sameMedicalContactAsFirstChild?: boolean | undefined;
  otherMedicalCondition?: string | undefined;
  medicalPlanAnswers?: SaveRegistrationMedicalPlanAnswerHttpRequest[] | undefined;
  signature?: string | undefined;
  authorize?: boolean | undefined;
  informationIsTrue?: boolean | undefined;
  signatureDocumentId?: string | undefined;
}

export class SaveRegistrationAddressHttpRequest implements ISaveRegistrationAddressHttpRequest {
  uniqueId!: string;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;

  constructor(data?: ISaveRegistrationAddressHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.streetLine1 = _data["streetLine1"];
      this.streetLine2 = _data["streetLine2"];
      this.suburb = _data["suburb"];
      this.postCode = _data["postCode"];
      this.state = _data["state"];
      this.country = _data["country"];
    }
  }

  static fromJS(data: any): SaveRegistrationAddressHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationAddressHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["streetLine1"] = this.streetLine1;
    data["streetLine2"] = this.streetLine2;
    data["suburb"] = this.suburb;
    data["postCode"] = this.postCode;
    data["state"] = this.state;
    data["country"] = this.country;
    return data;
  }
}

export interface ISaveRegistrationAddressHttpRequest {
  uniqueId: string;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postCode?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
}

export class SaveRegistrationMedicalPlanAnswerHttpRequest implements ISaveRegistrationMedicalPlanAnswerHttpRequest {
  questionId!: number;
  conditionId!: number;
  multipleAnswerIndex!: number;
  value?: string | undefined;
  freeText?: string | undefined;

  constructor(data?: ISaveRegistrationMedicalPlanAnswerHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.questionId = _data["questionId"];
      this.conditionId = _data["conditionId"];
      this.multipleAnswerIndex = _data["multipleAnswerIndex"];
      this.value = _data["value"];
      this.freeText = _data["freeText"];
    }
  }

  static fromJS(data: any): SaveRegistrationMedicalPlanAnswerHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationMedicalPlanAnswerHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["questionId"] = this.questionId;
    data["conditionId"] = this.conditionId;
    data["multipleAnswerIndex"] = this.multipleAnswerIndex;
    data["value"] = this.value;
    data["freeText"] = this.freeText;
    return data;
  }
}

export interface ISaveRegistrationMedicalPlanAnswerHttpRequest {
  questionId: number;
  conditionId: number;
  multipleAnswerIndex: number;
  value?: string | undefined;
  freeText?: string | undefined;
}

export class SaveRegistrationContactHttpRequest implements ISaveRegistrationContactHttpRequest {
  uniqueId!: string;
  contactTypeId?: number | undefined;
  isPrimary!: boolean;
  firstName!: string;
  lastName!: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy?: boolean | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  avatarIndex?: number | undefined;
  residentialAddress?: SaveRegistrationAddressHttpRequest | undefined;
  authorisation?: SaveRegistrationAuthorisationHttpRequest | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;

  constructor(data?: ISaveRegistrationContactHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data["uniqueId"];
      this.contactTypeId = _data["contactTypeId"];
      this.isPrimary = _data["isPrimary"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.createdAt = _data["createdAt"] ? dayjs(_data["createdAt"].toString()) : (undefined as any);
      this.birthday = _data["birthday"] ? dayjs(_data["birthday"].toString()) : (undefined as any);
      this.email = _data["email"];
      this.mobilePhone = _data["mobilePhone"];
      this.homePhone = _data["homePhone"];
      this.workPhone = _data["workPhone"];
      this.crn = _data["crn"];
      this.culturalBackground = _data["culturalBackground"];
      this.mainLanguage = _data["mainLanguage"];
      this.secondaryLanguage = _data["secondaryLanguage"];
      this.culturalNeeds = _data["culturalNeeds"];
      this.planToClaimChildCareSubsidy = _data["planToClaimChildCareSubsidy"];
      this.sameAddressDetailsAsPrimary = _data["sameAddressDetailsAsPrimary"];
      this.sameCulturalDetailsAsPrimary = _data["sameCulturalDetailsAsPrimary"];
      this.avatarIndex = _data["avatarIndex"];
      this.residentialAddress = _data["residentialAddress"]
        ? SaveRegistrationAddressHttpRequest.fromJS(_data["residentialAddress"])
        : (undefined as any);
      this.authorisation = _data["authorisation"]
        ? SaveRegistrationAuthorisationHttpRequest.fromJS(_data["authorisation"])
        : (undefined as any);
      this.genderId = _data["genderId"];
      this.otherGender = _data["otherGender"];
    }
  }

  static fromJS(data: any): SaveRegistrationContactHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationContactHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["uniqueId"] = this.uniqueId;
    data["contactTypeId"] = this.contactTypeId;
    data["isPrimary"] = this.isPrimary;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : (undefined as any);
    data["birthday"] = this.birthday ? this.birthday.toISOString() : (undefined as any);
    data["email"] = this.email;
    data["mobilePhone"] = this.mobilePhone;
    data["homePhone"] = this.homePhone;
    data["workPhone"] = this.workPhone;
    data["crn"] = this.crn;
    data["culturalBackground"] = this.culturalBackground;
    data["mainLanguage"] = this.mainLanguage;
    data["secondaryLanguage"] = this.secondaryLanguage;
    data["culturalNeeds"] = this.culturalNeeds;
    data["planToClaimChildCareSubsidy"] = this.planToClaimChildCareSubsidy;
    data["sameAddressDetailsAsPrimary"] = this.sameAddressDetailsAsPrimary;
    data["sameCulturalDetailsAsPrimary"] = this.sameCulturalDetailsAsPrimary;
    data["avatarIndex"] = this.avatarIndex;
    data["residentialAddress"] = this.residentialAddress ? this.residentialAddress.toJSON() : (undefined as any);
    data["authorisation"] = this.authorisation ? this.authorisation.toJSON() : (undefined as any);
    data["genderId"] = this.genderId;
    data["otherGender"] = this.otherGender;
    return data;
  }
}

export interface ISaveRegistrationContactHttpRequest {
  uniqueId: string;
  contactTypeId?: number | undefined;
  isPrimary: boolean;
  firstName: string;
  lastName: string;
  createdAt?: dayjs.Dayjs | undefined;
  birthday?: dayjs.Dayjs | undefined;
  email?: string | undefined;
  mobilePhone?: string | undefined;
  homePhone?: string | undefined;
  workPhone?: string | undefined;
  crn?: string | undefined;
  culturalBackground?: string | undefined;
  mainLanguage?: string | undefined;
  secondaryLanguage?: string | undefined;
  culturalNeeds?: string | undefined;
  planToClaimChildCareSubsidy?: boolean | undefined;
  sameAddressDetailsAsPrimary?: boolean | undefined;
  sameCulturalDetailsAsPrimary?: boolean | undefined;
  avatarIndex?: number | undefined;
  residentialAddress?: SaveRegistrationAddressHttpRequest | undefined;
  authorisation?: SaveRegistrationAuthorisationHttpRequest | undefined;
  genderId?: number | undefined;
  otherGender?: string | undefined;
}

export class SaveRegistrationAuthorisationHttpRequest implements ISaveRegistrationAuthorisationHttpRequest {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;

  constructor(data?: ISaveRegistrationAuthorisationHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canApproveAmbulance = _data["canApproveAmbulance"];
      this.canManageAccount = _data["canManageAccount"];
      this.canMakeAndChangeBookings = _data["canMakeAndChangeBookings"];
      this.canPickUpChild = _data["canPickUpChild"];
      this.consentToAdministerMedicine = _data["consentToAdministerMedicine"];
      this.consentToMedicalTreatment = _data["consentToMedicalTreatment"];
      this.consentToTakeOutsidePremises = _data["consentToTakeOutsidePremises"];
      this.consentForTransportation = _data["consentForTransportation"];
    }
  }

  static fromJS(data: any): SaveRegistrationAuthorisationHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationAuthorisationHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["canApproveAmbulance"] = this.canApproveAmbulance;
    data["canManageAccount"] = this.canManageAccount;
    data["canMakeAndChangeBookings"] = this.canMakeAndChangeBookings;
    data["canPickUpChild"] = this.canPickUpChild;
    data["consentToAdministerMedicine"] = this.consentToAdministerMedicine;
    data["consentToMedicalTreatment"] = this.consentToMedicalTreatment;
    data["consentToTakeOutsidePremises"] = this.consentToTakeOutsidePremises;
    data["consentForTransportation"] = this.consentForTransportation;
    return data;
  }
}

export interface ISaveRegistrationAuthorisationHttpRequest {
  canApproveAmbulance?: boolean | undefined;
  canManageAccount?: boolean | undefined;
  canMakeAndChangeBookings?: boolean | undefined;
  canPickUpChild?: boolean | undefined;
  consentToAdministerMedicine?: boolean | undefined;
  consentToMedicalTreatment?: boolean | undefined;
  consentToTakeOutsidePremises?: boolean | undefined;
  consentForTransportation?: boolean | undefined;
}

export class SaveRegistrationPaymentHttpRequest implements ISaveRegistrationPaymentHttpRequest {
  paymentTypeId!: number;
  financialInstitution?: string | undefined;
  branch?: string | undefined;
  bsb?: string | undefined;
  accountNumber?: string | undefined;
  accountName?: string | undefined;
  cardType?: string | undefined;
  cardNumber?: string | undefined;
  expireDateMonth?: number | undefined;
  expireDateYear?: number | undefined;
  holdersName?: string | undefined;
  acceptedTermConditions!: boolean;

  constructor(data?: ISaveRegistrationPaymentHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paymentTypeId = _data["paymentTypeId"];
      this.financialInstitution = _data["financialInstitution"];
      this.branch = _data["branch"];
      this.bsb = _data["bsb"];
      this.accountNumber = _data["accountNumber"];
      this.accountName = _data["accountName"];
      this.cardType = _data["cardType"];
      this.cardNumber = _data["cardNumber"];
      this.expireDateMonth = _data["expireDateMonth"];
      this.expireDateYear = _data["expireDateYear"];
      this.holdersName = _data["holdersName"];
      this.acceptedTermConditions = _data["acceptedTermConditions"];
    }
  }

  static fromJS(data: any): SaveRegistrationPaymentHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationPaymentHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["paymentTypeId"] = this.paymentTypeId;
    data["financialInstitution"] = this.financialInstitution;
    data["branch"] = this.branch;
    data["bsb"] = this.bsb;
    data["accountNumber"] = this.accountNumber;
    data["accountName"] = this.accountName;
    data["cardType"] = this.cardType;
    data["cardNumber"] = this.cardNumber;
    data["expireDateMonth"] = this.expireDateMonth;
    data["expireDateYear"] = this.expireDateYear;
    data["holdersName"] = this.holdersName;
    data["acceptedTermConditions"] = this.acceptedTermConditions;
    return data;
  }
}

export interface ISaveRegistrationPaymentHttpRequest {
  paymentTypeId: number;
  financialInstitution?: string | undefined;
  branch?: string | undefined;
  bsb?: string | undefined;
  accountNumber?: string | undefined;
  accountName?: string | undefined;
  cardType?: string | undefined;
  cardNumber?: string | undefined;
  expireDateMonth?: number | undefined;
  expireDateYear?: number | undefined;
  holdersName?: string | undefined;
  acceptedTermConditions: boolean;
}

export class SaveRegistrationContactsHttpRequest implements ISaveRegistrationContactsHttpRequest {
  contacts!: SaveRegistrationContactHttpRequest[];

  constructor(data?: ISaveRegistrationContactsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.contacts = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"]) this.contacts!.push(SaveRegistrationContactHttpRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SaveRegistrationContactsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveRegistrationContactsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISaveRegistrationContactsHttpRequest {
  contacts: SaveRegistrationContactHttpRequest[];
}

export class LogRegistrationEventHttpRequest implements ILogRegistrationEventHttpRequest {
  operation!: string;
  payload!: string;

  constructor(data?: ILogRegistrationEventHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.operation = _data["operation"];
      this.payload = _data["payload"];
    }
  }

  static fromJS(data: any): LogRegistrationEventHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new LogRegistrationEventHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["operation"] = this.operation;
    data["payload"] = this.payload;
    return data;
  }
}

export interface ILogRegistrationEventHttpRequest {
  operation: string;
  payload: string;
}

export class RollOverScheduleHttpResponse implements IRollOverScheduleHttpResponse {
  childId!: number;
  rollId!: number;
  startDate!: dayjs.Dayjs;
  endDate!: dayjs.Dayjs;
  frequencyTypeId!: number;
  mon1!: boolean;
  tue1!: boolean;
  wed1!: boolean;
  thu1!: boolean;
  fri1!: boolean;
  mon2!: boolean;
  tue2!: boolean;
  wed2!: boolean;
  thu2!: boolean;
  fri2!: boolean;
  processedAt?: dayjs.Dayjs | undefined;
  forYear!: number;
  cohortStatus!: RollOverStatusHttpResponse;
  rollOverStatus!: RollOverStatusHttpResponse;
  rollName!: string;
  careTypeId!: number;
  serviceId!: number;
  serviceName!: string;
  firstName!: string;
  lastName!: string;

  constructor(data?: IRollOverScheduleHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.frequencyTypeId = _data["frequencyTypeId"];
      this.mon1 = _data["mon1"];
      this.tue1 = _data["tue1"];
      this.wed1 = _data["wed1"];
      this.thu1 = _data["thu1"];
      this.fri1 = _data["fri1"];
      this.mon2 = _data["mon2"];
      this.tue2 = _data["tue2"];
      this.wed2 = _data["wed2"];
      this.thu2 = _data["thu2"];
      this.fri2 = _data["fri2"];
      this.processedAt = _data["processedAt"] ? dayjs(_data["processedAt"].toString()) : (undefined as any);
      this.forYear = _data["forYear"];
      this.cohortStatus = _data["cohortStatus"];
      this.rollOverStatus = _data["rollOverStatus"];
      this.rollName = _data["rollName"];
      this.careTypeId = _data["careTypeId"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
    }
  }

  static fromJS(data: any): RollOverScheduleHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RollOverScheduleHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.toISOString() : (undefined as any);
    data["frequencyTypeId"] = this.frequencyTypeId;
    data["mon1"] = this.mon1;
    data["tue1"] = this.tue1;
    data["wed1"] = this.wed1;
    data["thu1"] = this.thu1;
    data["fri1"] = this.fri1;
    data["mon2"] = this.mon2;
    data["tue2"] = this.tue2;
    data["wed2"] = this.wed2;
    data["thu2"] = this.thu2;
    data["fri2"] = this.fri2;
    data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : (undefined as any);
    data["forYear"] = this.forYear;
    data["cohortStatus"] = this.cohortStatus;
    data["rollOverStatus"] = this.rollOverStatus;
    data["rollName"] = this.rollName;
    data["careTypeId"] = this.careTypeId;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    return data;
  }
}

export interface IRollOverScheduleHttpResponse {
  childId: number;
  rollId: number;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  frequencyTypeId: number;
  mon1: boolean;
  tue1: boolean;
  wed1: boolean;
  thu1: boolean;
  fri1: boolean;
  mon2: boolean;
  tue2: boolean;
  wed2: boolean;
  thu2: boolean;
  fri2: boolean;
  processedAt?: dayjs.Dayjs | undefined;
  forYear: number;
  cohortStatus: RollOverStatusHttpResponse;
  rollOverStatus: RollOverStatusHttpResponse;
  rollName: string;
  careTypeId: number;
  serviceId: number;
  serviceName: string;
  firstName: string;
  lastName: string;
}

export enum RollOverStatusHttpResponse {
  Undefined = "undefined",
  OptOut = "optOut",
  OptIn = "optIn",
}

export class RollOverScheduleOptHttpRequest implements IRollOverScheduleOptHttpRequest {
  childId!: number;
  rollIds!: number[];
  rollOverStatus!: RollOverStatusHttpRequest;
  scheduleCancellationReasonId?: number | undefined;

  constructor(data?: IRollOverScheduleOptHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.rollIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      if (Array.isArray(_data["rollIds"])) {
        this.rollIds = [] as any;
        for (let item of _data["rollIds"]) this.rollIds!.push(item);
      }
      this.rollOverStatus = _data["rollOverStatus"];
      this.scheduleCancellationReasonId = _data["scheduleCancellationReasonId"];
    }
  }

  static fromJS(data: any): RollOverScheduleOptHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RollOverScheduleOptHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    if (Array.isArray(this.rollIds)) {
      data["rollIds"] = [];
      for (let item of this.rollIds) data["rollIds"].push(item);
    }
    data["rollOverStatus"] = this.rollOverStatus;
    data["scheduleCancellationReasonId"] = this.scheduleCancellationReasonId;
    return data;
  }
}

export interface IRollOverScheduleOptHttpRequest {
  childId: number;
  rollIds: number[];
  rollOverStatus: RollOverStatusHttpRequest;
  scheduleCancellationReasonId?: number | undefined;
}

export enum RollOverStatusHttpRequest {
  OptOut = "optOut",
  OptIn = "optIn",
}

export class RollOverScheduleUpdatesHttpRequest implements IRollOverScheduleUpdatesHttpRequest {
  schedules!: RollOverScheduleUpdateHttpRequest[];

  constructor(data?: IRollOverScheduleUpdatesHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.schedules = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["schedules"])) {
        this.schedules = [] as any;
        for (let item of _data["schedules"]) this.schedules!.push(RollOverScheduleUpdateHttpRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RollOverScheduleUpdatesHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RollOverScheduleUpdatesHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.schedules)) {
      data["schedules"] = [];
      for (let item of this.schedules) data["schedules"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IRollOverScheduleUpdatesHttpRequest {
  schedules: RollOverScheduleUpdateHttpRequest[];
}

export class RollOverScheduleUpdateHttpRequest implements IRollOverScheduleUpdateHttpRequest {
  childId!: number;
  rollId!: number;
  mon1!: boolean;
  tue1!: boolean;
  wed1!: boolean;
  thu1!: boolean;
  fri1!: boolean;
  mon2!: boolean;
  tue2!: boolean;
  wed2!: boolean;
  thu2!: boolean;
  fri2!: boolean;
  forYear!: number;
  rollOverStatus!: RollOverStatusHttpRequest;

  constructor(data?: IRollOverScheduleUpdateHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.rollId = _data["rollId"];
      this.mon1 = _data["mon1"];
      this.tue1 = _data["tue1"];
      this.wed1 = _data["wed1"];
      this.thu1 = _data["thu1"];
      this.fri1 = _data["fri1"];
      this.mon2 = _data["mon2"];
      this.tue2 = _data["tue2"];
      this.wed2 = _data["wed2"];
      this.thu2 = _data["thu2"];
      this.fri2 = _data["fri2"];
      this.forYear = _data["forYear"];
      this.rollOverStatus = _data["rollOverStatus"];
    }
  }

  static fromJS(data: any): RollOverScheduleUpdateHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new RollOverScheduleUpdateHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["rollId"] = this.rollId;
    data["mon1"] = this.mon1;
    data["tue1"] = this.tue1;
    data["wed1"] = this.wed1;
    data["thu1"] = this.thu1;
    data["fri1"] = this.fri1;
    data["mon2"] = this.mon2;
    data["tue2"] = this.tue2;
    data["wed2"] = this.wed2;
    data["thu2"] = this.thu2;
    data["fri2"] = this.fri2;
    data["forYear"] = this.forYear;
    data["rollOverStatus"] = this.rollOverStatus;
    return data;
  }
}

export interface IRollOverScheduleUpdateHttpRequest {
  childId: number;
  rollId: number;
  mon1: boolean;
  tue1: boolean;
  wed1: boolean;
  thu1: boolean;
  fri1: boolean;
  mon2: boolean;
  tue2: boolean;
  wed2: boolean;
  thu2: boolean;
  fri2: boolean;
  forYear: number;
  rollOverStatus: RollOverStatusHttpRequest;
}

export class RollHttpResponse implements IRollHttpResponse {
  rollId!: number;
  serviceId!: number;
  rollName?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeId?: number | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  casualFeeId?: number | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  rollClassificationId?: number | undefined;
  minAgeMths!: number;
  maxAgeMths!: number;
  ageCalculationMethod!: string;
  ageCalculation!: AgeCalculationMethod;
  isHolidayClub!: boolean;
  isOhsc!: boolean;
  nextAvailableSession!: dayjs.Dayjs;
  defaultMinAgeMths!: number;
  defaultMaxAgeMths!: number;
  monIsOpen!: boolean;
  tueIsOpen!: boolean;
  wedIsOpen!: boolean;
  thuIsOpen!: boolean;
  friIsOpen!: boolean;

  constructor(data?: IRollHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.serviceId = _data["serviceId"];
      this.rollName = _data["rollName"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.primaryFeeId = _data["primaryFeeId"];
      this.primaryFeeAmount = _data["primaryFeeAmount"];
      this.primaryFeeName = _data["primaryFeeName"];
      this.casualFeeId = _data["casualFeeId"];
      this.casualFeeName = _data["casualFeeName"];
      this.casualFeeAmount = _data["casualFeeAmount"];
      this.sessionType = _data["sessionType"];
      this.sessionSubType = _data["sessionSubType"];
      this.rollClassificationId = _data["rollClassificationId"];
      this.minAgeMths = _data["minAgeMths"];
      this.maxAgeMths = _data["maxAgeMths"];
      this.ageCalculationMethod = _data["ageCalculationMethod"];
      this.ageCalculation = _data["ageCalculation"];
      this.isHolidayClub = _data["isHolidayClub"];
      this.isOhsc = _data["isOhsc"];
      this.nextAvailableSession = _data["nextAvailableSession"]
        ? dayjs(_data["nextAvailableSession"].toString())
        : (undefined as any);
      this.defaultMinAgeMths = _data["defaultMinAgeMths"];
      this.defaultMaxAgeMths = _data["defaultMaxAgeMths"];
      this.monIsOpen = _data["monIsOpen"];
      this.tueIsOpen = _data["tueIsOpen"];
      this.wedIsOpen = _data["wedIsOpen"];
      this.thuIsOpen = _data["thuIsOpen"];
      this.friIsOpen = _data["friIsOpen"];
    }
  }

  static fromJS(data: any): RollHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new RollHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["serviceId"] = this.serviceId;
    data["rollName"] = this.rollName;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["primaryFeeId"] = this.primaryFeeId;
    data["primaryFeeAmount"] = this.primaryFeeAmount;
    data["primaryFeeName"] = this.primaryFeeName;
    data["casualFeeId"] = this.casualFeeId;
    data["casualFeeName"] = this.casualFeeName;
    data["casualFeeAmount"] = this.casualFeeAmount;
    data["sessionType"] = this.sessionType;
    data["sessionSubType"] = this.sessionSubType;
    data["rollClassificationId"] = this.rollClassificationId;
    data["minAgeMths"] = this.minAgeMths;
    data["maxAgeMths"] = this.maxAgeMths;
    data["ageCalculationMethod"] = this.ageCalculationMethod;
    data["ageCalculation"] = this.ageCalculation;
    data["isHolidayClub"] = this.isHolidayClub;
    data["isOhsc"] = this.isOhsc;
    data["nextAvailableSession"] = this.nextAvailableSession
      ? this.nextAvailableSession.toISOString()
      : (undefined as any);
    data["defaultMinAgeMths"] = this.defaultMinAgeMths;
    data["defaultMaxAgeMths"] = this.defaultMaxAgeMths;
    data["monIsOpen"] = this.monIsOpen;
    data["tueIsOpen"] = this.tueIsOpen;
    data["wedIsOpen"] = this.wedIsOpen;
    data["thuIsOpen"] = this.thuIsOpen;
    data["friIsOpen"] = this.friIsOpen;
    return data;
  }
}

export interface IRollHttpResponse {
  rollId: number;
  serviceId: number;
  rollName?: string | undefined;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  primaryFeeId?: number | undefined;
  primaryFeeAmount?: number | undefined;
  primaryFeeName?: string | undefined;
  casualFeeId?: number | undefined;
  casualFeeName?: string | undefined;
  casualFeeAmount?: number | undefined;
  sessionType?: string | undefined;
  sessionSubType?: string | undefined;
  rollClassificationId?: number | undefined;
  minAgeMths: number;
  maxAgeMths: number;
  ageCalculationMethod: string;
  ageCalculation: AgeCalculationMethod;
  isHolidayClub: boolean;
  isOhsc: boolean;
  nextAvailableSession: dayjs.Dayjs;
  defaultMinAgeMths: number;
  defaultMaxAgeMths: number;
  monIsOpen: boolean;
  tueIsOpen: boolean;
  wedIsOpen: boolean;
  thuIsOpen: boolean;
  friIsOpen: boolean;
}

export class SchoolHttpResponse implements ISchoolHttpResponse {
  schoolId!: number;
  schoolName!: string;
  caServiceId?: number | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;

  constructor(data?: ISchoolHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolId = _data["schoolId"];
      this.schoolName = _data["schoolName"];
      this.caServiceId = _data["caServiceId"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.postcode = _data["postcode"];
    }
  }

  static fromJS(data: any): SchoolHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new SchoolHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["schoolId"] = this.schoolId;
    data["schoolName"] = this.schoolName;
    data["caServiceId"] = this.caServiceId;
    data["city"] = this.city;
    data["state"] = this.state;
    data["postcode"] = this.postcode;
    return data;
  }
}

export interface ISchoolHttpResponse {
  schoolId: number;
  schoolName: string;
  caServiceId?: number | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
}

export class ServiceHttpResponse implements IServiceHttpResponse {
  serviceId!: number;
  isOperating?: boolean | undefined;
  licensedPlaces?: number | undefined;
  primaryAddressCountry?: string | undefined;
  primaryAddressPostcode?: string | undefined;
  primaryAddressState?: string | undefined;
  primaryAddressStreet?: string | undefined;
  primaryAddressSuburb?: string | undefined;
  primaryAddressType?: string | undefined;
  serviceName?: string | undefined;
  isPrimary?: boolean | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumBookingFeeDaysForDiscount?: number | undefined;
  firstMinimumBookingsRequired?: number | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking!: number;
  minimumVacBookingFeeDaysForDiscount!: number;
  isNationalProgrammingEnabled!: boolean;

  constructor(data?: IServiceHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.isOperating = _data["isOperating"];
      this.licensedPlaces = _data["licensedPlaces"];
      this.primaryAddressCountry = _data["primaryAddressCountry"];
      this.primaryAddressPostcode = _data["primaryAddressPostcode"];
      this.primaryAddressState = _data["primaryAddressState"];
      this.primaryAddressStreet = _data["primaryAddressStreet"];
      this.primaryAddressSuburb = _data["primaryAddressSuburb"];
      this.primaryAddressType = _data["primaryAddressType"];
      this.serviceName = _data["serviceName"];
      this.isPrimary = _data["isPrimary"];
      this.phone = _data["phone"];
      this.email = _data["email"];
      this.mobile = _data["mobile"];
      this.minimumDaysToAvoidCancellationFeeRecurringBooking =
        _data["minimumDaysToAvoidCancellationFeeRecurringBooking"];
      this.minimumDaysToAvoidCancellationFeeCasualBooking = _data["minimumDaysToAvoidCancellationFeeCasualBooking"];
      this.minimumBookingFeeDaysForDiscount = _data["minimumBookingFeeDaysForDiscount"];
      this.firstMinimumBookingsRequired = _data["firstMinimumBookingsRequired"];
      this.minimumDaysToAvoidCancellationFeeVacBooking = _data["minimumDaysToAvoidCancellationFeeVacBooking"];
      this.minimumVacBookingFeeDaysForDiscount = _data["minimumVacBookingFeeDaysForDiscount"];
      this.isNationalProgrammingEnabled = _data["isNationalProgrammingEnabled"];
    }
  }

  static fromJS(data: any): ServiceHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ServiceHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["isOperating"] = this.isOperating;
    data["licensedPlaces"] = this.licensedPlaces;
    data["primaryAddressCountry"] = this.primaryAddressCountry;
    data["primaryAddressPostcode"] = this.primaryAddressPostcode;
    data["primaryAddressState"] = this.primaryAddressState;
    data["primaryAddressStreet"] = this.primaryAddressStreet;
    data["primaryAddressSuburb"] = this.primaryAddressSuburb;
    data["primaryAddressType"] = this.primaryAddressType;
    data["serviceName"] = this.serviceName;
    data["isPrimary"] = this.isPrimary;
    data["phone"] = this.phone;
    data["email"] = this.email;
    data["mobile"] = this.mobile;
    data["minimumDaysToAvoidCancellationFeeRecurringBooking"] = this.minimumDaysToAvoidCancellationFeeRecurringBooking;
    data["minimumDaysToAvoidCancellationFeeCasualBooking"] = this.minimumDaysToAvoidCancellationFeeCasualBooking;
    data["minimumBookingFeeDaysForDiscount"] = this.minimumBookingFeeDaysForDiscount;
    data["firstMinimumBookingsRequired"] = this.firstMinimumBookingsRequired;
    data["minimumDaysToAvoidCancellationFeeVacBooking"] = this.minimumDaysToAvoidCancellationFeeVacBooking;
    data["minimumVacBookingFeeDaysForDiscount"] = this.minimumVacBookingFeeDaysForDiscount;
    data["isNationalProgrammingEnabled"] = this.isNationalProgrammingEnabled;
    return data;
  }
}

export interface IServiceHttpResponse {
  serviceId: number;
  isOperating?: boolean | undefined;
  licensedPlaces?: number | undefined;
  primaryAddressCountry?: string | undefined;
  primaryAddressPostcode?: string | undefined;
  primaryAddressState?: string | undefined;
  primaryAddressStreet?: string | undefined;
  primaryAddressSuburb?: string | undefined;
  primaryAddressType?: string | undefined;
  serviceName?: string | undefined;
  isPrimary?: boolean | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  mobile?: string | undefined;
  minimumDaysToAvoidCancellationFeeRecurringBooking?: number | undefined;
  minimumDaysToAvoidCancellationFeeCasualBooking?: number | undefined;
  minimumBookingFeeDaysForDiscount?: number | undefined;
  firstMinimumBookingsRequired?: number | undefined;
  minimumDaysToAvoidCancellationFeeVacBooking: number;
  minimumVacBookingFeeDaysForDiscount: number;
  isNationalProgrammingEnabled: boolean;
}

export class GetServicesByCustomerBookingsHttpResponse implements IGetServicesByCustomerBookingsHttpResponse {
  service!: ServiceHttpResponse;
  sessions!: SessionInfo2[];

  constructor(data?: IGetServicesByCustomerBookingsHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.service = new ServiceHttpResponse();
      this.sessions = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.service = _data["service"] ? ServiceHttpResponse.fromJS(_data["service"]) : new ServiceHttpResponse();
      if (Array.isArray(_data["sessions"])) {
        this.sessions = [] as any;
        for (let item of _data["sessions"]) this.sessions!.push(SessionInfo2.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetServicesByCustomerBookingsHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetServicesByCustomerBookingsHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["service"] = this.service ? this.service.toJSON() : (undefined as any);
    if (Array.isArray(this.sessions)) {
      data["sessions"] = [];
      for (let item of this.sessions) data["sessions"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetServicesByCustomerBookingsHttpResponse {
  service: ServiceHttpResponse;
  sessions: SessionInfo2[];
}

export class SessionInfo2 implements ISessionInfo2 {
  careType!: CareType2;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;

  constructor(data?: ISessionInfo2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.careType = _data["careType"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): SessionInfo2 {
    data = typeof data === "object" ? data : {};
    let result = new SessionInfo2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["careType"] = this.careType;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    return data;
  }
}

export interface ISessionInfo2 {
  careType: CareType2;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
}

export enum CareType2 {
  LDC = "ldc",
  OCC = "occ",
  BSC = "bsc",
  ASC = "asc",
  FDC = "fdc",
  IHC = "ihc",
  VAC = "vac",
  REG = "reg",
  NZC = "nzc",
  NON = "non",
  KIN = "kin",
}

export class TermHttpResponse implements ITermHttpResponse {
  termId!: number;
  year!: number;
  termNumber!: number;
  firstDayOfTerm?: dayjs.Dayjs | undefined;
  lastDayOfTerm?: dayjs.Dayjs | undefined;

  constructor(data?: ITermHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termId = _data["termId"];
      this.year = _data["year"];
      this.termNumber = _data["termNumber"];
      this.firstDayOfTerm = _data["firstDayOfTerm"] ? dayjs(_data["firstDayOfTerm"].toString()) : (undefined as any);
      this.lastDayOfTerm = _data["lastDayOfTerm"] ? dayjs(_data["lastDayOfTerm"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): TermHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new TermHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termId"] = this.termId;
    data["year"] = this.year;
    data["termNumber"] = this.termNumber;
    data["firstDayOfTerm"] = this.firstDayOfTerm ? this.firstDayOfTerm.toISOString() : (undefined as any);
    data["lastDayOfTerm"] = this.lastDayOfTerm ? this.lastDayOfTerm.toISOString() : (undefined as any);
    return data;
  }
}

export interface ITermHttpResponse {
  termId: number;
  year: number;
  termNumber: number;
  firstDayOfTerm?: dayjs.Dayjs | undefined;
  lastDayOfTerm?: dayjs.Dayjs | undefined;
}

export class BreakHttpResponse implements IBreakHttpResponse {
  term1!: TermHttpResponse;
  term2!: TermHttpResponse;
  firstDayOfBreak?: dayjs.Dayjs | undefined;
  lastDayOfBreak?: dayjs.Dayjs | undefined;

  constructor(data?: IBreakHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.term1 = new TermHttpResponse();
      this.term2 = new TermHttpResponse();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.term1 = _data["term1"] ? TermHttpResponse.fromJS(_data["term1"]) : new TermHttpResponse();
      this.term2 = _data["term2"] ? TermHttpResponse.fromJS(_data["term2"]) : new TermHttpResponse();
      this.firstDayOfBreak = _data["firstDayOfBreak"] ? dayjs(_data["firstDayOfBreak"].toString()) : (undefined as any);
      this.lastDayOfBreak = _data["lastDayOfBreak"] ? dayjs(_data["lastDayOfBreak"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): BreakHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new BreakHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["term1"] = this.term1 ? this.term1.toJSON() : (undefined as any);
    data["term2"] = this.term2 ? this.term2.toJSON() : (undefined as any);
    data["firstDayOfBreak"] = this.firstDayOfBreak ? this.firstDayOfBreak.toISOString() : (undefined as any);
    data["lastDayOfBreak"] = this.lastDayOfBreak ? this.lastDayOfBreak.toISOString() : (undefined as any);
    return data;
  }
}

export interface IBreakHttpResponse {
  term1: TermHttpResponse;
  term2: TermHttpResponse;
  firstDayOfBreak?: dayjs.Dayjs | undefined;
  lastDayOfBreak?: dayjs.Dayjs | undefined;
}

export class SessionAvailabilityInfo implements ISessionAvailabilityInfo {
  date!: dayjs.Dayjs;
  rollId!: number;
  availableCapacity!: number;
  reasonForRecurringBooking?: SessionUnavailabilityReason | undefined;
  reasonForCasualBooking?: SessionUnavailabilityReason | undefined;
  isAvailableForRecurringBooking!: boolean;
  isAvailableForCasualBooking!: boolean;

  constructor(data?: ISessionAvailabilityInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.rollId = _data["rollId"];
      this.availableCapacity = _data["availableCapacity"];
      this.reasonForRecurringBooking = _data["reasonForRecurringBooking"];
      this.reasonForCasualBooking = _data["reasonForCasualBooking"];
      this.isAvailableForRecurringBooking = _data["isAvailableForRecurringBooking"];
      this.isAvailableForCasualBooking = _data["isAvailableForCasualBooking"];
    }
  }

  static fromJS(data: any): SessionAvailabilityInfo {
    data = typeof data === "object" ? data : {};
    let result = new SessionAvailabilityInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["rollId"] = this.rollId;
    data["availableCapacity"] = this.availableCapacity;
    data["reasonForRecurringBooking"] = this.reasonForRecurringBooking;
    data["reasonForCasualBooking"] = this.reasonForCasualBooking;
    data["isAvailableForRecurringBooking"] = this.isAvailableForRecurringBooking;
    data["isAvailableForCasualBooking"] = this.isAvailableForCasualBooking;
    return data;
  }
}

export interface ISessionAvailabilityInfo {
  date: dayjs.Dayjs;
  rollId: number;
  availableCapacity: number;
  reasonForRecurringBooking?: SessionUnavailabilityReason | undefined;
  reasonForCasualBooking?: SessionUnavailabilityReason | undefined;
  isAvailableForRecurringBooking: boolean;
  isAvailableForCasualBooking: boolean;
}

export enum SessionUnavailabilityReason {
  None = "none",
  HasDuplicateCareType = "hasDuplicateCareType",
  OverCapacity = "overCapacity",
  TooLateToBook = "tooLateToBook",
  NotAllowedCareType = "notAllowedCareType",
  SessionNotOperating = "sessionNotOperating",
  SessionNotFound = "sessionNotFound",
}

export class GetPupilFreeDaysHttpResponse implements IGetPupilFreeDaysHttpResponse {
  rollId!: number;
  date!: dayjs.Dayjs;

  constructor(data?: IGetPupilFreeDaysHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): GetPupilFreeDaysHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetPupilFreeDaysHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    return data;
  }
}

export interface IGetPupilFreeDaysHttpResponse {
  rollId: number;
  date: dayjs.Dayjs;
}

export class AppStatusHttpResponse implements IAppStatusHttpResponse {
  status!: Status;
  startDate!: dayjs.Dayjs;
  endDate?: dayjs.Dayjs | undefined;
  description?: string | undefined;

  constructor(data?: IAppStatusHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data["status"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): AppStatusHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new AppStatusHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["status"] = this.status;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.toISOString() : (undefined as any);
    data["description"] = this.description;
    return data;
  }
}

export interface IAppStatusHttpResponse {
  status: Status;
  startDate: dayjs.Dayjs;
  endDate?: dayjs.Dayjs | undefined;
  description?: string | undefined;
}

export enum Status {
  Available = "available",
  UnAvailable = "unAvailable",
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

const customTimeParser: PluginFunc = (option, dayjsClass, dayjsFactory) => {
  const proto: any = dayjsClass.prototype;
  const oldParse = proto.parse;
  proto.parse = function (cfg: any) {
    const { date } = cfg;
    if (typeof date === "string" && date && date.length === 8 && date.split(":").length === 3) {
      cfg.date = "1970-01-01T" + date;
    }
    oldParse.call(this, cfg);
  };
};

dayjs.extend(customTimeParser);
